//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (t || (e((t = { exports: {} }).exports, t, t.exports), e = null), t.exports), s = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, c = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, l = (n, r, o) => (o = n == null ? {} : e(i(n)), c(r || !n || !n.__esModule || !a.call(n, "default") ? t(o, "default", {
	value: n,
	enumerable: !0
}) : o, n)), u = {
	lang: void 0,
	message: void 0,
	abortEarly: void 0,
	abortPipeEarly: void 0
};
/* @__NO_SIDE_EFFECTS__ */
function d(e) {
	return e ? {
		lang: e?.lang ?? void 0,
		message: e?.message,
		abortEarly: e?.abortEarly ?? void 0,
		abortPipeEarly: e?.abortPipeEarly ?? void 0
	} : u;
}
/* @__NO_SIDE_EFFECTS__ */
function ee(e) {
	let t = typeof e;
	return t === "string" ? `"${e}"` : t === "number" || t === "bigint" || t === "boolean" ? `${e}` : t === "object" || t === "function" ? (e && Object.getPrototypeOf(e)?.constructor?.name) ?? "null" : t;
}
function f(e, t, n, r, i) {
	let a = i && "input" in i ? i.input : n.value, o = i?.expected ?? e.expects ?? null, s = i?.received ?? /* @__PURE__ */ ee(a), c = {
		kind: e.kind,
		type: e.type,
		input: a,
		expected: o,
		received: s,
		message: `Invalid ${t}: ${o ? `Expected ${o} but r` : "R"}eceived ${s}`,
		requirement: e.requirement,
		path: i?.path,
		issues: i?.issues,
		lang: r.lang,
		abortEarly: r.abortEarly,
		abortPipeEarly: r.abortPipeEarly
	}, l = e.kind === "schema", u = i?.message ?? e.message ?? (e.reference, c.lang, void 0) ?? (l ? (c.lang, void 0) : null) ?? r.message ?? (c.lang, void 0);
	u !== void 0 && (c.message = typeof u == "function" ? u(c) : u), l && (n.typed = !1), n.issues ? n.issues.push(c) : n.issues = [c];
}
/* @__NO_SIDE_EFFECTS__ */
function p(e, t) {
	return e === t || Number.isNaN(e) && Number.isNaN(t);
}
/* @__NO_SIDE_EFFECTS__ */
function m(e, t) {
	return Object.prototype.hasOwnProperty.call(e, t) && t !== "__proto__" && t !== "prototype" && t !== "constructor";
}
/* @__NO_SIDE_EFFECTS__ */
function te(e, t) {
	let n = [...new Set(e)];
	return n.length > 1 ? `(${n.join(` ${t} `)})` : n[0] ?? "never";
}
function h(e) {
	return e["~standard"] = {
		version: 1,
		vendor: "valibot",
		validate: (t) => e["~run"]({ value: t }, /* @__PURE__ */ d())
	}, e;
}
/* @__NO_SIDE_EFFECTS__ */
function ne(e, t) {
	let n = {};
	for (let r of e) n[r] = t;
	return n;
}
var re = class extends Error {
	constructor(e) {
		super(e[0].message), this.name = "ValiError", this.issues = e;
	}
}, ie = /^[\w+-]+(?:\.[\w+-]+)*@[\da-zA-Z]+(?:[.-][\da-zA-Z]+)*\.[a-zA-Z]{2,}$/u, ae = /^(?:[\u{1F1E6}-\u{1F1FF}]{2}|\u{1F3F4}[\u{E0061}-\u{E007A}]{2}[\u{E0030}-\u{E0039}\u{E0061}-\u{E007A}]{1,3}\u{E007F}|(?:\p{Emoji}\uFE0F\u20E3?|\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|(?![\p{Emoji_Modifier_Base}\u{1F1E6}-\u{1F1FF}])\p{Emoji_Presentation})(?:\u200D(?:\p{Emoji}\uFE0F\u20E3?|\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|(?![\p{Emoji_Modifier_Base}\u{1F1E6}-\u{1F1FF}])\p{Emoji_Presentation}))*)+$/u, oe = /^(?:(?:[1-9]|1\d|2[0-4])?\d|25[0-5])(?:\.(?:(?:[1-9]|1\d|2[0-4])?\d|25[0-5])){3}$|^(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:|(?:[\da-f]{1,4}:){1,6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,5}(?::[\da-f]{1,4}){1,2}|(?:[\da-f]{1,4}:){1,4}(?::[\da-f]{1,4}){1,3}|(?:[\da-f]{1,4}:){1,3}(?::[\da-f]{1,4}){1,4}|(?:[\da-f]{1,4}:){1,2}(?::[\da-f]{1,4}){1,5}|[\da-f]{1,4}:(?::[\da-f]{1,4}){1,6}|:(?:(?::[\da-f]{1,4}){1,7}|:)|fe80:(?::[\da-f]{0,4}){0,4}%[\da-z]+|::(?:f{4}(?::0{1,4})?:)?(?:(?:25[0-5]|(?:2[0-4]|1?\d)?\d)\.){3}(?:25[0-5]|(?:2[0-4]|1?\d)?\d)|(?:[\da-f]{1,4}:){1,4}:(?:(?:25[0-5]|(?:2[0-4]|1?\d)?\d)\.){3}(?:25[0-5]|(?:2[0-4]|1?\d)?\d))$/iu, se = /^\d{4}-(?:0[1-9]|1[0-2])-(?:[12]\d|0[1-9]|3[01])$/u;
/* @__NO_SIDE_EFFECTS__ */
function ce(e, t) {
	return {
		kind: "validation",
		type: "check",
		reference: ce,
		async: !1,
		expects: null,
		requirement: e,
		message: t,
		"~run"(e, t) {
			return e.typed && !this.requirement(e.value) && f(this, "input", e, t), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function le(e) {
	return {
		kind: "validation",
		type: "email",
		reference: le,
		expects: null,
		async: !1,
		requirement: ie,
		message: e,
		"~run"(e, t) {
			return e.typed && !this.requirement.test(e.value) && f(this, "email", e, t), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function ue(e) {
	return {
		kind: "validation",
		type: "emoji",
		reference: ue,
		async: !1,
		expects: null,
		requirement: ae,
		message: e,
		"~run"(e, t) {
			return e.typed && !this.requirement.test(e.value) && f(this, "emoji", e, t), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function de(e) {
	return {
		kind: "validation",
		type: "integer",
		reference: de,
		async: !1,
		expects: null,
		requirement: Number.isInteger,
		message: e,
		"~run"(e, t) {
			return e.typed && !this.requirement(e.value) && f(this, "integer", e, t), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function fe(e) {
	return {
		kind: "validation",
		type: "ip",
		reference: fe,
		async: !1,
		expects: null,
		requirement: oe,
		message: e,
		"~run"(e, t) {
			return e.typed && !this.requirement.test(e.value) && f(this, "IP", e, t), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function pe(e) {
	return {
		kind: "validation",
		type: "iso_date",
		reference: pe,
		async: !1,
		expects: null,
		requirement: se,
		message: e,
		"~run"(e, t) {
			return e.typed && !this.requirement.test(e.value) && f(this, "date", e, t), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function me(e, t) {
	return {
		kind: "validation",
		type: "max_value",
		reference: me,
		async: !1,
		expects: `<=${e instanceof Date ? e.toJSON() : /* @__PURE__ */ ee(e)}`,
		requirement: e,
		message: t,
		"~run"(e, t) {
			return e.typed && !(e.value <= this.requirement) && f(this, "value", e, t, { received: e.value instanceof Date ? e.value.toJSON() : /* @__PURE__ */ ee(e.value) }), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function he(e, t) {
	return {
		kind: "validation",
		type: "min_length",
		reference: he,
		async: !1,
		expects: `>=${e}`,
		requirement: e,
		message: t,
		"~run"(e, t) {
			return e.typed && e.value.length < this.requirement && f(this, "length", e, t, { received: `${e.value.length}` }), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function ge(e, t) {
	return {
		kind: "validation",
		type: "min_value",
		reference: ge,
		async: !1,
		expects: `>=${e instanceof Date ? e.toJSON() : /* @__PURE__ */ ee(e)}`,
		requirement: e,
		message: t,
		"~run"(e, t) {
			return e.typed && !(e.value >= this.requirement) && f(this, "value", e, t, { received: e.value instanceof Date ? e.value.toJSON() : /* @__PURE__ */ ee(e.value) }), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function _e() {
	return {
		kind: "transformation",
		type: "readonly",
		reference: _e,
		async: !1,
		"~run"(e) {
			return e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function ve(e, t) {
	return {
		kind: "validation",
		type: "regex",
		reference: ve,
		async: !1,
		expects: `${e}`,
		requirement: e,
		message: t,
		"~run"(e, t) {
			return e.typed && !this.requirement.test(e.value) && f(this, "format", e, t), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function g(e) {
	return {
		kind: "transformation",
		type: "transform",
		reference: g,
		async: !1,
		operation: e,
		"~run"(e) {
			return e.value = this.operation(e.value), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function _(e) {
	return {
		kind: "validation",
		type: "url",
		reference: _,
		async: !1,
		expects: null,
		requirement(e) {
			try {
				return URL.canParse ? URL.canParse(e) : (new URL(e), !0);
			} catch {
				return !1;
			}
		},
		message: e,
		"~run"(e, t) {
			return e.typed && !this.requirement(e.value) && f(this, "URL", e, t), e;
		}
	};
}
var ye = { abortEarly: !0 };
/* @__NO_SIDE_EFFECTS__ */
function be(e, t, n) {
	return typeof e.fallback == "function" ? e.fallback(t, n) : e.fallback;
}
/* @__NO_SIDE_EFFECTS__ */
function v(e, t) {
	return h({
		...e,
		fallback: t,
		"~run"(t, n) {
			let r = e["~run"](t, n);
			return r.issues ? {
				typed: !0,
				value: /* @__PURE__ */ be(this, r, n)
			} : r;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function xe(e, t, n) {
	return typeof e.default == "function" ? e.default(t, n) : e.default;
}
/* @__NO_SIDE_EFFECTS__ */
function y() {
	return h({
		kind: "schema",
		type: "any",
		reference: y,
		expects: "any",
		async: !1,
		"~run"(e) {
			return e.typed = !0, e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function b(e, t) {
	return h({
		kind: "schema",
		type: "array",
		reference: b,
		expects: "Array",
		async: !1,
		item: e,
		message: t,
		"~run"(e, t) {
			let n = e.value;
			if (Array.isArray(n)) {
				e.typed = !0, e.value = [];
				for (let r = 0; r < n.length; r++) {
					let i = n[r], a = this.item["~run"]({ value: i }, t);
					if (a.issues) {
						let o = {
							type: "array",
							origin: "value",
							input: n,
							key: r,
							value: i
						};
						for (let t of a.issues) t.path ? t.path.unshift(o) : t.path = [o], e.issues?.push(t);
						if (e.issues ||= a.issues, t.abortEarly) {
							e.typed = !1;
							break;
						}
					}
					a.typed || (e.typed = !1), e.value.push(a.value);
				}
			} else f(this, "type", e, t);
			return e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function x(e) {
	return h({
		kind: "schema",
		type: "boolean",
		reference: x,
		expects: "boolean",
		async: !1,
		message: e,
		"~run"(e, t) {
			return typeof e.value == "boolean" ? e.typed = !0 : f(this, "type", e, t), e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Se(e, t) {
	let n = [];
	for (let t in e) (`${+t}` !== t || typeof e[t] != "string" || !Object.is(e[e[t]], +t)) && n.push(e[t]);
	return h({
		kind: "schema",
		type: "enum",
		reference: Se,
		expects: /* @__PURE__ */ te(n.map(ee), "|"),
		async: !1,
		enum: e,
		options: n,
		message: t,
		"~run"(e, t) {
			return this.options.includes(e.value) ? e.typed = !0 : f(this, "type", e, t), e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ce(e, t) {
	if (typeof e == typeof t) {
		if (/* @__PURE__ */ p(e, t) || e instanceof Date && t instanceof Date && /* @__PURE__ */ p(+e, +t)) return { value: e };
		if (e && t && e.constructor === Object && t.constructor === Object) {
			let n = {
				...e,
				...t
			};
			for (let r in t) if (Object.prototype.hasOwnProperty.call(e, r) && Object.prototype.hasOwnProperty.call(t, r)) {
				let i = /* @__PURE__ */ Ce(e[r], t[r]);
				if (i.issue) return i;
				n[r] = i.value;
			}
			return { value: n };
		}
		if (Array.isArray(e) && Array.isArray(t) && e.length === t.length) {
			let n = [...e];
			for (let r = 0; r < e.length; r++) {
				let i = /* @__PURE__ */ Ce(e[r], t[r]);
				if (i.issue) return i;
				n[r] = i.value;
			}
			return { value: n };
		}
	}
	return { issue: !0 };
}
/* @__NO_SIDE_EFFECTS__ */
function we(e, t) {
	return h({
		kind: "schema",
		type: "intersect",
		reference: we,
		expects: /* @__PURE__ */ te(e.map((e) => e.expects), "&"),
		async: !1,
		options: e,
		message: t,
		"~run"(e, t) {
			if (this.options.length) {
				let n = e.value, r;
				e.typed = !0;
				for (let i of this.options) {
					let a = i["~run"]({ value: n }, t);
					if (a.issues) {
						if (e.issues) for (let t of a.issues) e.issues.push(t);
						else e.issues = a.issues;
						if (t.abortEarly) {
							e.typed = !1;
							break;
						}
					}
					a.typed || (e.typed = !1), e.typed && (r ? r.push(a.value) : r = [a.value]);
				}
				if (e.typed) {
					e.value = r[0];
					for (let n = 1; n < r.length; n++) {
						let i = /* @__PURE__ */ Ce(e.value, r[n]);
						if (i.issue) {
							f(this, "type", e, t, { received: "unknown" });
							break;
						}
						e.value = i.value;
					}
				}
			} else f(this, "type", e, t);
			return e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Te(e) {
	return h({
		kind: "schema",
		type: "lazy",
		reference: Te,
		expects: "unknown",
		async: !1,
		getter: e,
		"~run"(e, t) {
			return this.getter(e.value)["~run"](e, t);
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function S(e, t) {
	return h({
		kind: "schema",
		type: "literal",
		reference: S,
		expects: /* @__PURE__ */ ee(e),
		async: !1,
		literal: e,
		message: t,
		"~run"(e, t) {
			return /* @__PURE__ */ p(e.value, this.literal) ? e.typed = !0 : f(this, "type", e, t), e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ee(e, t) {
	return h({
		kind: "schema",
		type: "loose_object",
		reference: Ee,
		expects: "Object",
		async: !1,
		entries: e,
		message: t,
		"~run"(e, t) {
			let n = e.value;
			if (n && typeof n == "object") {
				e.typed = !0, e.value = {};
				for (let r in this.entries) {
					let i = this.entries[r];
					if (r in n || (i.type === "exact_optional" || i.type === "optional" || i.type === "nullish") && i.default !== void 0) {
						let a = r in n ? n[r] : /* @__PURE__ */ xe(i), o = i["~run"]({ value: a }, t);
						if (o.issues) {
							let i = {
								type: "object",
								origin: "value",
								input: n,
								key: r,
								value: a
							};
							for (let t of o.issues) t.path ? t.path.unshift(i) : t.path = [i], e.issues?.push(t);
							if (e.issues ||= o.issues, t.abortEarly) {
								e.typed = !1;
								break;
							}
						}
						o.typed || (e.typed = !1), e.value[r] = o.value;
					} else if (i.fallback !== void 0) e.value[r] = /* @__PURE__ */ be(i);
					else if (i.type !== "exact_optional" && i.type !== "optional" && i.type !== "nullish" && (f(this, "key", e, t, {
						input: void 0,
						expected: `"${r}"`,
						path: [{
							type: "object",
							origin: "key",
							input: n,
							key: r,
							value: n[r]
						}]
					}), t.abortEarly)) break;
				}
				if (!e.issues || !t.abortEarly) for (let t in n) /* @__PURE__ */ m(n, t) && !Object.prototype.hasOwnProperty.call(this.entries, t) && (e.value[t] = n[t]);
			} else f(this, "type", e, t);
			return e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function De(e) {
	return h({
		kind: "schema",
		type: "null",
		reference: De,
		expects: "null",
		async: !1,
		message: e,
		"~run"(e, t) {
			return e.value === null ? e.typed = !0 : f(this, "type", e, t), e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function C(e, t) {
	return h({
		kind: "schema",
		type: "nullable",
		reference: C,
		expects: `(${e.expects} | null)`,
		async: !1,
		wrapped: e,
		default: t,
		"~run"(e, t) {
			return e.value === null && (this.default !== void 0 && (e.value = /* @__PURE__ */ xe(this, e, t)), e.value === null) ? (e.typed = !0, e) : this.wrapped["~run"](e, t);
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function w(e) {
	return h({
		kind: "schema",
		type: "number",
		reference: w,
		expects: "number",
		async: !1,
		message: e,
		"~run"(e, t) {
			return typeof e.value == "number" && !isNaN(e.value) ? e.typed = !0 : f(this, "type", e, t), e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function T(e, t) {
	return h({
		kind: "schema",
		type: "object",
		reference: T,
		expects: "Object",
		async: !1,
		entries: e,
		message: t,
		"~run"(e, t) {
			let n = e.value;
			if (n && typeof n == "object") {
				e.typed = !0, e.value = {};
				for (let r in this.entries) {
					let i = this.entries[r];
					if (r in n || (i.type === "exact_optional" || i.type === "optional" || i.type === "nullish") && i.default !== void 0) {
						let a = r in n ? n[r] : /* @__PURE__ */ xe(i), o = i["~run"]({ value: a }, t);
						if (o.issues) {
							let i = {
								type: "object",
								origin: "value",
								input: n,
								key: r,
								value: a
							};
							for (let t of o.issues) t.path ? t.path.unshift(i) : t.path = [i], e.issues?.push(t);
							if (e.issues ||= o.issues, t.abortEarly) {
								e.typed = !1;
								break;
							}
						}
						o.typed || (e.typed = !1), e.value[r] = o.value;
					} else if (i.fallback !== void 0) e.value[r] = /* @__PURE__ */ be(i);
					else if (i.type !== "exact_optional" && i.type !== "optional" && i.type !== "nullish" && (f(this, "key", e, t, {
						input: void 0,
						expected: `"${r}"`,
						path: [{
							type: "object",
							origin: "key",
							input: n,
							key: r,
							value: n[r]
						}]
					}), t.abortEarly)) break;
				}
			} else f(this, "type", e, t);
			return e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function E(e, t) {
	return h({
		kind: "schema",
		type: "optional",
		reference: E,
		expects: `(${e.expects} | undefined)`,
		async: !1,
		wrapped: e,
		default: t,
		"~run"(e, t) {
			return e.value === void 0 && (this.default !== void 0 && (e.value = /* @__PURE__ */ xe(this, e, t)), e.value === void 0) ? (e.typed = !0, e) : this.wrapped["~run"](e, t);
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function D(e, t) {
	return h({
		kind: "schema",
		type: "picklist",
		reference: D,
		expects: /* @__PURE__ */ te(e.map(ee), "|"),
		async: !1,
		options: e,
		message: t,
		"~run"(e, t) {
			return this.options.includes(e.value) ? e.typed = !0 : f(this, "type", e, t), e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function O(e, t, n) {
	return h({
		kind: "schema",
		type: "record",
		reference: O,
		expects: "Object",
		async: !1,
		key: e,
		value: t,
		message: n,
		"~run"(e, t) {
			let n = e.value;
			if (n && typeof n == "object") {
				e.typed = !0, e.value = {};
				for (let r in n) if (/* @__PURE__ */ m(n, r)) {
					let i = n[r], a = this.key["~run"]({ value: r }, t);
					if (a.issues) {
						let o = {
							type: "object",
							origin: "key",
							input: n,
							key: r,
							value: i
						};
						for (let t of a.issues) t.path = [o], e.issues?.push(t);
						if (e.issues ||= a.issues, t.abortEarly) {
							e.typed = !1;
							break;
						}
					}
					let o = this.value["~run"]({ value: i }, t);
					if (o.issues) {
						let a = {
							type: "object",
							origin: "value",
							input: n,
							key: r,
							value: i
						};
						for (let t of o.issues) t.path ? t.path.unshift(a) : t.path = [a], e.issues?.push(t);
						if (e.issues ||= o.issues, t.abortEarly) {
							e.typed = !1;
							break;
						}
					}
					(!a.typed || !o.typed) && (e.typed = !1), a.typed && (e.value[a.value] = o.value);
				}
			} else f(this, "type", e, t);
			return e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function k(e) {
	return h({
		kind: "schema",
		type: "string",
		reference: k,
		expects: "string",
		async: !1,
		message: e,
		"~run"(e, t) {
			return typeof e.value == "string" ? e.typed = !0 : f(this, "type", e, t), e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Oe(e, t) {
	return h({
		kind: "schema",
		type: "tuple",
		reference: Oe,
		expects: "Array",
		async: !1,
		items: e,
		message: t,
		"~run"(e, t) {
			let n = e.value;
			if (Array.isArray(n)) {
				e.typed = !0, e.value = [];
				for (let r = 0; r < this.items.length; r++) {
					let i = n[r], a = this.items[r]["~run"]({ value: i }, t);
					if (a.issues) {
						let o = {
							type: "array",
							origin: "value",
							input: n,
							key: r,
							value: i
						};
						for (let t of a.issues) t.path ? t.path.unshift(o) : t.path = [o], e.issues?.push(t);
						if (e.issues ||= a.issues, t.abortEarly) {
							e.typed = !1;
							break;
						}
					}
					a.typed || (e.typed = !1), e.value.push(a.value);
				}
			} else f(this, "type", e, t);
			return e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function ke(e) {
	return h({
		kind: "schema",
		type: "undefined",
		reference: ke,
		expects: "undefined",
		async: !1,
		message: e,
		"~run"(e, t) {
			return e.value === void 0 ? e.typed = !0 : f(this, "type", e, t), e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ae(e) {
	let t;
	if (e) for (let n of e) if (t) for (let e of n.issues) t.push(e);
	else t = n.issues;
	return t;
}
/* @__NO_SIDE_EFFECTS__ */
function je(e, t) {
	return h({
		kind: "schema",
		type: "union",
		reference: je,
		expects: /* @__PURE__ */ te(e.map((e) => e.expects), "|"),
		async: !1,
		options: e,
		message: t,
		"~run"(e, t) {
			let n, r, i;
			for (let a of this.options) {
				let o = a["~run"]({ value: e.value }, t);
				if (o.typed) {
					if (o.issues) r ? r.push(o) : r = [o];
					else {
						n = o;
						break;
					}
				} else i ? i.push(o) : i = [o];
			}
			if (n) return n;
			if (r) {
				if (r.length === 1) return r[0];
				f(this, "type", e, t, { issues: /* @__PURE__ */ Ae(r) }), e.typed = !0;
			} else if (i?.length === 1) return i[0];
			else f(this, "type", e, t, { issues: /* @__PURE__ */ Ae(i) });
			return e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function A() {
	return h({
		kind: "schema",
		type: "unknown",
		reference: A,
		expects: "unknown",
		async: !1,
		"~run"(e) {
			return e.typed = !0, e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Me(e, t, n) {
	return h({
		kind: "schema",
		type: "variant",
		reference: Me,
		expects: "Object",
		async: !1,
		key: e,
		options: t,
		message: n,
		"~run"(e, t) {
			let n = e.value;
			if (n && typeof n == "object") {
				let r, i = 0, a = this.key, o = [], s = (e, c) => {
					for (let l of e.options) {
						if (l.type === "variant") s(l, new Set(c).add(l.key));
						else {
							let e = !0, s = 0;
							for (let t of c) {
								let r = l.entries[t];
								if (t in n ? r["~run"]({
									typed: !1,
									value: n[t]
								}, ye).issues : r.type !== "exact_optional" && r.type !== "optional" && r.type !== "nullish") {
									e = !1, a !== t && (i < s || i === s && t in n && !(a in n)) && (i = s, a = t, o = []), a === t && o.push(l.entries[t].expects);
									break;
								}
								s++;
							}
							if (e) {
								let e = l["~run"]({ value: n }, t);
								(!r || !r.typed && e.typed) && (r = e);
							}
						}
						if (r && !r.issues) break;
					}
				};
				if (s(this, /* @__PURE__ */ new Set([this.key])), r) return r;
				f(this, "type", e, t, {
					input: n[a],
					expected: /* @__PURE__ */ te(o, "|"),
					path: [{
						type: "object",
						origin: "value",
						input: n,
						key: a,
						value: n[a]
					}]
				});
			} else f(this, "type", e, t);
			return e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ne(e, t) {
	let n = { ...e.entries };
	for (let e of t) delete n[e];
	return h({
		...e,
		entries: n
	});
}
function j(e, t, n) {
	let r = e["~run"]({ value: t }, /* @__PURE__ */ d(n));
	if (r.issues) throw new re(r.issues);
	return r.value;
}
/* @__NO_SIDE_EFFECTS__ */
function Pe(e, t) {
	let n = {};
	for (let r in e.entries) n[r] = !t || t.includes(r) ? /* @__PURE__ */ E(e.entries[r]) : e.entries[r];
	return h({
		...e,
		entries: n
	});
}
/* @__NO_SIDE_EFFECTS__ */
function M(...e) {
	return h({
		...e[0],
		pipe: e,
		"~run"(t, n) {
			for (let r of e) if (r.kind !== "metadata") {
				if (t.issues && (r.kind === "schema" || r.kind === "transformation")) {
					t.typed = !1;
					break;
				}
				(!t.issues || !n.abortEarly && !n.abortPipeEarly) && (t = r["~run"](t, n));
			}
			return t;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Fe(e, t, n) {
	let r = e["~run"]({ value: t }, /* @__PURE__ */ d(n));
	return {
		typed: r.typed,
		success: !r.issues,
		output: r.value,
		issues: r.issues
	};
}
//#endregion
//#region lib/utils/index.ts
var Ie = (e, t) => {
	let n = {};
	for (let r of t) r in e && (n[r] = e[r]);
	return n;
}, Le = (e, t) => {
	let n = { ...e };
	for (let e of t) delete n[e];
	return n;
}, Re = [
	"/assets/default_header.webp",
	"/headers/original/missing.png",
	"/api/v1/accounts/identicon",
	/\/static\/img\/missing\.[a-z0-9]+\.png$/,
	"/storage/headers/missing.png",
	"/images/banner.png",
	"/assets/transparent.png"
], ze = (e = "") => e === "" || Re.some((t) => typeof t == "string" ? e.endsWith(t) : t.test(e)), Be = [
	/\/assets\/default_avatars\/GoToSocial_icon[1-6]\.webp$/,
	"/avatars/original/missing.png",
	/\/identicon\/[a-z0-9]{16}$/,
	"/api/v1/accounts/identicon",
	"/s/img/avatar.svg",
	"/avatars/default.jpg",
	"/images/avi.png"
], Ve = (e = "") => e === "" || Be.some((t) => typeof t == "string" ? e.endsWith(t) : t.test(e)), He = (e) => {
	try {
		let t = e.url;
		return new URL(t).host;
	} catch {
		return "";
	}
}, Ue = (e) => {
	let t = e.acct, [n, r] = t.split("@");
	return r ? t : [n, He(e)].join("@");
}, We = /* @__PURE__ */ T({
	shortcode: /* @__PURE__ */ k(),
	url: /* @__PURE__ */ k(),
	static_url: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	visible_in_picker: /* @__PURE__ */ v(/* @__PURE__ */ x(), !0),
	category: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
}), N = /* @__PURE__ */ T({
	blocked_by: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	blocking: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	domain_blocking: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	endorsed: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	followed_by: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	following: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	id: /* @__PURE__ */ k(),
	muting: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	muting_notifications: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	note: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	notifying: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	notifying_reblogs: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	notifying_replies: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	requested: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	requested_by: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	showing_reblogs: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	languages: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ b(/* @__PURE__ */ k())), null)
}), Ge = /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	color: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ ve(/^#[a-f0-9]{6}$/i)), ""),
	permissions: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	highlighted: /* @__PURE__ */ v(/* @__PURE__ */ x(), !0),
	collection_limit: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0)
}), P = /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ ve(/^\d{4}-\d{2}-\d{2}T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d+)?(([+-]\d{2}:?\d{2})|(Z)?)$/)), Ke = /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ g((e) => e.slice(0, 10)), /* @__PURE__ */ ve(/^\d{4}-\d{2}-\d{2}$/)), F = (e) => /* @__PURE__ */ M(/* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ y()), []), /* @__PURE__ */ g((t) => (t || []).map((t) => {
	let n = /* @__PURE__ */ Fe(e, t);
	return n.success ? n.output : void 0;
}).filter((e) => !!e))), qe = /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ g((e) => e === "❤" ? "❤️" : e), /* @__PURE__ */ ue()), Je = /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ ve(/^\w+\/[-+.\w]+$/)), I = (e) => /* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => typeof e == "object" && !Array.isArray(e) && e !== null ? e : {}), /* @__PURE__ */ T(e)), {}), Ye = (e) => e?.filter((e) => e.startsWith("badge:")).map((e) => j(Ge, {
	id: e,
	name: e.replace(/^badge:/, "")
})), Xe = [
	"https://pl.fediverse.pl/users/mkljczk",
	"https://gts.mkljczk.pl/users/mkljczk",
	"https://gts.mkljczk.pl/@mkljczk",
	"https://twojstary.gay/users/a8hjg35etyprng8m",
	"https://twojstary.gay/@mkljczk"
], Ze = /* @__PURE__ */ Me("type", [/* @__PURE__ */ T({
	type: /* @__PURE__ */ S("link"),
	name: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	href: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	object_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
}), /* @__PURE__ */ T({
	type: /* @__PURE__ */ S("monero-subscription"),
	chain_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	price: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	amount_min: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	object_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
})]), Qe = /* @__PURE__ */ g((e) => {
	if (!e?.acct) return null;
	let t = e.username || e.acct.split("@")[0], n = e.fqn || Ue(e), r = n.split("@")[1] || "", i = (e.pleroma?.is_cat ?? e.is_cat) || Xe.includes(e.uri ?? e.url), a = e.pleroma?.speak_as_cat ?? e.speak_as_cat ?? i;
	return {
		username: t,
		fqn: n,
		domain: r,
		avatar: e.avatar || e.avatar_static,
		header: e.header || e.header_static,
		avatar_default: Ve(e.avatar || e.avatar_static || ""),
		header_default: ze(e.header || e.header_static || ""),
		local: typeof e.pleroma?.is_local == "boolean" ? e.pleroma.is_local : e.acct.split("@")[1] === void 0,
		discoverable: e.discoverable || e.pleroma?.source?.discoverable,
		verified: e.verified || e.pleroma?.tags?.includes("verified"),
		...e.role?.permissions ? { is_admin: (e.role?.permissions & 1) == 1 } : {},
		ap_id: e.pleroma?.ap_id ?? e.actor_id,
		...Ie(e.pleroma || {}, [
			"background_image",
			"relationship",
			"is_moderator",
			"is_admin",
			"privileges",
			"hide_favorites",
			"hide_followers",
			"hide_follows",
			"hide_followers_count",
			"hide_follows_count",
			"accepts_chat_messages",
			"favicon",
			"birthday",
			"deactivated",
			"avatar_description",
			"header_description",
			"settings_store",
			"chat_token",
			"allow_following_move",
			"unread_conversation_count",
			"unread_notifications_count",
			"notification_settings",
			"location"
		]),
		...Ie(e.akkoma || {}, ["permit_followback"]),
		is_cat: i,
		speak_as_cat: a,
		...Ie(e.other_settings || {}, ["birthday", "location"]),
		__meta: Ie(e, ["pleroma", "source"]),
		...e,
		display_name: e.display_name?.replace(/^[\s\u180E\u200B-\u200D\u2060\uFEFF]+|[\s\u180E\u200B-\u200D\u2060\uFEFF]+$/g, "").trim() || t,
		roles: e.roles?.length ? e.roles : Ye(e.pleroma?.tags),
		source: e.source ? {
			...Ie(e.pleroma?.source || {}, [
				"show_role",
				"no_rich_text",
				"discoverable",
				"actor_type",
				"show_birthday"
			]),
			...e.source
		} : void 0
	};
}), $e = /* @__PURE__ */ T({
	name: /* @__PURE__ */ k(),
	value: /* @__PURE__ */ k(),
	verified_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null)
}), et = /* @__PURE__ */ T({
	automatic: /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ D([
		"public",
		"followers",
		"following",
		"unsupported_policy"
	])), []),
	manual: /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ D([
		"public",
		"followers",
		"following",
		"unsupported_policy"
	])), []),
	current_user: /* @__PURE__ */ v(/* @__PURE__ */ D([
		"automatic",
		"manual",
		"denied",
		"missing",
		"unknown"
	]), "unknown")
}), tt = /* @__PURE__ */ T({
	...(/* @__PURE__ */ T({
		id: /* @__PURE__ */ k(),
		username: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		acct: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		url: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()),
		display_name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		note: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ g((e) => e === "<p></p>" ? "" : e)), ""),
		avatar: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		avatar_static: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
		header: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
		header_static: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
		locked: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		fields: F($e),
		emojis: F(We),
		bot: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		group: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		discoverable: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		indexable: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ x()), null),
		noindex: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ x()), null),
		memorial: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ x()), null),
		suspended: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		limited: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		created_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString()),
		last_status_at: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ pe())), null),
		statuses_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
		followers_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
		following_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
		roles: F(Ge),
		hide_collections: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		email_subscriptions: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		feature_approval: /* @__PURE__ */ v(/* @__PURE__ */ E(et), void 0),
		fqn: /* @__PURE__ */ k(),
		ap_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		background_image: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		relationship: /* @__PURE__ */ v(/* @__PURE__ */ E(N), void 0),
		is_moderator: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		is_admin: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		privileges: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ b(/* @__PURE__ */ k())), void 0),
		is_suggested: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		hide_favorites: /* @__PURE__ */ v(/* @__PURE__ */ x(), !0),
		hide_followers: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		hide_follows: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		hide_followers_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		hide_follows_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		accepts_chat_messages: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ x()), null),
		favicon: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
		birthday: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ pe())), void 0),
		deactivated: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		location: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
		local: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), !1),
		permit_followback: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		avatar_description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		custom_css: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		enable_rss: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		header_description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		verified: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		domain: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		pronouns: /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ k()), []),
		bite_controls: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ D([
			"public",
			"followers",
			"none"
		])), void 0),
		can_bite: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		mention_policy: /* @__PURE__ */ v(/* @__PURE__ */ D([
			"none",
			"only_known",
			"only_contacts"
		]), "none"),
		subscribers_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
		identity_proofs: F(/* @__PURE__ */ T({
			name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
			value: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
			verified_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString())
		})),
		payment_options: F(Ze),
		is_cat: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		speak_as_cat: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		__meta: I({
			pleroma: /* @__PURE__ */ E(/* @__PURE__ */ y(), void 0),
			source: /* @__PURE__ */ E(/* @__PURE__ */ y(), void 0)
		}),
		avatar_default: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		header_default: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
	})).entries,
	moved: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ Te(() => tt)), null)
}), L = /* @__PURE__ */ M(/* @__PURE__ */ y(), Qe, tt), nt = /* @__PURE__ */ M(/* @__PURE__ */ y(), Qe, /* @__PURE__ */ T({
	...tt.entries,
	source: /* @__PURE__ */ v(/* @__PURE__ */ C(I({
		attribution_domains: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ C(/* @__PURE__ */ b(/* @__PURE__ */ k()))), null),
		note: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), ""),
		fields: /* @__PURE__ */ v(/* @__PURE__ */ E(F($e)), []),
		privacy: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ D([
			"public",
			"unlisted",
			"private",
			"direct"
		])), "public"),
		sensitive: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), !1),
		language: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ C(/* @__PURE__ */ k())), null),
		follow_requests_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de(), /* @__PURE__ */ ge(0))), void 0),
		hide_collections: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		discoverable: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		indexable: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ x()), null),
		quote_policy: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ D([
			"public",
			"followers",
			"nobody"
		])), null),
		show_role: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ C(/* @__PURE__ */ x())), void 0),
		no_rich_text: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ C(/* @__PURE__ */ x())), void 0),
		actor_type: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
		show_birthday: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		also_known_as_uris: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ b(/* @__PURE__ */ k())), void 0),
		status_content_type: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
		web_include_boosts: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
		web_layout: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ D(["microblog", "gallery"])), void 0),
		web_visibility: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ D([
			"public",
			"unlisted",
			"none"
		])), void 0),
		blocks_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de(), /* @__PURE__ */ ge(0))), void 0),
		outgoing_follow_requests_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de(), /* @__PURE__ */ ge(0))), void 0)
	})), null),
	role: /* @__PURE__ */ v(/* @__PURE__ */ C(Ge), null),
	settings_store: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ y())), void 0),
	chat_token: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	allow_following_move: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	unread_conversation_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	unread_notifications_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	notification_settings: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ T({
		block_from_strangers: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		hide_notification_contents: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
	})), void 0)
})), rt = /* @__PURE__ */ M(/* @__PURE__ */ y(), Qe, /* @__PURE__ */ T({
	...tt.entries,
	block_expires_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null)
})), it = /* @__PURE__ */ M(/* @__PURE__ */ y(), Qe, /* @__PURE__ */ T({
	...tt.entries,
	mute_expires_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null)
})), at = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	...e,
	hint: e.hint || e.subtext
})), /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	text: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	hint: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	translations: /* @__PURE__ */ E(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ T({
		text: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		hint: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
	})), void 0)
})), ot = /^([0-9.]*) \(not true; really snac\/([\w.]*)\)/, st = /^WordPress\/[\w+.-]*, EMA\/([\w+.-]*)/, ct = (e) => ({
	...Object.fromEntries(e.pleroma?.metadata?.features?.map((e) => {
		let t = `${e}.pleroma.pl-api`;
		return (t.startsWith("pleroma:") || t.startsWith("pleroma_")) && (t = t.slice(8)), t.startsWith("akkoma:") && (t = t.slice(7)), t.startsWith("pl:") && (t = t.slice(3)), [t, 1];
	}) || []),
	...Object.fromEntries(e.fedibird_capabilities?.map((e) => [`${e}.fedibird.pl-api`, 1]) || []),
	...e.api_versions
}), lt = (e) => {
	let { approval_required: t, configuration: n, contact_account: r, description: i, description_limit: a, email: o, max_media_attachments: s, max_toot_chars: c, poll_limits: l, pleroma: u, registrations: d, short_description: ee, thumbnail: f, upload_limit: p, uri: m, urls: te, ...h } = j(bt, e), ne = m;
	try {
		ne = new URL(m).host;
	} catch {}
	return {
		...h,
		account_domain: h.account_domain || m,
		configuration: {
			...n,
			media_attachments: {
				...n.media_attachments,
				image_size_limit: p ?? n.media_attachments.image_size_limit,
				video_size_limit: p ?? n.media_attachments.video_size_limit
			},
			polls: {
				...n.polls,
				max_characters_per_option: l.max_option_chars ?? n.polls.max_characters_per_option,
				max_expiration: l.max_expiration ?? n.polls.max_expiration,
				max_options: l.max_options ?? n.polls.max_options,
				min_expiration: l.min_expiration ?? n.polls.min_expiration
			},
			statuses: {
				...n.statuses,
				max_characters: c ?? n.statuses.max_characters,
				max_media_attachments: s ?? n.statuses.max_media_attachments
			},
			urls: { streaming: te.streaming_api },
			vapid: { public_key: u.vapid_public_key }
		},
		contact: {
			account: r,
			email: o
		},
		description: ee || i,
		domain: ne,
		pleroma: {
			...u,
			metadata: {
				...u.metadata,
				description_limit: a
			}
		},
		registrations: {
			approval_required: t,
			enabled: d
		},
		thumbnail: { url: f },
		usage: {
			...h.usage,
			users: {
				...h.usage.users,
				active_month: u.stats.mau ?? h.usage.users.active_month
			}
		}
	};
}, ut = [
	["takahe", "Takahe"],
	["neodb", "NeoDB"],
	["egregoros", "Egregoros"]
], dt = (e) => {
	if ((/* @__PURE__ */ new RegExp(/[0-9.]+rc[0-9]+/g)).test(e)) return e.split("rc").join("-rc");
	for (let [t, n] of ut) if (e.startsWith(`${t}/`)) return `0.0.0 (compatible; ${n} ${e.slice(t.length + 1)})`;
	let t = st.exec(e);
	if (t) return `0.0.0 (compatible; WordPress ${t[1]})`;
	let n = ot.exec(e);
	return n ? `${n[1]} (compatible; snac ${n[2]})` : e;
}, ft = I({
	accounts: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ T({
		allow_custom_css: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		max_display_name_length: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		max_note_length: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		max_avatar_description_length: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		max_header_description_length: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		max_featured_tags: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		max_pinned_statuses: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		max_profile_fields: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		profile_field_name_limit: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		profile_field_value_limit: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0)
	})), null),
	chats: I({ max_characters: /* @__PURE__ */ v(/* @__PURE__ */ w(), 5e3) }),
	groups: I({
		max_characters_description: /* @__PURE__ */ v(/* @__PURE__ */ w(), 160),
		max_characters_name: /* @__PURE__ */ v(/* @__PURE__ */ w(), 50)
	}),
	media_attachments: I({
		image_matrix_limit: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		image_size_limit: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		supported_mime_types: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ b(Je)), void 0),
		video_duration_limit: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		video_frame_rate_limit: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		video_matrix_limit: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		video_size_limit: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0)
	}),
	polls: I({
		max_characters_per_option: /* @__PURE__ */ v(/* @__PURE__ */ w(), 25),
		max_expiration: /* @__PURE__ */ v(/* @__PURE__ */ w(), 2629746),
		max_options: /* @__PURE__ */ v(/* @__PURE__ */ w(), 4),
		min_expiration: /* @__PURE__ */ v(/* @__PURE__ */ w(), 300)
	}),
	reactions: I({ max_reactions: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0) }),
	statuses: I({
		characters_reserved_per_url: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		max_characters: /* @__PURE__ */ v(/* @__PURE__ */ w(), 500),
		max_media_attachments: /* @__PURE__ */ v(/* @__PURE__ */ w(), 4)
	}),
	translation: I({ enabled: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1) }),
	timelines_access: I({
		.../* @__PURE__ */ ne(["hashtag_feeds", "trending_link_feeds"], I(/* @__PURE__ */ ne(["local", "remote"], /* @__PURE__ */ v(/* @__PURE__ */ D([
			"public",
			"authenticated",
			"disabled"
		]), "public")))),
		live_feeds: I(/* @__PURE__ */ ne([
			"local",
			"bubble",
			"remote",
			"wrenched"
		], /* @__PURE__ */ v(/* @__PURE__ */ D([
			"public",
			"authenticated",
			"disabled",
			"restricted"
		]), "public")))
	}),
	urls: I({
		streaming: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _())), void 0),
		status: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _())), void 0),
		about: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		privacy_policy: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		terms_of_service: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
	}),
	vapid: I({ public_key: /* @__PURE__ */ v(/* @__PURE__ */ k(), "") }),
	limited_federation: /* @__PURE__ */ E(/* @__PURE__ */ x(), void 0),
	gif_search: I({
		enabled: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		provider: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
	})
}), pt = I({
	contact_account: /* @__PURE__ */ v(/* @__PURE__ */ E(L), void 0),
	email: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ le()), "")
}), mt = I({
	metadata: I({
		account_activation_required: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		birthday_min_age: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
		birthday_required: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		description_limit: /* @__PURE__ */ v(/* @__PURE__ */ w(), 1500),
		federation: I({
			enabled: /* @__PURE__ */ v(/* @__PURE__ */ x(), !0),
			mrf_policies: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ b(/* @__PURE__ */ k())), void 0),
			mrf_simple: I(/* @__PURE__ */ ne([
				"accept",
				"avatar_removal",
				"banner_removal",
				"federated_timeline_removal",
				"followers_only",
				"media_nsfw",
				"media_removal",
				"reject",
				"reject_deletes",
				"report_removal"
			], /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ k()), []))),
			mrf_simple_info: I(/* @__PURE__ */ ne([
				"accept",
				"avatar_removal",
				"banner_removal",
				"federated_timeline_removal",
				"followers_only",
				"media_nsfw",
				"media_removal",
				"reject",
				"reject_deletes",
				"report_removal"
			], /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ Oe([/* @__PURE__ */ k(), /* @__PURE__ */ k()])), [])))
		}),
		fields_limits: I({
			max_fields: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de(), /* @__PURE__ */ ge(0)), 4),
			name_length: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de(), /* @__PURE__ */ ge(0)), 255),
			value_length: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de(), /* @__PURE__ */ ge(0)), 2047)
		}),
		markup: I({
			allow_headings: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
			allow_inline_images: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
		}),
		migration_cooldown_period: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		multitenancy: I({
			domains: /* @__PURE__ */ E(/* @__PURE__ */ b(/* @__PURE__ */ T({
				domain: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
				id: /* @__PURE__ */ k(),
				public: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
			}))),
			enabled: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
		}),
		post_formats: /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ k()), ["text/plain"]),
		restrict_unauthenticated: I({
			activities: I({
				local: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
				remote: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
			}),
			profiles: I({
				local: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
				remote: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
			}),
			timelines: I({
				bubble: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
				federated: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
				local: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
				wrenched: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
			})
		}),
		translation: I({
			allow_remote: /* @__PURE__ */ v(/* @__PURE__ */ x(), !0),
			allow_unauthenticated: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
			source_languages: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ b(/* @__PURE__ */ k())), void 0),
			target_languages: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ b(/* @__PURE__ */ k())), void 0)
		})
	}),
	oauth_consumer_strategies: /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ k()), []),
	stats: I({ mau: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0) }),
	vapid_public_key: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
}), ht = I({
	max_expiration: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	max_option_chars: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	max_options: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	min_expiration: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0)
}), gt = I({
	approval_required: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	enabled: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	message: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	min_age: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	reason_required: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ x()), null),
	url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _())), null)
}), _t = I({
	domain_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	status_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	user_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0)
}), vt = I({ url: /* @__PURE__ */ v(/* @__PURE__ */ k(), "") }), yt = I({ users: I({ active_month: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0) }) }), bt = I({
	account_domain: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	approval_required: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	configuration: ft,
	contact_account: /* @__PURE__ */ v(/* @__PURE__ */ E(L), void 0),
	description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	description_limit: /* @__PURE__ */ v(/* @__PURE__ */ w(), 1500),
	email: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ le()), ""),
	feature_quote: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	languages: /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ k()), []),
	max_media_attachments: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	max_toot_chars: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	pleroma: mt,
	poll_limits: ht,
	registrations: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	rules: F(at),
	short_description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	stats: _t,
	thumbnail: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	title: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	upload_limit: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	uri: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	urls: I({ streaming_api: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _())), void 0) }),
	usage: yt,
	version: /* @__PURE__ */ v(/* @__PURE__ */ k(), "0.0.0")
}), xt = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => {
	e.source_url === "https://github.com/fedify-dev/hollo" && (e.version = `0.0.0 (compatible; Hollo ${e.version})`), e.source_url === "https://codeberg.org/superseriousbusiness/gotosocial" && (e.version = `0.0.0 (compatible; GoToSocial ${e.version})`), e.contact?.account?.created_at === "0000-01-01T00:00:00Z" && (e.version = `0.0.0 (compatible; TinyAP ${e.version})`);
	let t = ct(e);
	if (e.pleroma ||= { metadata: { post_formats: e.configuration?.statuses?.supported_mime_types || (t["kmyblue_markdown.fedibird.pl-api"] ? ["text/plain", "text/markdown"] : e.version?.includes("Sharkey") ? ["text/x.misskeymarkdown"] : []) } }, e.pleroma?.metadata?.restrict_unauthenticated?.timelines) {
		let t = e.pleroma.metadata.restrict_unauthenticated.timelines, n = e.pleroma.metadata.features || [];
		e.configuration ||= {}, e.configuration.timelines_access = {
			...e.configuration.timelines_access,
			live_feeds: {
				bubble: t.bubble ? "authenticated" : n.includes("bubble_timeline") ? "public" : "disabled",
				local: t.local ? "authenticated" : "public",
				remote: t.federated ? "authenticated" : "public",
				wrenched: t.wrenched ? "authenticated" : n.includes("pleroma:wrenched_timeline") ? "public" : "disabled"
			}
		};
	}
	return e.domain ? {
		account_domain: e.domain,
		...e,
		api_versions: t
	} : {
		...lt(e),
		api_versions: t
	};
}), I({
	account_domain: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	api_versions: /* @__PURE__ */ v(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ w()), {}),
	configuration: ft,
	contact: pt,
	description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	domain: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	feature_quote: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	icons: F(/* @__PURE__ */ T({
		size: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ ve(/^[0-9]+x[0-9]+$/)),
		src: /* @__PURE__ */ k()
	})),
	languages: /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ k()), []),
	pleroma: mt,
	registrations: gt,
	rules: F(at),
	stats: _t,
	thumbnail: vt,
	title: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	usage: yt,
	version: /* @__PURE__ */ M(/* @__PURE__ */ v(/* @__PURE__ */ k(), "0.0.0"), /* @__PURE__ */ g(dt)),
	blockchains: /* @__PURE__ */ v(/* @__PURE__ */ E(F(/* @__PURE__ */ T({
		chain_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		chain_metadata: I({
			is_forwarding_required: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
			description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
			payment_amount_min: /* @__PURE__ */ w()
		}),
		features: I({ subscriptions: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1) })
	}))), void 0)
})), St = /* @__PURE__ */ o(((e, t) => {
	t.exports = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...e) => console.error("SEMVER", ...e) : () => {};
})), Ct = /* @__PURE__ */ o(((e, t) => {
	t.exports = {
		MAX_LENGTH: 256,
		MAX_SAFE_COMPONENT_LENGTH: 16,
		MAX_SAFE_BUILD_LENGTH: 250,
		MAX_SAFE_INTEGER: 2 ** 53 - 1 || 
		/* istanbul ignore next */ 9007199254740991,
		RELEASE_TYPES: [
			"major",
			"premajor",
			"minor",
			"preminor",
			"patch",
			"prepatch",
			"prerelease"
		],
		SEMVER_SPEC_VERSION: "2.0.0",
		FLAG_INCLUDE_PRERELEASE: 1,
		FLAG_LOOSE: 2
	};
})), wt = /* @__PURE__ */ o(((e, t) => {
	var { MAX_SAFE_COMPONENT_LENGTH: n, MAX_SAFE_BUILD_LENGTH: r, MAX_LENGTH: i } = Ct(), a = St();
	e = t.exports = {};
	var o = e.re = [], s = e.safeRe = [], c = e.src = [], l = e.safeSrc = [], u = e.t = {}, d = 0, ee = "[a-zA-Z0-9-]", f = [
		["\\s", 1],
		["\\d", i],
		[ee, r]
	], p = (e) => {
		for (let [t, n] of f) e = e.split(`${t}*`).join(`${t}{0,${n}}`).split(`${t}+`).join(`${t}{1,${n}}`);
		return e;
	}, m = (e, t, n) => {
		let r = p(t), i = d++;
		a(e, i, t), u[e] = i, c[i] = t, l[i] = r, o[i] = new RegExp(t, n ? "g" : void 0), s[i] = new RegExp(r, n ? "g" : void 0);
	};
	m("NUMERICIDENTIFIER", "0|[1-9]\\d*"), m("NUMERICIDENTIFIERLOOSE", "\\d+"), m("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${ee}*`), m("MAINVERSION", `(${c[u.NUMERICIDENTIFIER]})\\.(${c[u.NUMERICIDENTIFIER]})\\.(${c[u.NUMERICIDENTIFIER]})`), m("MAINVERSIONLOOSE", `(${c[u.NUMERICIDENTIFIERLOOSE]})\\.(${c[u.NUMERICIDENTIFIERLOOSE]})\\.(${c[u.NUMERICIDENTIFIERLOOSE]})`), m("PRERELEASEIDENTIFIER", `(?:${c[u.NONNUMERICIDENTIFIER]}|${c[u.NUMERICIDENTIFIER]})`), m("PRERELEASEIDENTIFIERLOOSE", `(?:${c[u.NONNUMERICIDENTIFIER]}|${c[u.NUMERICIDENTIFIERLOOSE]})`), m("PRERELEASE", `(?:-(${c[u.PRERELEASEIDENTIFIER]}(?:\\.${c[u.PRERELEASEIDENTIFIER]})*))`), m("PRERELEASELOOSE", `(?:-?(${c[u.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${c[u.PRERELEASEIDENTIFIERLOOSE]})*))`), m("BUILDIDENTIFIER", `${ee}+`), m("BUILD", `(?:\\+(${c[u.BUILDIDENTIFIER]}(?:\\.${c[u.BUILDIDENTIFIER]})*))`), m("FULLPLAIN", `v?${c[u.MAINVERSION]}${c[u.PRERELEASE]}?${c[u.BUILD]}?`), m("FULL", `^${c[u.FULLPLAIN]}$`), m("LOOSEPLAIN", `[v=\\s]*${c[u.MAINVERSIONLOOSE]}${c[u.PRERELEASELOOSE]}?${c[u.BUILD]}?`), m("LOOSE", `^${c[u.LOOSEPLAIN]}$`), m("GTLT", "((?:<|>)?=?)"), m("XRANGEIDENTIFIERLOOSE", `${c[u.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), m("XRANGEIDENTIFIER", `${c[u.NUMERICIDENTIFIER]}|x|X|\\*`), m("XRANGEPLAIN", `[v=\\s]*(${c[u.XRANGEIDENTIFIER]})(?:\\.(${c[u.XRANGEIDENTIFIER]})(?:\\.(${c[u.XRANGEIDENTIFIER]})(?:${c[u.PRERELEASE]})?${c[u.BUILD]}?)?)?`), m("XRANGEPLAINLOOSE", `[v=\\s]*(${c[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${c[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${c[u.XRANGEIDENTIFIERLOOSE]})(?:${c[u.PRERELEASELOOSE]})?${c[u.BUILD]}?)?)?`), m("XRANGE", `^${c[u.GTLT]}\\s*${c[u.XRANGEPLAIN]}$`), m("XRANGELOOSE", `^${c[u.GTLT]}\\s*${c[u.XRANGEPLAINLOOSE]}$`), m("COERCEPLAIN", `(^|[^\\d])(\\d{1,${n}})(?:\\.(\\d{1,${n}}))?(?:\\.(\\d{1,${n}}))?`), m("COERCE", `${c[u.COERCEPLAIN]}(?:$|[^\\d])`), m("COERCEFULL", c[u.COERCEPLAIN] + `(?:${c[u.PRERELEASE]})?(?:${c[u.BUILD]})?(?:$|[^\\d])`), m("COERCERTL", c[u.COERCE], !0), m("COERCERTLFULL", c[u.COERCEFULL], !0), m("LONETILDE", "(?:~>?)"), m("TILDETRIM", `(\\s*)${c[u.LONETILDE]}\\s+`, !0), e.tildeTrimReplace = "$1~", m("TILDE", `^${c[u.LONETILDE]}${c[u.XRANGEPLAIN]}$`), m("TILDELOOSE", `^${c[u.LONETILDE]}${c[u.XRANGEPLAINLOOSE]}$`), m("LONECARET", "(?:\\^)"), m("CARETTRIM", `(\\s*)${c[u.LONECARET]}\\s+`, !0), e.caretTrimReplace = "$1^", m("CARET", `^${c[u.LONECARET]}${c[u.XRANGEPLAIN]}$`), m("CARETLOOSE", `^${c[u.LONECARET]}${c[u.XRANGEPLAINLOOSE]}$`), m("COMPARATORLOOSE", `^${c[u.GTLT]}\\s*(${c[u.LOOSEPLAIN]})$|^$`), m("COMPARATOR", `^${c[u.GTLT]}\\s*(${c[u.FULLPLAIN]})$|^$`), m("COMPARATORTRIM", `(\\s*)${c[u.GTLT]}\\s*(${c[u.LOOSEPLAIN]}|${c[u.XRANGEPLAIN]})`, !0), e.comparatorTrimReplace = "$1$2$3", m("HYPHENRANGE", `^\\s*(${c[u.XRANGEPLAIN]})\\s+-\\s+(${c[u.XRANGEPLAIN]})\\s*$`), m("HYPHENRANGELOOSE", `^\\s*(${c[u.XRANGEPLAINLOOSE]})\\s+-\\s+(${c[u.XRANGEPLAINLOOSE]})\\s*$`), m("STAR", "(<|>)?=?\\s*\\*"), m("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), m("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})), Tt = /* @__PURE__ */ o(((e, t) => {
	var n = Object.freeze({ loose: !0 }), r = Object.freeze({});
	t.exports = (e) => e ? typeof e == "object" ? e : n : r;
})), Et = /* @__PURE__ */ o(((e, t) => {
	var n = /^[0-9]+$/, r = (e, t) => {
		if (typeof e == "number" && typeof t == "number") return e === t ? 0 : e < t ? -1 : 1;
		let r = n.test(e), i = n.test(t);
		return r && i && (e = +e, t = +t), e === t ? 0 : r && !i ? -1 : i && !r ? 1 : e < t ? -1 : 1;
	};
	t.exports = {
		compareIdentifiers: r,
		rcompareIdentifiers: (e, t) => r(t, e)
	};
})), Dt = /* @__PURE__ */ o(((e, t) => {
	var n = St(), { MAX_LENGTH: r, MAX_SAFE_INTEGER: i } = Ct(), { safeRe: a, t: o } = wt(), s = Tt(), { compareIdentifiers: c } = Et(), l = (e, t) => {
		let n = t.split(".");
		if (n.length > e.length) return !1;
		for (let t = 0; t < n.length; t++) if (c(e[t], n[t]) !== 0) return !1;
		return !0;
	};
	t.exports = class e {
		constructor(t, c) {
			if (c = s(c), t instanceof e) {
				if (t.loose === !!c.loose && t.includePrerelease === !!c.includePrerelease) return t;
				t = t.version;
			} else if (typeof t != "string") throw TypeError(`Invalid version. Must be a string. Got type "${typeof t}".`);
			if (t.length > r) throw TypeError(`version is longer than ${r} characters`);
			n("SemVer", t, c), this.options = c, this.loose = !!c.loose, this.includePrerelease = !!c.includePrerelease;
			let l = t.trim().match(c.loose ? a[o.LOOSE] : a[o.FULL]);
			if (!l) throw TypeError(`Invalid Version: ${t}`);
			if (this.raw = t, this.major = +l[1], this.minor = +l[2], this.patch = +l[3], this.major > i || this.major < 0) throw TypeError("Invalid major version");
			if (this.minor > i || this.minor < 0) throw TypeError("Invalid minor version");
			if (this.patch > i || this.patch < 0) throw TypeError("Invalid patch version");
			this.prerelease = l[4] ? l[4].split(".").map((e) => {
				if (/^[0-9]+$/.test(e)) {
					let t = +e;
					if (t >= 0 && t < i) return t;
				}
				return e;
			}) : [], this.build = l[5] ? l[5].split(".") : [], this.format();
		}
		format() {
			return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
		}
		toString() {
			return this.version;
		}
		compare(t) {
			if (n("SemVer.compare", this.version, this.options, t), !(t instanceof e)) {
				if (typeof t == "string" && t === this.version) return 0;
				t = new e(t, this.options);
			}
			return t.version === this.version ? 0 : this.compareMain(t) || this.comparePre(t);
		}
		compareMain(t) {
			return t instanceof e || (t = new e(t, this.options)), this.major < t.major ? -1 : this.major > t.major ? 1 : this.minor < t.minor ? -1 : this.minor > t.minor ? 1 : this.patch < t.patch ? -1 : +(this.patch > t.patch);
		}
		comparePre(t) {
			if (t instanceof e || (t = new e(t, this.options)), this.prerelease.length && !t.prerelease.length) return -1;
			if (!this.prerelease.length && t.prerelease.length) return 1;
			if (!this.prerelease.length && !t.prerelease.length) return 0;
			let r = 0;
			do {
				let e = this.prerelease[r], i = t.prerelease[r];
				if (n("prerelease compare", r, e, i), e === void 0 && i === void 0) return 0;
				if (i === void 0) return 1;
				if (e === void 0) return -1;
				if (e !== i) return c(e, i);
			} while (++r);
		}
		compareBuild(t) {
			t instanceof e || (t = new e(t, this.options));
			let r = 0;
			do {
				let e = this.build[r], i = t.build[r];
				if (n("build compare", r, e, i), e === void 0 && i === void 0) return 0;
				if (i === void 0) return 1;
				if (e === void 0) return -1;
				if (e !== i) return c(e, i);
			} while (++r);
		}
		inc(e, t, n) {
			if (e.startsWith("pre")) {
				if (!t && n === !1) throw Error("invalid increment argument: identifier is empty");
				if (t) {
					let e = `-${t}`.match(this.options.loose ? a[o.PRERELEASELOOSE] : a[o.PRERELEASE]);
					if (!e || e[1] !== t) throw Error(`invalid identifier: ${t}`);
				}
			}
			switch (e) {
				case "premajor":
					this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", t, n);
					break;
				case "preminor":
					this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", t, n);
					break;
				case "prepatch":
					this.prerelease.length = 0, this.inc("patch", t, n), this.inc("pre", t, n);
					break;
				case "prerelease":
					this.prerelease.length === 0 && this.inc("patch", t, n), this.inc("pre", t, n);
					break;
				case "release":
					if (this.prerelease.length === 0) throw Error(`version ${this.raw} is not a prerelease`);
					this.prerelease.length = 0;
					break;
				case "major":
					(this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
					break;
				case "minor":
					(this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
					break;
				case "patch":
					this.prerelease.length === 0 && this.patch++, this.prerelease = [];
					break;
				case "pre": {
					let e = +!!Number(n);
					if (this.prerelease.length === 0) this.prerelease = [e];
					else {
						let r = this.prerelease.length;
						for (; --r >= 0;) typeof this.prerelease[r] == "number" && (this.prerelease[r]++, r = -2);
						if (r === -1) {
							if (t === this.prerelease.join(".") && n === !1) throw Error("invalid increment argument: identifier already exists");
							this.prerelease.push(e);
						}
					}
					if (t) {
						let r = [t, e];
						if (n === !1 && (r = [t]), l(this.prerelease, t)) {
							let e = this.prerelease[t.split(".").length];
							isNaN(e) && (this.prerelease = r);
						} else this.prerelease = r;
					}
					break;
				}
				default: throw Error(`invalid increment argument: ${e}`);
			}
			return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
		}
	};
})), Ot = /* @__PURE__ */ o(((e, t) => {
	var n = Dt();
	t.exports = (e, t, r = !1) => {
		if (e instanceof n) return e;
		try {
			return new n(e, t);
		} catch (e) {
			if (!r) return null;
			throw e;
		}
	};
})), kt = /* @__PURE__ */ o(((e, t) => {
	var n = Dt(), r = Ot(), { safeRe: i, t: a } = wt();
	t.exports = (e, t) => {
		if (e instanceof n) return e;
		if (typeof e == "number" && (e = String(e)), typeof e != "string") return null;
		t ||= {};
		let o = null;
		if (!t.rtl) o = e.match(t.includePrerelease ? i[a.COERCEFULL] : i[a.COERCE]);
		else {
			let n = t.includePrerelease ? i[a.COERCERTLFULL] : i[a.COERCERTL], r;
			for (; (r = n.exec(e)) && (!o || o.index + o[0].length !== e.length);) (!o || r.index + r[0].length !== o.index + o[0].length) && (o = r), n.lastIndex = r.index + r[1].length + r[2].length;
			n.lastIndex = -1;
		}
		if (o === null) return null;
		let s = o[2];
		return r(`${s}.${o[3] || "0"}.${o[4] || "0"}${t.includePrerelease && o[5] ? `-${o[5]}` : ""}${t.includePrerelease && o[6] ? `+${o[6]}` : ""}`, t);
	};
})), At = /* @__PURE__ */ o(((e, t) => {
	var n = Dt();
	t.exports = (e, t, r) => new n(e, r).compare(new n(t, r));
})), jt = /* @__PURE__ */ o(((e, t) => {
	var n = At();
	t.exports = (e, t, r) => n(e, t, r) > 0;
})), Mt = /* @__PURE__ */ o(((e, t) => {
	var n = At();
	t.exports = (e, t, r) => n(e, t, r) >= 0;
})), Nt = /* @__PURE__ */ l(kt(), 1), Pt = /* @__PURE__ */ l(jt(), 1), R = /* @__PURE__ */ l(Mt(), 1), Ft = /* @__PURE__ */ l(Ot(), 1), z = (e) => e.some(Boolean), It = "Egregoros", B = "Firefish", Lt = "Friendica", V = "GoToSocial", H = "Hollo", U = "Iceshrimp", W = "Iceshrimp.NET", G = "Mastodon", K = "Mitra", q = "NeoDB", J = "Pixelfed", Y = "Pleroma", X = "Sharkey", Rt = "snac", zt = "Takahe", Bt = "TinyAP", Vt = "Toki", Ht = "Wafrn", Ut = "WordPress", Z = "Akkoma", Wt = "glitch", Gt = "hometown", Kt = "unreleased", qt = (e) => {
	let t = Jt(e.version || ""), n = !!e.pleroma.metadata.federation.enabled;
	return {
		version: t,
		accountAvatarDescription: z([
			t.software === "Akkoma" && (0, R.default)(t.version, "3.19.0"),
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"),
			t.software === W,
			t.software === "Pleroma" && (0, R.default)(t.version, "2.8.0"),
			e.api_versions.chuckya >= 1,
			e.api_versions.mastodon >= 11
		]),
		accountBackups: z([t.software === Z, t.software === Y]),
		accountByUsername: z([
			t.software === Z,
			t.software === K,
			t.software === Y
		]),
		accountCreation: !0,
		accountDiscoverability: z([
			t.software === Lt,
			t.software === V,
			t.software === H,
			t.software === G,
			t.software === K,
			t.software === X,
			e.api_versions["profile_directory.pleroma.pl-api"] >= 1
		]),
		accountEnableRss: t.software === V,
		accountEndorsements: z([t.software === "Pleroma" && (0, R.default)(t.version, "2.5.0"), e.api_versions.mastodon >= 6]),
		accountIsCat: e.api_versions["is_cat.pleroma.pl-api"] >= 1,
		accountLocation: z([e.api_versions["account_location.pleroma.pl-api"] >= 1]),
		accountLookup: z([
			t.software === Z,
			t.software === B,
			t.software === V,
			t.software === H,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === K,
			t.software === q,
			t.software === "Pleroma" && (0, R.default)(t.version, "2.5.0"),
			t.software === X,
			t.software === Rt,
			t.software === "Takahe" && (0, R.default)(t.version, "0.6.1"),
			t.software === Vt,
			t.software === Ht,
			t.software === Ut
		]),
		accountMentionPolicy: z([t.software === K]),
		accountMoving: z([t.software === Z, t.software === "Pleroma" && (0, R.default)(t.version, "2.5.0")]),
		accountNotifies: z([
			t.software === Z,
			t.software === V,
			t.software === G,
			t.software === "Pleroma" && (0, R.default)(t.version, "2.5.0")
		]),
		accountNotifiesControl: e.api_versions["notifies_control.pleroma.pl-api"] >= 1,
		accountWebIncludeBoosts: t.software === "GoToSocial" && (0, R.default)(t.version, "0.21.0"),
		accountWebLayout: z([t.software === "GoToSocial" && (0, R.default)(t.version, "0.19.0")]),
		accountWebVisibility: z([t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0")]),
		additionalTags: z([
			t.software === Z,
			t.software === W,
			t.software === G,
			t.software === Y
		]),
		addressableLists: z([t.software === Z, t.software === Y]),
		adminCanonicalEmailBlocks: t.software === "Mastodon" && (0, R.default)(t.version, "3.5.0"),
		adminCustomEmojis: t.software === V,
		adminCustomEmojiCategories: t.software === V,
		adminDeleteStatus: z([
			t.software === Z,
			t.software === W,
			t.software === K,
			t.software === Y
		]),
		adminDomainBlocks: z([
			t.software === Z,
			t.software === V,
			t.software === G,
			t.software === Y
		]),
		adminDomainKeysExpire: t.software === V,
		adminDomainLimits: t.software === V,
		adminDomainPermissionSubscriptions: t.software === "GoToSocial" && (0, R.default)(t.version, "0.18.0"),
		adminEmailDomainBlocks: t.software === "Mastodon" && (0, R.default)(t.version, "4.1.0"),
		adminEmailTest: t.software === V,
		adminHeaderFilters: t.software === "GoToSocial" && (0, R.default)(t.version, "0.16.0"),
		adminInstances: t.software === V,
		adminIpBlocks: t.software === "Mastodon" && (0, R.default)(t.version, "4.0.0"),
		adminMediaModeration: t.software === V,
		adminRelaySubscriptions: t.software === V,
		adminReportForwarding: t.software === W,
		adminRules: z([t.software === V, t.software === "Pleroma" && (0, R.default)(t.version, "2.7.0")]),
		adminRulesPriority: z([t.software === "Pleroma" && (0, R.default)(t.version, "2.7.0")]),
		announcements: z([
			t.software === Z,
			t.software === B,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === q,
			t.software === Y,
			t.software === X,
			t.software === Rt,
			t.software === "Takahe" && (0, R.default)(t.version, "0.7.0"),
			t.software === Ht
		]),
		announcementsReactions: t.software === G,
		antennas: e.api_versions["kmyblue_antenna.fedibird.pl-api"] >= 1,
		birthdays: t.software === Y,
		biteControls: e.api_versions["net.iceshrimp.bites"] >= 1,
		bites: z([
			t.software === W,
			t.software === Vt,
			t.software === Ht,
			e.api_versions["bites.pleroma.pl-api"] >= 1,
			e.api_versions["net.iceshrimp.bites"] >= 1
		]),
		biteStatuses: t.software === W,
		blockersVisible: !z([t.software === "Pleroma", t.software === "Akkoma"]) || e.api_versions["blockers_visible.pleroma.pl-api"] >= 1,
		blocksDuration: e.api_versions["block_expiration.pleroma.pl-api"] >= 1,
		bookmarkFolderEmojis: e.api_versions["bookmark_folders.pleroma.pl-api"] >= 1,
		bookmarkFolders: z([e.api_versions["bookmark_folders.pleroma.pl-api"] >= 1, e.api_versions["kmyblue_bookmark_category.fedibird.pl-api"] >= 1]),
		bookmarkFoldersMultiple: e.api_versions["kmyblue_bookmark_category.fedibird.pl-api"] >= 1,
		bookmarks: z([
			t.software === Z,
			t.software === B,
			t.software === V,
			t.software === H,
			t.software === U,
			t.software === W,
			t.software === Lt,
			t.software === G,
			t.software === "Mitra" && (0, R.default)(t.version, "3.3.0"),
			t.software === q,
			t.software === J,
			t.software === Y,
			t.software === X,
			t.software === "Takahe" && (0, R.default)(t.version, "0.9.0"),
			t.software === Vt
		]),
		bots: z([
			t.software === Z,
			t.software === V,
			t.software === H,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === "Mitra" && (0, R.default)(t.version, "3.22.0"),
			t.software === J,
			t.software === Y,
			t.software === Rt
		]),
		bubbleDomainList: e.api_versions.chuckya >= 1,
		bubbleTimeline: z([e.api_versions["bubble_timeline.pleroma.pl-api"] >= 1, t.software === W]),
		bubbleTimelineStreaming: t.software === W,
		changeEmail: z([
			t.software === Z,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.16.0"),
			t.software === Y
		]),
		changePassword: z([
			t.software === Z,
			t.software === V,
			t.software === W,
			t.software === K,
			t.software === J,
			t.software === Y
		]),
		chats: e.api_versions["chat_messages.pleroma.pl-api"] >= 1,
		chatsDelete: z([e.api_versions["chat_delete.pleroma.pl-api"] >= 1]),
		circles: e.api_versions["kmyblue_circle_history.fedibird.pl-api"] >= 1,
		collections: e.api_versions.mastodon >= 10,
		composeAllowHeadings: z([t.software !== "Pleroma" && t.software !== "Akkoma", e.pleroma.metadata.markup.allow_headings]),
		composeAllowInlineImages: e.pleroma.metadata.markup.allow_inline_images,
		conversations: z([
			t.software === Z,
			t.software === B,
			t.software === Lt,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"),
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === q,
			t.software === J,
			t.software === Y,
			t.software === X,
			t.software === zt
		]),
		conversationsByRecipients: z([t.software === Z, t.software === Y]),
		createStatusConversationScope: t.software === K,
		createStatusExpiration: z([t.software === Z, t.software === Y]),
		createStatusExplicitAddressing: z([e.api_versions["explicit_addressing.pleroma.pl-api"] >= 1]),
		createStatusReplyToConversation: z([t.software === Z, t.software === Y]),
		createStatusListScope: z([t.software === Z, t.software === Y]),
		createStatusLocalScope: z([
			t.software === Z,
			t.software === W,
			t.software === Y
		]),
		createStatusMutualsOnlyScope: t.software === V,
		createStatusSubscribersScope: t.software === K,
		createStatusPreview: z([
			t.software === Z,
			t.software === Y,
			t.software === K
		]),
		customEmojiReacts: z([
			e.api_versions["custom_emoji_reactions.pleroma.pl-api"] >= 1,
			t.software === H,
			t.software === "Mitra" && (0, R.default)(t.version, "3.4.0")
		]),
		deleteAccount: z([
			t.software === Z,
			t.software === V,
			t.software === Y
		]),
		deleteAccountWithoutPassword: t.software === "Mitra" && (0, R.default)(t.version, "2.14.0"),
		deleteMedia: e.api_versions.mastodon >= 4,
		disableMfaWithCode: t.software === W,
		domains: z([e.pleroma.metadata.multitenancy.enabled]),
		drive: t.software === W,
		editProfile: z([
			t.software === Z,
			t.software === B,
			t.software === Lt,
			t.software === V,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === K,
			t.software === q,
			t.software === J,
			t.software === Y,
			t.software === "Takahe" && (0, R.default)(t.version, "0.7.0"),
			t.software === Vt
		]),
		editStatuses: z([
			t.software === B,
			t.software === "Friendica" && (0, R.default)(t.version, "2022.12.0"),
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.18.0"),
			t.software === H,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === K,
			t.software === q,
			t.software === X,
			t.software === "Takahe" && (0, R.default)(t.version, "0.8.0"),
			e.api_versions["editing.pleroma.pl-api"] >= 1
		]),
		embeds: t.software === G,
		emojiReacts: z([
			t.software === Z,
			t.software === B,
			t.software === H,
			t.software === "Mitra" && (0, R.default)(t.version, "2.21.0"),
			t.software === Y,
			e ? e.configuration.reactions.max_reactions > 0 : !1
		]),
		emojiReactsList: z([
			t.software === Z,
			t.software === W,
			t.software === Y,
			e.api_versions["emoji_reaction.fedibird.pl-api"] >= 1
		]),
		events: e.api_versions["events.pleroma.pl-api"] >= 1,
		exportBlocks: t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"),
		exportFollowers: z([t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"), t.software === "Mitra" && (0, R.default)(t.version, "1.27.0")]),
		exportFollows: z([t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"), t.software === "Mitra" && (0, R.default)(t.version, "1.27.0")]),
		exportLists: t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"),
		exportMutes: t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"),
		exposableReactions: z([
			t.software === B,
			t.software === Lt,
			t.software === V,
			t.software === H,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === "Mitra" && (0, R.default)(t.version, "4.5.0"),
			t.software === q,
			t.software === X,
			t.software === Rt,
			t.software === "Takahe" && (0, R.default)(t.version, "0.6.1"),
			t.software === Vt,
			e.api_versions["exposable_reactions.pleroma.pl-api"] >= 1
		]),
		familiarFollowers: z([
			t.software === H,
			t.software === G,
			t.software === q,
			t.software === J,
			t.software === "Pleroma" && (0, R.default)(t.version, "2.7.0"),
			t.software === zt
		]),
		featuredTags: z([
			t.software === H,
			t.software === G,
			t.software === q,
			t.software === "Takahe" && (0, R.default)(t.version, "0.12.0")
		]),
		federating: n,
		filters: z([
			t.software === Z,
			t.software === V,
			t.software === Y,
			t.software === X
		]),
		filtersV2: z([
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.16.0"),
			t.software === W,
			t.software === G
		]),
		filtersV2BlurAction: z([t.software === "GoToSocial" && (0, R.default)(t.version, "0.20.0"), t.software === "Mastodon" && (0, R.default)(t.version, "4.4.0")]),
		focalPoint: z([t.software === V, t.software === G]),
		followedHashtagsList: z([
			t.software === Z,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"),
			t.software === H,
			t.software === "Mastodon" && (0, R.default)(t.compatVersion, "4.1.0"),
			t.software === q,
			t.software === J,
			t.software === "Pleroma" && (0, R.default)(t.version, "2.9.0"),
			t.software === "snac" && (0, R.default)(t.version, "2.69.0"),
			t.software === "Takahe" && (0, R.default)(t.version, "0.9.0"),
			t.software === Ht
		]),
		followHashtags: z([
			t.software === Z,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"),
			t.software === H,
			t.software === "Mastodon" && (0, R.default)(t.compatVersion, "4.0.0"),
			t.software === q,
			t.software === J,
			t.software === "Pleroma" && (0, R.default)(t.version, "2.9.0"),
			t.software === "snac" && (0, R.default)(t.version, "2.69.0"),
			t.software === "Takahe" && (0, R.default)(t.version, "0.9.0"),
			t.software === Ht
		]),
		followRequests: z([
			t.software === Z,
			t.software === B,
			t.software === V,
			t.software === H,
			t.software === W,
			t.software === G,
			t.software === K,
			t.software === Y,
			t.software === "snac" && (0, R.default)(t.version, "2.78.0"),
			t.software === Vt
		]),
		frontendConfigurations: z([
			t.software === Z,
			t.software === "Mitra" && (0, R.default)(t.version, "1.20.0"),
			t.software === Y
		]),
		getAccounts: z([
			t.software === W,
			t.software === "Mastodon" && (0, R.default)(t.version, "4.3.0"),
			t.software === Ht
		]),
		getStatuses: z([
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.22.0"),
			t.software === W,
			t.software === "Mastodon" && (0, R.default)(t.version, "4.3.0"),
			t.software === "Mitra" && (0, Pt.default)(t.version, "5.7.1"),
			t.software === Ht
		]),
		grantTypePassword: !z([
			t.software === V,
			t.software === U,
			t.software === "Mastodon" && (0, R.default)(t.version, "4.4.0"),
			t.software === X,
			t.software === Rt,
			t.software === Bt
		]),
		groupedNotifications: z([
			e.api_versions.mastodon >= 2,
			t.software === "Hollo" && (0, R.default)(t.version, "0.7.0"),
			e.api_versions["mastodon_api_grouped_notifications.pleroma.pl-api"] >= 1
		]),
		gifPicker: e.configuration.gif_search.enabled,
		groups: z([t.software === J, e.api_versions["groups.pleroma.pl-api"] >= 1]),
		groupsSlugs: e.api_versions["groups.pleroma.pl-api"] >= 1,
		hideNetwork: z([
			t.software === Z,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.15.0"),
			t.software === Y
		]),
		iceshrimpAdmin: t.software === W,
		importArchives: e.api_versions["import_archives.pleroma.pl-api"] >= 1,
		importBlocks: z([
			t.software === Z,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"),
			t.software === W,
			t.software === Y
		]),
		importFollowers: z([t.software === "Mitra" && (0, R.default)(t.version, "2.18.0")]),
		importFollows: z([
			t.software === Z,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"),
			t.software === W,
			t.software === "Mitra" && (0, R.default)(t.version, "1.10.0"),
			t.software === Y
		]),
		importMutes: z([
			t.software === Z,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.19.0"),
			t.software === W,
			t.software === Y
		]),
		importOverwrite: t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"),
		instanceTimeline: z([
			t.software === Z,
			t.software === W,
			t.software === "Pleroma" && (0, R.default)(t.version, "2.7.0")
		]),
		instanceV2: z([
			t.software === B,
			t.software === V,
			t.software === "Mastodon" && (0, R.default)(t.compatVersion, "4.0.0"),
			t.software === "Mitra" && (0, R.default)(t.version, "2.18.0"),
			t.software === "Pleroma" && (0, R.default)(t.version, "2.7.0"),
			t.software === Bt
		]),
		interactionRequests: t.software === "GoToSocial" && (0, R.default)(t.version, "0.17.0"),
		languageDetection: e.api_versions["language_detection.pleroma.pl-api"] >= 1,
		lazyTranslations: e.api_versions["translations.pl.pl-api"] >= 1,
		lists: z([
			t.software === Z,
			t.software === B,
			t.software === Lt,
			t.software === V,
			t.software === H,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === K,
			t.software === q,
			t.software === Y,
			t.software === X,
			t.software === Rt,
			t.software === "Takahe" && (0, R.default)(t.version, "0.12.0")
		]),
		listsEmojis: t.software === "Pleroma" && (0, R.default)(t.version, "2.10.3"),
		listsExclusive: z([
			t.software === V,
			t.software === H,
			t.software === W,
			t.software === "Mastodon" && (0, R.default)(t.version, "4.2.0"),
			t.software === q,
			t.software === "Takahe" && (0, R.default)(t.version, "0.12.0")
		]),
		listsFavourites: e.api_versions["favourite_list.fedibird.pl-api"] >= 1,
		listsNotifications: e.api_versions["kmyblue_list_notification.fedibird.pl-api"] >= 1,
		listsRepliesPolicy: z([
			t.software === "Friendica" && (0, R.default)(t.version, "2024.12.0"),
			t.software === V,
			t.software === H,
			t.software === "Mastodon" && (0, R.default)(t.version, "3.3.0"),
			t.software === q,
			t.software === "Takahe" && (0, R.default)(t.version, "0.12.0")
		]),
		loadActivities: t.software === "Mitra" && (0, R.default)(t.version, "2.16.0"),
		loadConversation: t.software === "Mitra" && (0, R.default)(t.version, "2.25.0"),
		localOnlyStatuses: n && z([t.software === "GoToSocial", t.software === "Mastodon" && t.build === "hometown"]),
		logInWithUsername: z([
			t.software === Z,
			t.software === W,
			t.software === K,
			t.software === Y,
			t.software === Vt
		]),
		manageAccountAliases: z([t.software === Z, t.software === Y]),
		manageMfa: z([
			t.software === Z,
			t.software === W,
			t.software === Y,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.19.0")
		]),
		manageMfaBackupCodes: z([t.software === Z, t.software === Y]),
		manageMfaRequiresPassword: z([t.software === Z, t.software === Y]),
		mastodonAdmin: z([
			t.software === V,
			t.software === G,
			e.api_versions["mastodon_admin_api.pleroma.pl-api"] >= 1
		]),
		mastodonAdminResolveReportWithComment: t.software === V,
		mastodonAdminMetrics: t.software === "Mastodon" && (0, R.default)(t.version, "3.5.0"),
		mastodonAdminUnresolvedReports: z([t.software === "GoToSocial" && (0, R.default)(t.version, "0.22.0"), e.api_versions["mastodon_admin_api.pleroma.pl-api"] >= 1]),
		mastodonAdminV2: z([
			t.software === V,
			t.software === "Mastodon" && (0, R.default)(t.version, "3.5.0"),
			e.api_versions["mastodon_admin_api.pleroma.pl-api"] >= 1
		]),
		mediaV2: z([
			t.software === Z,
			t.software === B,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === K,
			t.software === q,
			t.software === Y,
			t.software === zt,
			t.software === Vt,
			t.software === Ht,
			t.software === Ut
		]),
		multiLanguage: e.api_versions["multi_language.pleroma.pl-api"] >= 1,
		mutedThreads: t.software === W,
		muteStrangers: z([t.software === Z, t.software === Y]),
		mutes: z([
			t.software === Z,
			t.software === B,
			t.software === Lt,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.16.0"),
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === K,
			t.software === q,
			t.software === J,
			t.software === Y,
			t.software === X,
			t.software === zt
		]),
		mutesDuration: z([
			t.software === Z,
			t.software === B,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.16.0"),
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === q,
			t.software === Y,
			t.software === zt
		]),
		notes: z([
			t.software === Z,
			t.software === V,
			t.software === W,
			t.software === G,
			t.software === "Pleroma" && (0, R.default)(t.version, "2.5.0")
		]),
		notificationsDismissMultiple: z([t.software === Z, t.software === Y]),
		notificationsExcludeTypes: t.software !== K,
		notificationsExcludeVisibilities: z([t.software === Z, t.software === Y]),
		notificationsGetUnreadCount: e.api_versions.mastodon >= 1,
		notificationsIncludeTypes: z([
			t.software === Z,
			t.software === B,
			t.software === V,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === q,
			t.software === "Pleroma" && (0, R.default)(t.version, "2.5.0"),
			t.software === "Takahe" && (0, R.default)(t.version, "0.6.2")
		]),
		notificationsPolicy: e.api_versions.mastodon >= 1,
		notificationsMarkRead: z([t.software === Z, t.software === Y]),
		notificationsPolicyForBots: e.api_versions.mastodon >= 11,
		notificationsRequestsAcceptMultiple: e.api_versions.mastodon >= 1,
		outgoingFollowRequests: z([
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.20.0"),
			t.software === W,
			t.software === "Mitra" && (0, R.default)(t.version, "4.19.0"),
			e.api_versions["outgoing_follow_requests.pleroma.pl-api"] >= 1
		]),
		pleromaAdminAccounts: z([t.software === Z, t.software === Y]),
		pleromaAdminAnnouncements: z([t.software === Z, t.software === Y]),
		pleromaAdminConfig: z([t.software === Z, t.software === Y]),
		pleromaAdminInvites: z([t.software === Z, t.software === Y]),
		pleromaAdminModerationLog: z([t.software === Z, t.software === Y]),
		pleromaAdminRelays: z([t.software === Z, t.software === Y]),
		pleromaAdminStatuses: z([t.software === Z, t.software === Y]),
		pleromaAdminStatusesRedact: e.api_versions["admin_statuses_redact.pleroma.pl-api"] >= 1,
		pleromaRemoteFollow: z([t.software === Z, t.software === Y]),
		polls: z([
			t.software === B,
			t.software === V,
			t.software === H,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === "Mitra" && (0, R.default)(t.version, "3.15.0"),
			t.software === q,
			t.software === X,
			t.software === "snac" && (0, R.default)(t.version, "2.90.0"),
			t.software === "Takahe" && (0, R.default)(t.version, "0.8.0"),
			e.api_versions["polls.pleroma.pl-api"] >= 1
		]),
		postLanguages: z([
			t.software === Z,
			t.software === V,
			t.software === H,
			t.software === G,
			t.software === "Mitra" && (0, R.default)(t.version, "3.23.0"),
			t.software === "Pleroma" && (0, R.default)(t.version, "2.9.0"),
			t.software === "snac" && (0, R.default)(t.version, "2.82.0"),
			t.software === X,
			t.software === Ht
		]),
		preferredFrontends: t.software === Z,
		privacyScopes: !0,
		profileDirectory: z([
			t.software === Lt,
			t.software === G,
			t.software === K,
			e.api_versions["profile_directory.pleroma.pl-api"] >= 1
		]),
		profileFields: z([
			t.software === Z,
			t.software === V,
			t.software === H,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === K,
			t.software === q,
			t.software === Y,
			t.software === X,
			t.software === Rt,
			t.software === "Takahe" && (0, R.default)(t.version, "0.7.0")
		]),
		publicFavourites: z([t.software === Z, t.software === Y]),
		publicTimeline: z([
			t.software === Z,
			t.software === B,
			t.software === Lt,
			t.software === V,
			t.software === H,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === K,
			t.software === q,
			t.software === Y,
			t.software === X,
			t.software === Rt,
			t.software === zt,
			t.software === Vt,
			t.software === Ht,
			t.software === Ut
		]),
		quotePosts: z([
			t.software === W,
			t.software === "Friendica" && (0, R.default)(t.version, "2023.3.0"),
			t.software === X,
			e.api_versions.mastodon >= 7,
			e.api_versions["quote_posting.pleroma.pl-api"] >= 1,
			e.feature_quote === !0
		]),
		quoteApprovalPolicies: e.api_versions.mastodon >= 7,
		reblogVisibility: z([
			t.software === Z,
			t.software === W,
			t.software === G,
			t.software === Y,
			t.software === Ht
		]),
		remoteInteractions: z([t.software === Z, t.software === "Pleroma" && (0, R.default)(t.version, "2.5.0")]),
		removeFromFollowers: z([
			t.software === Z,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.23.0"),
			t.software === W,
			t.software === G,
			t.software === "Mitra" && (0, R.default)(t.version, "2.17.0"),
			t.software === "Pleroma" && (0, R.default)(t.version, "2.5.0")
		]),
		reportForwarding: t.software !== W,
		resetPassword: z([t.software === Z, t.software === Y]),
		richText: z([
			t.software === Z,
			t.software === V,
			t.software === "Mastodon" && t.build === "glitch",
			t.software === Y,
			t.software === K,
			e.pleroma.metadata.post_formats.filter((e) => e !== "text/plain").length > 0
		]),
		rssFeeds: z([
			t.software === Z,
			t.software === V,
			t.software === "Iceshrimp.NET" && (0, R.default)(t.version, "2026.1.0"),
			t.software === G,
			t.software === Y
		]),
		rssFeedSubscriptions: e.api_versions["rss_feed_subscriptions.pleroma.pl-api"] >= 1,
		scheduledReblogs: z([e.api_versions["net.iceshrimp.scheduled_boosts"] >= 1]),
		scheduledStatuses: z([
			t.software === Z,
			t.software === B,
			t.software === Lt,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.18.0"),
			t.software === G,
			t.software === Y,
			e.api_versions["net.iceshrimp.scheduled_boosts"] >= 1
		]),
		scheduledStatusesBackwards: z([t.software === "GoToSocial" && (0, R.default)(t.version, "0.18.0"), e.api_versions["backwards_schedule_at.pleroma.pl-api"] >= 1]),
		scrobbles: t.software === Y,
		searchFromAccount: z([
			t.software === Z,
			t.software === V,
			t.software === U,
			t.software === W,
			t.software === G,
			t.software === Y
		]),
		sessions: z([
			t.software === Z,
			t.software === "GoToSocial" && (0, R.default)(t.version, "0.18.2"),
			t.software === W,
			t.software === "Mitra" && (0, Pt.default)(t.version, "4.13.1"),
			t.software === Y
		]),
		shoutbox: e.api_versions["shout.pleroma.pl-api"] >= 1,
		spoilers: t.software !== K,
		statusDislikes: t.software === "Friendica" && (0, R.default)(t.version, "2023.3.0"),
		statusLocation: e.api_versions["status_location.pleroma.pl-api"] >= 1,
		stories: t.software === J,
		subscriptions: t.software === K,
		suggestions: z([
			t.software === Lt,
			t.software === U,
			t.software === G,
			t.software === J,
			e.api_versions["v2_suggestions.pleroma.pl-api"] >= 1
		]),
		suggestionsDismiss: z([t.software === G]),
		suggestionsV2: z([
			t.software === Lt,
			t.software === U,
			t.software === G,
			t.software === X,
			e.api_versions["v2_suggestions.pleroma.pl-api"] >= 1
		]),
		translations: z([
			e.api_versions["translation.pleroma.pl-api"] >= 1,
			e.api_versions["machine_translation.akkoma.pl-api"] >= 1,
			e.configuration.translation.enabled
		]),
		trendingLinks: z([t.software === "Mastodon" && (0, R.default)(t.compatVersion, "3.5.0"), t.software === q]),
		trendingStatuses: z([
			t.software === B,
			t.software === "Friendica" && (0, R.default)(t.version, "2022.12.0"),
			t.software === U,
			t.software === G,
			t.software === q,
			t.software === J,
			t.software === X
		]),
		trendingStatusesRange: t.software === J,
		trends: z([
			t.software === B,
			t.software === "Friendica" && (0, R.default)(t.version, "2022.12.0"),
			t.software === U,
			t.software === G,
			t.software === q,
			t.software === J,
			t.software === X,
			t.software === "Takahe" && (0, R.default)(t.version, "0.12.0")
		]),
		unrestrictedLists: z([
			t.software === Z,
			t.software === Y,
			t.software === Rt
		]),
		wrenchedTimeline: e.api_versions["wrenched_timeline.pleroma.pl-api"] >= 1
	};
}, Jt = (e) => {
	let t = /^([\w+.-]*)(?: \(compatible; ([\w.]*) (.*)\))?$/.exec(e.replace("/", " ")), n = t && (t[3] || t[1]), r = t ? (0, Ft.default)(n) || (0, Nt.default)(n, { loose: !0 }) : null, i = t ? (0, Ft.default)(t[1]) || (0, Nt.default)(t[1]) : null;
	return t && r && i ? {
		build: r.build[0]?.split("-")[0],
		compatVersion: i.version,
		software: t[2] || "Mastodon",
		version: r.version.split("-")[0]
	} : {
		build: null,
		compatVersion: "0.0.0",
		software: null,
		version: "0.0.0"
	};
}, Yt = /* @__PURE__ */ l((/* @__PURE__ */ o(((e, t) => {
	var n = /^utf-?8|ascii|utf-?16-?le|ucs-?2|base-?64|latin-?1$/i, r = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, i = /\s|\uFEFF|\xA0/, a = /\r?\n[\x20\x09]+/g, o = /[;,"]/, s = /[;,"]|\s/, c = /^[!#$%&'*+\-\.^_`|~\da-zA-Z]+$/, l = {
		IDLE: 1,
		URI: 2,
		ATTR: 4
	};
	function u(e) {
		return e.replace(r, "");
	}
	function d(e) {
		return i.test(e);
	}
	function ee(e, t) {
		for (; d(e[t]);) t++;
		return t;
	}
	function f(e) {
		return s.test(e) || !c.test(e);
	}
	function p(e, t) {
		return Object.keys(e).length === Object.keys(t).length && Object.keys(e).every((n) => n in t && e[n] === t[n]);
	}
	var m = class e {
		constructor(e) {
			this.refs = [], e && this.parse(e);
		}
		rel(e) {
			for (var t = [], n = e.toLowerCase(), r = 0; r < this.refs.length; r++) typeof this.refs[r].rel == "string" && this.refs[r].rel.toLowerCase() === n && t.push(this.refs[r]);
			return t;
		}
		get(e, t) {
			e = e.toLowerCase(), t = t.toLowerCase();
			for (var n = [], r = 0; r < this.refs.length; r++) typeof this.refs[r][e] == "string" && this.refs[r][e].toLowerCase() === t && n.push(this.refs[r]);
			return n;
		}
		set(e) {
			return this.refs.push(e), this;
		}
		setUnique(e) {
			return this.refs.some((t) => p(t, e)) || this.refs.push(e), this;
		}
		has(e, t) {
			e = e.toLowerCase(), t = t.toLowerCase();
			for (var n = 0; n < this.refs.length; n++) if (typeof this.refs[n][e] == "string" && this.refs[n][e].toLowerCase() === t) return !0;
			return !1;
		}
		parse(t, n) {
			n ||= 0, t = n ? t.slice(n) : t, t = u(t).replace(a, "");
			for (var r = l.IDLE, i = t.length, n = 0, s = null; n < i;) if (r === l.IDLE) {
				if (d(t[n])) {
					n++;
					continue;
				}
				if (t[n] === "<") {
					s != null && (s.rel == null ? this.refs.push(s) : this.refs.push(...e.expandRelations(s)));
					var c = t.indexOf(">", n);
					if (c === -1) throw Error("Expected end of URI delimiter at offset " + n);
					s = { uri: t.slice(n + 1, c) }, n = c, r = l.URI;
				} else throw Error("Unexpected character \"" + t[n] + "\" at offset " + n);
				n++;
			} else if (r === l.URI) {
				if (d(t[n])) {
					n++;
					continue;
				}
				if (t[n] === ";") r = l.ATTR, n++;
				else if (t[n] === ",") r = l.IDLE, n++;
				else throw Error("Unexpected character \"" + t[n] + "\" at offset " + n);
			} else if (r === l.ATTR) {
				if (t[n] === ";" || d(t[n])) {
					n++;
					continue;
				}
				var c = t.indexOf("=", n);
				c === -1 && (c = t.indexOf(";", n)), c === -1 && (c = t.length);
				var f = u(t.slice(n, c)).toLowerCase(), p = "";
				if (n = c + 1, n = ee(t, n), t[n] === "\"") for (n++; n < i;) {
					if (t[n] === "\"") {
						n++;
						break;
					}
					t[n] === "\\" && n++, p += t[n], n++;
				}
				else {
					for (var c = n + 1; !o.test(t[c]) && c < i;) c++;
					p = t.slice(n, c), n = c;
				}
				switch (s[f] && e.isSingleOccurenceAttr(f) || (f[f.length - 1] === "*" ? s[f] = e.parseExtendedValue(p) : (p = f === "type" ? p.toLowerCase() : p, s[f] == null ? s[f] = p : Array.isArray(s[f]) ? s[f].push(p) : s[f] = [s[f], p])), t[n]) {
					case ",":
						r = l.IDLE;
						break;
					case ";": r = l.ATTR;
				}
				n++;
			} else throw Error("Unknown parser state \"" + r + "\"");
			return s != null && (s.rel == null ? this.refs.push(s) : this.refs.push(...e.expandRelations(s))), s = null, this;
		}
		toString() {
			for (var t = [], n = "", r = null, i = 0; i < this.refs.length; i++) r = this.refs[i], n = Object.keys(this.refs[i]).reduce(function(t, n) {
				return n === "uri" ? t : t + "; " + e.formatAttribute(n, r[n]);
			}, "<" + r.uri + ">"), t.push(n);
			return t.join(", ");
		}
	};
	m.isCompatibleEncoding = function(e) {
		return n.test(e);
	}, m.parse = function(e, t) {
		return new m().parse(e, t);
	}, m.isSingleOccurenceAttr = function(e) {
		return e === "rel" || e === "type" || e === "media" || e === "title" || e === "title*";
	}, m.isTokenAttr = function(e) {
		return e === "rel" || e === "type" || e === "anchor";
	}, m.escapeQuotes = function(e) {
		return e.replace(/"/g, "\\\"");
	}, m.expandRelations = function(e) {
		return e.rel.split(" ").map(function(t) {
			var n = Object.assign({}, e);
			return n.rel = t, n;
		});
	}, m.parseExtendedValue = function(e) {
		var t = /([^']+)?(?:'([^']*)')?(.+)/.exec(e);
		return {
			language: t[2].toLowerCase(),
			encoding: m.isCompatibleEncoding(t[1]) ? null : t[1].toLowerCase(),
			value: m.isCompatibleEncoding(t[1]) ? decodeURIComponent(t[3]) : t[3]
		};
	}, m.formatExtendedAttribute = function(e, t) {
		var n = (t.encoding || "utf-8").toUpperCase(), r = t.language || "en", i = "";
		return i = typeof Buffer < "u" && Buffer.isBuffer(t.value) && m.isCompatibleEncoding(n) ? t.value.toString(n) : typeof Buffer < "u" && Buffer.isBuffer(t.value) ? t.value.toString("hex").replace(/[0-9a-f]{2}/gi, "%$1") : encodeURIComponent(t.value), e + "=" + n + "'" + r + "'" + i;
	}, m.formatAttribute = function(e, t) {
		return Array.isArray(t) ? t.map((t) => m.formatAttribute(e, t)).join("; ") : e[e.length - 1] === "*" || typeof t != "string" ? m.formatExtendedAttribute(e, t) : (m.isTokenAttr(e) ? t = f(t) ? "\"" + m.escapeQuotes(t) + "\"" : m.escapeQuotes(t) : f(t) && (t = encodeURIComponent(t), t = t.replace(/%20/g, " ").replace(/%2C/g, ",").replace(/%3B/g, ";"), t = "\"" + t + "\""), e + "=" + t);
	}, t.exports = m;
})))(), 1);
function Xt(e) {
	return e === void 0;
}
function Zt(e) {
	return e === null;
}
function Qt(e) {
	return typeof e == "boolean";
}
function $t(e) {
	return typeof e == "symbol";
}
function en(e) {
	return e === Object(e);
}
function tn(e) {
	return Array.isArray(e);
}
function nn(e) {
	if (!en(e)) return !1;
	try {
		return Date.prototype.getTime.call(e), !0;
	} catch {
		return !1;
	}
}
function rn(e, t) {
	if (t) return en(e) && !Xt(e.uri);
	if (!en(e) || typeof e.size != "number" || typeof e.type != "string" || typeof e.slice != "function") return !1;
	if (typeof Blob > "u" || e instanceof Blob) return !0;
	try {
		return Blob.prototype.slice.call(e, 0, 0), !0;
	} catch {
		return !1;
	}
}
function an(e, t) {
	return typeof File < "u" && e instanceof File || rn(e, t) && typeof e.name == "string" && (en(e.lastModifiedDate) || typeof e.lastModified == "number");
}
function on(e, t, n, r, i, a) {
	t ||= {}, n ||= new FormData(), i ||= /* @__PURE__ */ new WeakSet();
	let o = typeof n.getParts == "function", s = nn(e), c = tn(e) || en(e) && !s && !rn(e, o);
	if (c) {
		if (i.has(e)) throw TypeError("Cannot serialize circular structure");
		i.add(e);
	}
	if (Xt(e) || $t(e)) return n;
	if (Zt(e)) t.nullsAsUndefineds || n.append(r, "");
	else if (Qt(e)) t.booleansAsIntegers ? n.append(r, +!!e) : n.append(r, e);
	else if (tn(e)) {
		let s = arguments.length > 5 ? a : r;
		e.length ? e.forEach((e, a) => {
			let c = r + "[" + (t.indices ? a : "") + "]", l = an(e, o);
			t.noFilesWithArrayNotation && l ? c = s : t.noAttributesWithArrayNotation && !l && (c = r), on(e, t, n, c, i, tn(e) ? s : void 0);
		}) : t.allowEmptyArrays && n.append(t.noAttributesWithArrayNotation ? r : r + "[]", "");
	} else s ? n.append(r, e.toISOString()) : en(e) && !rn(e, o) ? Object.keys(e).forEach((a) => {
		let o = e[a];
		if (tn(o)) for (; a.length > 2 && a.lastIndexOf("[]") === a.length - 2;) a = a.substring(0, a.length - 2);
		let s = r ? t.dotsForObjectNotation ? r + "." + a : r + "[" + a + "]" : a;
		on(o, t, n, s, i);
	}) : n.append(r, e);
	return c && i.delete(e), n;
}
//#endregion
//#region ../../node_modules/.pnpm/decode-uri-component@0.5.0/node_modules/decode-uri-component/index.js
var sn = /* @__PURE__ */ RegExp("(%[a-f0-9]{2})+", "gi"), cn = /^[a-f\d]{2}$/i;
function ln(e, t) {
	if (e.codePointAt(t) !== 37 || t + 3 > e.length) return;
	let n = e.slice(t + 1, t + 3);
	if (cn.test(n)) return {
		byte: Number.parseInt(n, 16),
		next: t + 3
	};
}
function un(e) {
	return e <= 127 ? 1 : e >= 194 && e <= 223 ? 2 : e >= 224 && e <= 239 ? 3 : e >= 240 && e <= 244 ? 4 : 0;
}
function dn(e) {
	return e >= 128 && e <= 191;
}
function fn(e) {
	try {
		return decodeURIComponent(e);
	} catch {
		let t = "", n = 0;
		for (; n < e.length;) {
			if (e.codePointAt(n) !== 37) {
				t += e.charAt(n), n++;
				continue;
			}
			let r = ln(e, n);
			if (!r) {
				t += e.charAt(n), n++;
				continue;
			}
			let i = un(r.byte);
			if (i === 0) {
				t += e.slice(n, n + 3), n += 3;
				continue;
			}
			let a = r.next, o = !0;
			for (let t = 1; t < i; t++) {
				let t = ln(e, a);
				if (!t || !dn(t.byte)) {
					o = !1;
					break;
				}
				a = t.next;
			}
			if (o) {
				let r = e.slice(n, a);
				try {
					t += decodeURIComponent(r), n = a;
					continue;
				} catch {}
			}
			t += e.slice(n, n + 3), n += 3;
		}
		return t;
	}
}
function pn(e) {
	let t = {
		"%FE%FF": "��",
		"%FF%FE": "��"
	}, n = sn.exec(e);
	for (; n;) {
		try {
			t[n[0]] = decodeURIComponent(n[0]);
		} catch {
			let e = fn(n[0]);
			e !== n[0] && (t[n[0]] = e);
		}
		n = sn.exec(e);
	}
	t["%C2"] = "�";
	let r = Object.keys(t);
	for (let n of r) e = e.replace(new RegExp(n, "g"), t[n]);
	return e;
}
function mn(e) {
	if (typeof e != "string") throw TypeError(`Expected \`encodedURI\` to be of type \`string\`, got \`${typeof e}\``);
	try {
		return decodeURIComponent(e);
	} catch {
		return pn(e);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/filter-obj@5.1.0/node_modules/filter-obj/index.js
function hn(e, t) {
	let n = {};
	if (Array.isArray(t)) for (let r of t) {
		let t = Object.getOwnPropertyDescriptor(e, r);
		t?.enumerable && Object.defineProperty(n, r, t);
	}
	else for (let r of Reflect.ownKeys(e)) {
		let i = Object.getOwnPropertyDescriptor(e, r);
		if (i.enumerable) {
			let a = e[r];
			t(r, a, e) && Object.defineProperty(n, r, i);
		}
	}
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/split-on-first@3.0.0/node_modules/split-on-first/index.js
function gn(e, t) {
	if (typeof e != "string" || typeof t != "string") throw TypeError("Expected the arguments to be of type `string`");
	if (e === "" || t === "") return [];
	let n = e.indexOf(t);
	return n === -1 ? [] : [e.slice(0, n), e.slice(n + t.length)];
}
//#endregion
//#region ../../node_modules/.pnpm/query-string@9.5.1/node_modules/query-string/base.js
var _n = /* @__PURE__ */ s({
	exclude: () => In,
	extract: () => An,
	parse: () => jn,
	parseUrl: () => Nn,
	pick: () => Fn,
	stringify: () => Mn,
	stringifyUrl: () => Pn
}), vn = (e) => e == null, yn = (e) => encodeURIComponent(e).replaceAll(/[!'()*]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), bn = Symbol("encodeFragmentIdentifier");
function xn(e) {
	switch (e.arrayFormat) {
		case "index": return (t) => (n, r) => {
			let i = n.length;
			return r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? (n.push([
				Q(t, e),
				"[",
				i,
				"]"
			].join("")), n) : (n.push([
				Q(t, e),
				"[",
				Q(i, e),
				"]=",
				Q(r, e)
			].join("")), n);
		};
		case "bracket": return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? (n.push([Q(t, e), "[]"].join("")), n) : (n.push([
			Q(t, e),
			"[]=",
			Q(r, e)
		].join("")), n);
		case "colon-list-separator": return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? (n.push([Q(t, e), ":list="].join("")), n) : (n.push([
			Q(t, e),
			":list=",
			Q(r, e)
		].join("")), n);
		case "comma":
		case "separator":
		case "bracket-separator": {
			let t = e.arrayFormat === "bracket-separator" ? "[]=" : "=";
			return (n) => (r, i) => i === void 0 || e.skipNull && i === null || e.skipEmptyString && i === "" ? r : (i = i === null ? "" : i, r.length === 0 ? (r.push([
				Q(n, e),
				t,
				Q(i, e)
			].join("")), r) : (r.push(Q(i, e)), r));
		}
		default: return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? (n.push(Q(t, e)), n) : (n.push([
			Q(t, e),
			"=",
			Q(r, e)
		].join("")), n);
	}
}
function Sn(e) {
	let t;
	switch (e.arrayFormat) {
		case "index": return (e, n, r) => {
			t = /\[(\d*)]$/.exec(e), e = e.replace(/\[\d*]$/, ""), t ? (r[e] === void 0 && (r[e] = {}), r[e][t[1]] = n) : r[e] = n;
		};
		case "bracket": return (e, n, r) => {
			t = /(\[])$/.exec(e), e = e.replace(/\[]$/, ""), t ? r[e] === void 0 ? r[e] = [n] : Array.isArray(r[e]) ? r[e].push(n) : r[e] = [r[e], n] : r[e] = n;
		};
		case "colon-list-separator": return (e, n, r) => {
			t = /(:list)$/.exec(e), e = e.replace(/:list$/, ""), t ? r[e] === void 0 ? r[e] = [n] : Array.isArray(r[e]) ? r[e].push(n) : r[e] = [r[e], n] : r[e] = n;
		};
		case "comma":
		case "separator": return (t, n, r) => {
			r[t] = typeof n == "string" && n.includes(e.arrayFormatSeparator) ? n.split(e.arrayFormatSeparator).map((t) => wn(t, e)) : n === null ? n : wn(n, e);
		};
		case "bracket-separator": return (t, n, r) => {
			let i = /(\[])$/.test(t);
			if (t = t.replace(/\[]$/, ""), !i) {
				r[t] = n && wn(n, e);
				return;
			}
			let a = n === null ? [] : wn(n, e).split(e.arrayFormatSeparator);
			if (r[t] === void 0) r[t] = a;
			else {
				Array.isArray(r[t]) || (r[t] = [r[t]]);
				for (let e of a) r[t].push(e);
			}
		};
		default: return (e, t, n) => {
			n[e] === void 0 ? n[e] = t : Array.isArray(n[e]) ? n[e].push(t) : n[e] = [n[e], t];
		};
	}
}
function Cn(e) {
	if (typeof e != "string" || e.length !== 1) throw TypeError("arrayFormatSeparator must be single character string");
}
function Q(e, t) {
	return t.encode ? t.strict ? yn(e) : encodeURIComponent(e) : e;
}
function wn(e, t) {
	return t.decode ? mn(e) : e;
}
function Tn(e) {
	return Array.isArray(e) ? e.sort() : typeof e == "object" ? Tn(Object.keys(e)).sort((e, t) => Number(e) - Number(t)).map((t) => e[t]) : e;
}
function En(e) {
	let t = e.indexOf("#");
	return t !== -1 && (e = e.slice(0, t)), e;
}
function Dn(e) {
	let t = "", n = e.indexOf("#");
	return n !== -1 && (t = e.slice(n)), t;
}
function On(e) {
	let t = e.indexOf("?");
	return t === -1 ? e : e.slice(0, t);
}
function kn(e, t, n) {
	return n === "string" && typeof e == "string" ? e : typeof n == "function" && typeof e == "string" ? n(e) : n === "boolean" && e === null ? !0 : n === "boolean" && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") ? e.toLowerCase() === "true" : n === "boolean" && e !== null && (e.toLowerCase() === "1" || e.toLowerCase() === "0") ? e.toLowerCase() === "1" : n === "string[]" && t.arrayFormat !== "none" && typeof e == "string" ? [e] : n === "number[]" && t.arrayFormat !== "none" && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? [Number(e)] : n === "number" && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? Number(e) : t.parseBooleans && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") ? e.toLowerCase() === "true" : t.parseNumbers && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? Number(e) : e;
}
function An(e) {
	e = En(e);
	let t = e.indexOf("?");
	return t === -1 ? "" : e.slice(t + 1);
}
function jn(e, t) {
	t = {
		decode: !0,
		sort: !0,
		arrayFormat: "none",
		arrayFormatSeparator: ",",
		parseNumbers: !1,
		parseBooleans: !1,
		types: Object.create(null),
		...t
	}, Cn(t.arrayFormatSeparator);
	let n = Sn(t), r = Object.create(null);
	if (typeof e != "string" || (e = e.trim().replace(/^[?#&]/, ""), !e) || /^&+$/.test(e)) return r;
	let i = 0, a = e.indexOf("&");
	a === -1 && (a = e.length);
	for (let o = a; o <= e.length; o++) {
		if (o < e.length && e[o] !== "&") continue;
		if (o === i) {
			i = o + 1;
			continue;
		}
		let a = e.slice(i, o), s = t.decode ? a.replaceAll("+", " ") : a, [c, l] = gn(s, "=");
		c === void 0 && (c = s), l = l === void 0 ? null : [
			"comma",
			"separator",
			"bracket-separator"
		].includes(t.arrayFormat) ? l : wn(l, t), n(wn(c, t), l, r), i = o + 1;
	}
	for (let [e, n] of Object.entries(r)) if (typeof n == "object" && n && t.types[e] !== "string") for (let [r, i] of Object.entries(n)) {
		let a = t.types[e], o = typeof a == "function" ? a : a ? a.replace("[]", "") : void 0;
		n[r] = kn(i, t, o);
	}
	else r[e] = typeof n == "object" && n && t.types[e] === "string" ? Object.values(n).join(t.arrayFormatSeparator) : kn(n, t, t.types[e]);
	return t.sort === !1 ? r : (t.sort === !0 ? Object.keys(r).sort() : Object.keys(r).sort(t.sort)).reduce((e, t) => {
		let n = r[t];
		return e[t] = n && typeof n == "object" && !Array.isArray(n) ? Tn(n) : n, e;
	}, Object.create(null));
}
function Mn(e, t) {
	if (!e) return "";
	t = {
		encode: !0,
		strict: !0,
		arrayFormat: "none",
		arrayFormatSeparator: ",",
		...t
	}, Cn(t.arrayFormatSeparator);
	let n = (n) => t.skipNull && vn(e[n]) || t.skipEmptyString && e[n] === "", r = xn(t), i = {};
	for (let [t, r] of Object.entries(e)) n(t) || (i[t] = r);
	let a = Object.keys(i);
	return t.sort !== !1 && a.sort(t.sort), a.map((n) => {
		let i = e[n];
		if (t.replacer && (i = t.replacer(n, i), i === void 0) || i === void 0) return "";
		if (i === null) return Q(n, t);
		if (Array.isArray(i)) {
			if (i.length === 0 && t.arrayFormat === "bracket-separator") return Q(n, t) + "[]";
			let e = i;
			t.replacer && (e = i.map((e, r) => t.replacer(`${n}[${r}]`, e)).filter((e) => e !== void 0));
			let a = e.reduce(r(n), []), o = [
				"comma",
				"separator",
				"bracket-separator"
			].includes(t.arrayFormat) ? t.arrayFormatSeparator : "&";
			return a.join(o);
		}
		return Q(n, t) + "=" + Q(i, t);
	}).filter((e) => e.length > 0).join("&");
}
function Nn(e, t) {
	t = {
		decode: !0,
		...t
	};
	let [n, r] = gn(e, "#");
	return n === void 0 && (n = e), {
		url: On(n ?? ""),
		query: jn(An(e), t),
		...t && t.parseFragmentIdentifier && r ? { fragmentIdentifier: wn(r, t) } : {}
	};
}
function Pn(e, t) {
	t = {
		encode: !0,
		strict: !0,
		[bn]: !0,
		...t
	};
	let n = On(En(e.url)) || "", r = Mn({
		...jn(An(e.url), {
			sort: !1,
			...t
		}),
		...e.query
	}, t);
	r &&= `?${r}`;
	let i = Dn(e.url);
	if (typeof e.fragmentIdentifier == "string" && (i = `#${e.fragmentIdentifier}`, t[bn])) {
		let e = new URL("https://query-string.invalid");
		e.hash = i, i = e.hash;
	}
	return `${n}${r}${i}`;
}
function Fn(e, t, n) {
	n = {
		parseFragmentIdentifier: !0,
		[bn]: !1,
		...n
	};
	let { url: r, query: i, fragmentIdentifier: a } = Nn(e, n);
	return Pn({
		url: r,
		query: hn(i, t),
		fragmentIdentifier: a
	}, n);
}
function In(e, t, n) {
	if (Array.isArray(t)) {
		let r = new Set(t);
		return Fn(e, (e) => !r.has(e), n);
	}
	return Fn(e, (e, n) => !t(e, n), n);
}
//#endregion
//#region ../../node_modules/.pnpm/query-string@9.5.1/node_modules/query-string/index.js
var Ln = _n, Rn = (e) => /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e), zn = (e, t) => t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e, Bn = (e, t, n) => {
	let r = t && !Rn(e) ? zn(t, e) : e;
	if (n && Object.entries(n).length) {
		let { url: e, query: t } = Ln.parseUrl(r);
		return `${e}?${Ln.stringify({
			...t,
			...n
		}, { arrayFormat: "bracket" })}`;
	}
	return r;
}, Vn = class extends Error {
	response;
	constructor(e, t) {
		super(t || `Request failed with status ${e.status}`), this.name = "PlApiError", this.response = e;
	}
	get status() {
		return this.response.status;
	}
	get json() {
		return this.response.json;
	}
}, Hn = (e) => {
	let t = e.headers?.get("link"), n = t && new Yt.default(t) || null;
	return {
		next: n?.refs.find((e) => e.rel.toLocaleLowerCase() === "next")?.uri || null,
		prev: n?.refs.find((e) => e.rel.toLocaleLowerCase() === "prev")?.uri || null
	};
}, Un = (e) => "id" in e && "retry" in e, Wn = (e) => {
	let t = e.headers.get("mastodon-async-refresh");
	if (!t) return null;
	let n = {};
	return t.split(/,\s*/).forEach((e) => {
		let [t, r] = e.split("=", 2), i;
		t && ["id", "retry"].includes(t) && r && (i = r.startsWith("\"") ? r.slice(1, -1) : parseInt(r, 10), n[t] = i);
	}), Un(n) ? n : null;
}, Gn = (e) => {
	let t = new Headers();
	for (let n of e.trim().split(/[\r\n]+/)) if (n.indexOf(":") !== -1) try {
		let e = n.split(": "), r = e.shift(), i = e.join(": ");
		if (!r) continue;
		t.append(r, i);
	} catch {}
	return t;
};
function Kn(e, { body: t, method: n = t ? "POST" : "GET", params: r, onUploadProgress: i, signal: a, contentType: o, formData: s, idempotencyKey: c } = {}) {
	e = e.toString();
	let l = Bn(e, this.baseURL, r), u = new Headers();
	return e.startsWith("/api/iceshrimp/") && this.iceshrimpAccessToken ? u.set("Authorization", `Bearer ${this.iceshrimpAccessToken}`) : this.accessToken ? u.set("Authorization", `Bearer ${this.accessToken}`) : this.customAuthorizationToken && u.set("Authorization", this.customAuthorizationToken), (!s && t || o) && u.set("Content-Type", o || "application/json"), c && u.set("Idempotency-Key", c), t = t && s ? on(t, { indices: !0 }) : JSON.stringify(t), i ? new Promise((e, r) => {
		let a = new XMLHttpRequest();
		a.upload.addEventListener("progress", i), a.addEventListener("loadend", () => {
			let t = a.response, n;
			if (a.getResponseHeader("content-type")?.match(/(text|application)\/json/)) try {
				n = JSON.parse(t);
			} catch {}
			a.status >= 400 ? r(new Vn({
				status: a.status,
				statusText: a.statusText,
				url: a.responseURL,
				data: t,
				json: n,
				headers: Gn(a.getAllResponseHeaders()),
				ok: a.status >= 200 && a.status < 300,
				redirected: !1,
				type: "default"
			})) : e({
				status: a.status,
				data: t,
				json: n
			});
		}), a.open(n, l, !0), u.forEach((e, t) => a.setRequestHeader(t, e)), a.responseType = "text", a.send(t);
	}) : fetch(l, {
		method: n,
		headers: u,
		body: t,
		signal: a
	}).then(async (e) => {
		let t = await e.text(), n;
		if (e.headers.get("content-type")?.match(/(text|application)\/json/)) try {
			n = JSON.parse(t);
		} catch {}
		let { headers: r, ok: i, redirected: a, status: o, statusText: s, type: c, url: l } = e, u = {
			headers: r,
			ok: i,
			redirected: a,
			status: o,
			statusText: s,
			type: c,
			url: l,
			data: t,
			json: n
		};
		if (!i) throw new Vn(u);
		return u;
	});
}
//#endregion
//#region lib/responses.ts
var qn = class {
	items;
	previous;
	next;
	total;
	partial;
	constructor(e, t = {}) {
		this.items = e, this.previous = t.previous ?? null, this.next = t.next ?? null, this.total = t.total, this.partial = t.partial ?? !1;
	}
}, Jn = class {
	baseURL;
	#e;
	#t;
	#n;
	#r = j(xt, {});
	request = Kn.bind(this);
	features = qt(this.#r);
	socket;
	shoutSocket;
	constructor(e, t, n = {}) {
		this.baseURL = e, this.#e = t, this.#n = n.customAuthorizationToken, n.instance && this.setInstance(n.instance);
	}
	paginatedGet = async (e, t, n, r = !0) => {
		let i = r ? F(n) : n, a = (e) => {
			let { prev: t, next: n } = Hn(e);
			return new qn(j(i, e.json), {
				previous: o(t),
				next: o(n),
				partial: e.status === 206
			});
		}, o = (e) => e ? () => this.request(e).then(a) : null;
		return a(await this.request(e, t));
	};
	setInstance = (e) => {
		let t = this.#r.configuration.urls.streaming !== e.configuration.urls.streaming, n = this.features.version.software;
		this.#r = e, this.features = qt(this.#r), (t || n !== this.features.version.software) && this.socket?.close();
	};
	getIceshrimpAccessToken = async () => {};
	setIceshrimpAccessToken(e) {
		this.#t = e;
	}
	get accessToken() {
		return this.#e;
	}
	set accessToken(e) {
		this.#e !== e && (this.#e = e, this.socket?.close(), this.getIceshrimpAccessToken());
	}
	get iceshrimpAccessToken() {
		return this.#t;
	}
	get customAuthorizationToken() {
		return this.#n;
	}
	set customAuthorizationToken(e) {
		this.#n = e;
	}
	get instanceInformation() {
		return this.#r;
	}
}, Yn = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	action: /* @__PURE__ */ D([
		"none",
		"disable",
		"mark_statuses_as_sensitive",
		"delete_statuses",
		"sensitive",
		"silence",
		"suspend"
	]),
	text: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	status_ids: /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ k()), []),
	target_account: L,
	appeal: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ T({
		text: /* @__PURE__ */ k(),
		state: /* @__PURE__ */ D([
			"approved",
			"rejected",
			"pending"
		])
	})), null),
	created_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString())
}), Xn = /* @__PURE__ */ T({
	ip: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ fe()),
	used_at: P
}), Zn = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => "displayName" in e ? {
	id: e.id,
	account: null,
	username: e.username,
	domain: e.username.split("@")[1] || null,
	actor_type: e.isBot ? "Service" : "Person",
	display_name: e.displayName
} : e.account ? e : {
	id: e.id,
	account: null,
	username: e.nickname,
	domain: e.nickname.split("@")[1] || null,
	created_at: e.created_at,
	email: e.email,
	invite_request: e.registration_reason,
	role: e.roles?.is_admin ? j(Ge, { name: "Admin" }) : e.roles?.moderator ? j(Ge, { name: "Moderator " }) : null,
	confirmed: e.is_confirmed,
	approved: e.is_approved,
	disabled: !e.is_active,
	actor_type: e.actor_type,
	display_name: e.display_name,
	suggested: e.is_suggested
}), /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	username: /* @__PURE__ */ k(),
	domain: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	created_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString()),
	email: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	ip: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ fe())), null),
	ips: F(Xn),
	locale: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	invite_request: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	role: /* @__PURE__ */ v(/* @__PURE__ */ C(Ge), null),
	confirmed: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	approved: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	disabled: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	silenced: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	suspended: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	sensitized: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	account: /* @__PURE__ */ v(/* @__PURE__ */ C(L), null),
	created_by_application_id: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	invited_by_account_id: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	actor_type: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	display_name: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	suggested: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ x()), null)
})), Qn = /* @__PURE__ */ T({ action_id: /* @__PURE__ */ v(/* @__PURE__ */ k(), "") }), $n = /* @__PURE__ */ T({
	name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	count: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de(), /* @__PURE__ */ ge(0)), 0),
	me: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	static_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	announcement_id: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
}), er = /* @__PURE__ */ M(/* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	username: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	url: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	acct: /* @__PURE__ */ k()
}), /* @__PURE__ */ g((e) => (e.username ||= e.acct.split("@")[0], e))), tr = /* @__PURE__ */ b(/* @__PURE__ */ T({
	day: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number)),
	accounts: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number)),
	uses: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number))
})), nr = /* @__PURE__ */ T({
	name: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ g((e) => e.startsWith("#") ? e.slice(1) : e), /* @__PURE__ */ he(1)),
	url: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	history: /* @__PURE__ */ v(/* @__PURE__ */ C(tr), null),
	following: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	total: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null)
}), rr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	content: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	starts_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	ends_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	all_day: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	read: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	published_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString()),
	reactions: F($n),
	statuses: /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => Array.isArray(e) ? Object.fromEntries(e.map((e) => [e.url, e.account?.acct]) || []) : e), /* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ k())),
	mentions: F(er),
	tags: F(nr),
	emojis: F(We),
	updated_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString())
}), ir = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	...e,
	...Ie(e.pleroma, ["raw_content"])
})), /* @__PURE__ */ T({
	...rr.entries,
	raw_content: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
})), ar = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	canonical_email_hash: /* @__PURE__ */ k()
}), or = /* @__PURE__ */ T({
	period: P,
	frequency: /* @__PURE__ */ D(["day", "month"]),
	data: /* @__PURE__ */ b(/* @__PURE__ */ T({
		date: P,
		rate: /* @__PURE__ */ w(),
		value: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number))
	}))
}), sr = /* @__PURE__ */ T({
	category: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	content_type: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	disabled: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	domain: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	id: /* @__PURE__ */ k(),
	shortcode: /* @__PURE__ */ k(),
	static_url: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	total_file_size: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	updated_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	uri: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	url: /* @__PURE__ */ k(),
	visible_in_picker: /* @__PURE__ */ v(/* @__PURE__ */ x(), !0)
}), cr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	name: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
}), lr = /* @__PURE__ */ T({
	key: /* @__PURE__ */ k(),
	data: /* @__PURE__ */ b(/* @__PURE__ */ T({
		key: /* @__PURE__ */ k(),
		human_key: /* @__PURE__ */ k(),
		value: /* @__PURE__ */ k(),
		unit: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
		human_value: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0)
	}))
}), ur = /* @__PURE__ */ T({
	domain: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
	public: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	resolves: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	last_checked_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null)
}), dr = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	id: e.host,
	domain: e.host,
	is_imported: e.isImported,
	...e
})), /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	domain: /* @__PURE__ */ k(),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	is_imported: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ x()), null)
})), fr = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	id: e.host,
	domain: e.host,
	is_imported: e.isImported,
	public_comment: e.reason,
	...e
})), /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	domain: /* @__PURE__ */ k(),
	digest: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	severity: /* @__PURE__ */ v(/* @__PURE__ */ D([
		"silence",
		"suspend",
		"noop"
	]), "suspend"),
	reject_media: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	reject_reports: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	private_comment: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	public_comment: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	obfuscate: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
})), pr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	domain: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	created_by: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	accounts_policy: /* @__PURE__ */ v(/* @__PURE__ */ D(["no_action", "mute"]), "no_action"),
	follows_policy: /* @__PURE__ */ v(/* @__PURE__ */ D([
		"no_action",
		"manual_approval",
		"reject_non_mutual",
		"reject_all"
	]), "no_action"),
	media_policy: /* @__PURE__ */ v(/* @__PURE__ */ D([
		"no_action",
		"mark_sensitive",
		"reject"
	]), "no_action"),
	statuses_policy: /* @__PURE__ */ v(/* @__PURE__ */ D([
		"no_action",
		"filter_warn",
		"filter_hide"
	]), "no_action"),
	content_warning: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	public_comment: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	private_comment: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0)
}), mr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	domain: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	created_by: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	obfuscate: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	permission_type: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ D(["block", "allow"])), void 0),
	private_comment: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	public_comment: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	comment: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	severity: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	silenced_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	suspended_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	subscription_id: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0)
}), hr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	priority: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	title: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	permission_type: /* @__PURE__ */ v(/* @__PURE__ */ D(["block", "allow"]), "block"),
	as_draft: /* @__PURE__ */ v(/* @__PURE__ */ x(), !0),
	adopt_orphans: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	remove_retracted: /* @__PURE__ */ v(/* @__PURE__ */ x(), !0),
	uri: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	content_type: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	fetch_username: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	fetch_password: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	created_by: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	fetched_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	successfully_fetched_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	error: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0)
}), gr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	domain: /* @__PURE__ */ k(),
	created_at: P,
	history: /* @__PURE__ */ b(/* @__PURE__ */ T({
		day: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
		accounts: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
		uses: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String))
	}))
}), _r = /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	header: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	regex: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	created_by: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0)
}), vr = /* @__PURE__ */ T({
	error: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	time: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0)
}), yr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	domain: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	first_seen: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	latest_successful_delivery: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	software: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	delivery_errors: F(vr)
}), br = /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	token: /* @__PURE__ */ k(),
	used: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	expires_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	uses: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	max_use: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	invite_type: /* @__PURE__ */ v(/* @__PURE__ */ k(), "one_time")
}), xr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	ip: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ fe()),
	severity: /* @__PURE__ */ D([
		"sign_up_requires_approval",
		"sign_up_block",
		"no_access"
	]),
	comment: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	created_at: P,
	expires_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null)
}), Sr = /* @__PURE__ */ T({
	key: /* @__PURE__ */ k(),
	unit: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	total: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number)),
	human_value: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	previous_total: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number))), void 0),
	data: /* @__PURE__ */ b(/* @__PURE__ */ T({
		date: Ke,
		value: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number))
	}))
}), Cr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
	data: /* @__PURE__ */ v(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ y()), {}),
	time: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	message: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
}), wr = /* @__PURE__ */ T({
	configs: /* @__PURE__ */ b(/* @__PURE__ */ T({
		value: /* @__PURE__ */ y(),
		group: /* @__PURE__ */ k(),
		key: /* @__PURE__ */ k()
	})),
	need_reboot: /* @__PURE__ */ x()
}), Tr = /* @__PURE__ */ Ee({
	key: /* @__PURE__ */ E(/* @__PURE__ */ k()),
	type: /* @__PURE__ */ je([/* @__PURE__ */ k(), /* @__PURE__ */ b(/* @__PURE__ */ je([/* @__PURE__ */ k(), /* @__PURE__ */ b(/* @__PURE__ */ k())]))]),
	description: /* @__PURE__ */ E(/* @__PURE__ */ k()),
	label: /* @__PURE__ */ E(/* @__PURE__ */ k()),
	suggestions: /* @__PURE__ */ E(/* @__PURE__ */ b(/* @__PURE__ */ y())),
	children: /* @__PURE__ */ E(/* @__PURE__ */ Te(() => /* @__PURE__ */ b(Tr))),
	group: /* @__PURE__ */ E(/* @__PURE__ */ je([/* @__PURE__ */ k(), /* @__PURE__ */ b(/* @__PURE__ */ k())]))
}), Er = /* @__PURE__ */ T({
	group: /* @__PURE__ */ E(/* @__PURE__ */ k()),
	key: /* @__PURE__ */ E(/* @__PURE__ */ k()),
	type: /* @__PURE__ */ je([/* @__PURE__ */ k(), /* @__PURE__ */ b(/* @__PURE__ */ k())]),
	description: /* @__PURE__ */ E(/* @__PURE__ */ k()),
	label: /* @__PURE__ */ E(/* @__PURE__ */ k()),
	children: /* @__PURE__ */ b(Tr),
	tab: /* @__PURE__ */ E(/* @__PURE__ */ k()),
	related_policy: /* @__PURE__ */ E(/* @__PURE__ */ k())
}), Dr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	keyword: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	whole_word: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	exclude: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
}), Or = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => {
	if (!e.id) return {
		id: e.actor,
		relay_actor_uri: e.actor,
		...e
	};
	if (e.status) return {
		approved: e.status === "accepted",
		rejected: e.status === "rejected",
		relay_actor_uri: e.actor,
		...e
	};
}), /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	relay_actor_uri: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	account_id: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	approved: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	public: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	unlisted: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	match_by_default: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	ignore_sensitive: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	ignore_media: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	ignore_replies: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	matchers: F(Dr),
	followed_back: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	rejected: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
})), kr = /* @__PURE__ */ T({
	name: /* @__PURE__ */ k(),
	url: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0)
}), Ar = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	account_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	state: /* @__PURE__ */ D(["pending", "accepted"]),
	created_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString())
}), jr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	account_id: /* @__PURE__ */ k(),
	uri: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	name: /* @__PURE__ */ k(),
	description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	language: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	local: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	sensitive: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	discoverable: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	tag: /* @__PURE__ */ v(/* @__PURE__ */ C(kr), null),
	item_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	items: F(Ar),
	created_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString()),
	updated_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString())
}), Mr = /* @__PURE__ */ T({
	accounts: F(L),
	collection: jr
}), Nr = /* @__PURE__ */ T({
	count: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g((e) => e === null || isNaN(e) ? null : Number(e)))), null),
	me: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	name: qe,
	url: /* @__PURE__ */ v(/* @__PURE__ */ ke(), void 0),
	static_url: /* @__PURE__ */ v(/* @__PURE__ */ ke(), void 0),
	accounts: F(L),
	account_ids: /* @__PURE__ */ v(F(/* @__PURE__ */ k()), []),
	visible_in_picker: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0)
}), Pr = /* @__PURE__ */ T({
	...Nr.entries,
	name: /* @__PURE__ */ k(),
	url: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()),
	static_url: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _())
}), Fr = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => e ? {
	url: e.url,
	static_url: e.url,
	account_ids: e.accounts?.map((e) => e?.id),
	...e
} : null), /* @__PURE__ */ je([Nr, Pr])), Ir = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	keyword: /* @__PURE__ */ k(),
	whole_word: /* @__PURE__ */ x()
}), Lr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	status_id: /* @__PURE__ */ k()
}), Rr = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	title: /* @__PURE__ */ k(),
	context: /* @__PURE__ */ b(/* @__PURE__ */ D([
		"home",
		"notifications",
		"public",
		"thread",
		"account"
	])),
	expires_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	filter_action: /* @__PURE__ */ v(/* @__PURE__ */ D([
		"warn",
		"hide",
		"blur"
	]), "warn"),
	keywords: F(Ir),
	statuses: F(Lr)
}), zr = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => e.phrase ? {
	...e,
	title: e.phrase,
	keywords: [{
		id: "1",
		keyword: e.phrase,
		whole_word: e.whole_word
	}],
	filter_action: e.irreversible ? "hide" : "warn"
} : e), Rr), Br = /* @__PURE__ */ T({
	filter: /* @__PURE__ */ Ne(Rr, ["keywords", "statuses"]),
	keyword_matches: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	status_matches: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
}), Vr = /* @__PURE__ */ function(e) {
	return e.OWNER = "owner", e.ADMIN = "admin", e.MODERATOR = "moderator", e.USER = "user", e;
}(Vr || {}), Hr = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => e.account ? e : {
	id: e.id,
	account: e,
	role: {
		founder: "owner",
		admin: "admin",
		moderator: "moderator"
	}[e.role] || "user"
}), /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	account: L,
	role: /* @__PURE__ */ Se(Vr)
})), Ur = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	member: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	role: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ Se(Vr)), void 0),
	requested: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
}), Wr = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => {
	let t = He(e);
	return e?.config && (e = {
		display_name: e.name,
		members_count: e.member_count,
		note: e.short_description,
		relationship: e.self ? {
			...e.self,
			member: e.self.is_member,
			role: {
				founder: "owner",
				admin: "admin",
				moderator: "moderator"
			}[e.self.role] || "user",
			id: e.id
		} : null,
		...e
	}), {
		domain: t,
		...e,
		avatar: e.avatar || e.avatar_static,
		header: e.header || e.header_static,
		avatar_default: Ve(e.avatar || e.avatar_static || ""),
		header_default: ze(e.header || e.header_static || "")
	};
}), /* @__PURE__ */ T({
	avatar: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	avatar_static: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	created_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString()),
	display_name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	domain: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	emojis: F(We),
	header: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	header_static: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
	locked: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	membership_required: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	members_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	owner: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ T({ id: /* @__PURE__ */ k() })), null),
	note: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ g((e) => e === "<p></p>" ? "" : e)), ""),
	relationship: /* @__PURE__ */ v(/* @__PURE__ */ C(Ur), null),
	statuses_visibility: /* @__PURE__ */ v(/* @__PURE__ */ k(), "public"),
	uri: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	url: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	avatar_description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	header_description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	avatar_default: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	header_default: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
})), Gr = /* @__PURE__ */ D([
	"public",
	"followers",
	"following",
	"mutuals",
	"mentioned",
	"author",
	"me"
]), Kr = /* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => (e.always && (e.automatic_approval = e.always), e.with_approval && (e.manual_approval = e.with_approval), e)), /* @__PURE__ */ T({
	automatic_approval: /* @__PURE__ */ v(/* @__PURE__ */ b(Gr), ["public", "me"]),
	manual_approval: /* @__PURE__ */ v(/* @__PURE__ */ b(Gr), [])
})), {}), qr = I({
	can_favourite: Kr,
	can_reblog: Kr,
	can_reply: Kr
}), Jr = I({
	public: qr,
	unlisted: qr,
	private: qr,
	direct: qr
}), Yr = /* @__PURE__ */ "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz#$%*+,-.:;=?@[]^_{|}~".split(""), Xr = (e) => {
	let t = 0;
	for (let n = 0; n < e.length; n++) {
		let r = e[n], i = Yr.indexOf(r);
		t = t * 83 + i;
	}
	return t;
}, Zr = class extends Error {
	constructor(e) {
		super(e), this.name = "ValidationError", this.message = e;
	}
}, Qr = (e) => {
	if (!e || e.length < 6) throw new Zr("The blurhash string must be at least 6 characters");
	let t = Xr(e[0]), n = Math.floor(t / 9) + 1, r = t % 9 + 1;
	if (e.length !== 4 + 2 * r * n) throw new Zr(`blurhash length mismatch: length is ${e.length} but it should be ${4 + 2 * r * n}`);
}, $r = (e) => {
	try {
		Qr(e);
	} catch (e) {
		return {
			result: !1,
			errorReason: e.message
		};
	}
	return { result: !0 };
}, ei = /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ ce((e) => $r(e).result, "invalid blurhash")), ti = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	type: /* @__PURE__ */ k(),
	url: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	preview_url: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	remote_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _())), null),
	description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	blurhash: /* @__PURE__ */ v(/* @__PURE__ */ C(ei), null),
	mime_type: /* @__PURE__ */ v(/* @__PURE__ */ C(Je), null)
}), ni = /* @__PURE__ */ T({
	width: /* @__PURE__ */ w(),
	height: /* @__PURE__ */ w(),
	size: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ ve(/\d+x\d+$/))), null),
	aspect: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null)
}), ri = /* @__PURE__ */ T({
	...ti.entries,
	type: /* @__PURE__ */ S("image"),
	meta: /* @__PURE__ */ v(/* @__PURE__ */ T({
		original: /* @__PURE__ */ v(/* @__PURE__ */ E(ni), void 0),
		small: /* @__PURE__ */ v(/* @__PURE__ */ E(ni), void 0),
		focus: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ T({
			x: /* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ ge(-1), /* @__PURE__ */ me(1)),
			y: /* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ ge(-1), /* @__PURE__ */ me(1))
		})), void 0)
	}), {})
}), ii = /* @__PURE__ */ T({
	...ti.entries,
	type: /* @__PURE__ */ S("video"),
	meta: /* @__PURE__ */ v(/* @__PURE__ */ T({
		duration: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		original: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ T({
			...ni.entries,
			frame_rate: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ ve(/\d+\/\d+$/))), null),
			duration: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ ge(0))), null)
		})), void 0),
		small: /* @__PURE__ */ v(/* @__PURE__ */ E(ni), void 0)
	}), {})
}), ai = /* @__PURE__ */ T({
	...ti.entries,
	type: /* @__PURE__ */ S("gifv"),
	meta: /* @__PURE__ */ v(/* @__PURE__ */ T({
		duration: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		original: /* @__PURE__ */ v(/* @__PURE__ */ E(ni), void 0),
		focus: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ T({
			x: /* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ ge(-1), /* @__PURE__ */ me(1)),
			y: /* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ ge(-1), /* @__PURE__ */ me(1))
		})), void 0)
	}), {})
}), oi = /* @__PURE__ */ T({
	...ti.entries,
	type: /* @__PURE__ */ S("audio"),
	meta: /* @__PURE__ */ v(/* @__PURE__ */ T({
		duration: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
		colors: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ T({
			background: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
			foreground: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
			accent: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
			duration: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0)
		})), void 0),
		original: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ T({
			duration: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
			bitrate: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ ge(0))), void 0)
		})), void 0)
	}), {})
}), si = /* @__PURE__ */ T({
	...ti.entries,
	type: /* @__PURE__ */ S("unknown")
}), ci = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => e ? {
	mime_type: e.pleroma?.mime_type,
	preview_url: e.url,
	...e
} : null), /* @__PURE__ */ Me("type", [
	ri,
	ii,
	ai,
	oi,
	si
])), li = /* @__PURE__ */ T({
	title: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	votes_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	title_map: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ k())), null)
}), ui = /* @__PURE__ */ T({
	emojis: F(We),
	expired: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	expires_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	id: /* @__PURE__ */ k(),
	multiple: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	options: /* @__PURE__ */ M(/* @__PURE__ */ b(li), /* @__PURE__ */ he(1)),
	voters_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	votes_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	own_votes: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ b(/* @__PURE__ */ w()), /* @__PURE__ */ he(1))), null),
	voted: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	non_anonymous: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1)
}), di = /* @__PURE__ */ T({
	name: /* @__PURE__ */ k(),
	url: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()),
	account: /* @__PURE__ */ v(/* @__PURE__ */ C(L), null)
}), fi = (e) => {
	if (e.hostname === "youtu.be") {
		let t = e.pathname.slice(1);
		return /^[\w-]{11}$/.test(t) ? t : null;
	}
	if (![
		"youtube.com",
		"www.youtube.com",
		"m.youtube.com"
	].includes(e.hostname)) return null;
	let t = e.pathname === "/watch" ? e.searchParams.get("v") : e.pathname.match(/^\/(?:shorts|live|embed)\/([\w-]{11})\/?$/)?.[1];
	return t && /^[\w-]{11}$/.test(t) ? t : null;
}, pi = /* @__PURE__ */ M(/* @__PURE__ */ T({
	author_name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	author_url: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	authors: F(di),
	blurhash: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	embed_url: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	height: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	html: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	image: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	image_description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	provider_name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	provider_url: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	title: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	type: /* @__PURE__ */ v(/* @__PURE__ */ D([
		"link",
		"photo",
		"video",
		"rich"
	]), "link"),
	url: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()),
	width: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0)
}), /* @__PURE__ */ g((e) => {
	if (e.html) return e;
	let t = fi(new URL(e.url));
	return t ? {
		...e,
		height: 720,
		html: `<iframe src="https://www.youtube.com/embed/${t}" width="1280" height="720" allowfullscreen></iframe>`,
		type: "video",
		width: 1280
	} : e;
})), mi = /* @__PURE__ */ D([
	"pending",
	"accepted",
	"rejected",
	"revoked",
	"deleted",
	"unauthorized",
	"blocked_account",
	"blocked_domain",
	"muted_account"
]), hi = /* @__PURE__ */ T({
	state: /* @__PURE__ */ v(mi, "accepted"),
	quoted_status: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ Te(() => $)), null)
}), gi = /* @__PURE__ */ T({
	state: /* @__PURE__ */ v(mi, "accepted"),
	quoted_status_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
}), _i = /* @__PURE__ */ T({
	automatic: /* @__PURE__ */ b(/* @__PURE__ */ D([
		"public",
		"followers",
		"following",
		"unsupported_policy"
	])),
	manual: /* @__PURE__ */ b(/* @__PURE__ */ D([
		"public",
		"followers",
		"following",
		"unsupported_policy"
	])),
	current_user: /* @__PURE__ */ D([
		"automatic",
		"manual",
		"denied",
		"unknown"
	])
}), vi = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	url: /* @__PURE__ */ k(),
	title: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	description: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	image_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
}), yi = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => e?.text ? {
	content: e.text,
	detected_source_language: e.detected_language
} : e), /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	content: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	spoiler_text: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	language: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	poll: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ T({
		id: /* @__PURE__ */ k(),
		options: /* @__PURE__ */ b(/* @__PURE__ */ T({ title: /* @__PURE__ */ k() }))
	})), void 0),
	media_attachments: F(/* @__PURE__ */ T({
		id: /* @__PURE__ */ k(),
		description: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
	})),
	detected_source_language: /* @__PURE__ */ k(),
	provider: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
})), bi = /* @__PURE__ */ T({
	name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	url: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	latitude: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	longitude: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	street: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	postal_code: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	locality: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	region: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	country: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
}), xi = /* @__PURE__ */ T({
	name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	start_time: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	end_time: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	join_mode: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ D([
		"free",
		"restricted",
		"invite",
		"external"
	])), null),
	participants_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	participation_request_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	location: /* @__PURE__ */ v(/* @__PURE__ */ C(bi), null),
	join_state: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ D([
		"pending",
		"reject",
		"accept"
	])), null)
}), Si = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	uri: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	created_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString()),
	account: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g((e) => {
		let t = window?.__PL_API_FALLBACK_ACCOUNT;
		return t && Object.keys(e).length === 0 ? t : e;
	}), L),
	content: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ g((e) => e === "<p></p>" ? "" : e)), ""),
	visibility: /* @__PURE__ */ v(/* @__PURE__ */ k(), "public"),
	sensitive: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Boolean)),
	spoiler_text: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	media_attachments: F(ci),
	application: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ T({
		name: /* @__PURE__ */ k(),
		website: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _())), null)
	})), null),
	mentions: F(er),
	tags: F(nr),
	emojis: F(We),
	reblogs_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	favourites_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	replies_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	url: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	in_reply_to_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	in_reply_to_account_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	poll: /* @__PURE__ */ v(/* @__PURE__ */ C(ui), null),
	card: /* @__PURE__ */ v(/* @__PURE__ */ C(pi), null),
	language: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	text: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	edited_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	favourited: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Boolean)), !1),
	reblogged: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Boolean)), !1),
	muted: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Boolean)), !1),
	bookmarked: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Boolean)), !1),
	pinned: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Boolean)), !1),
	filtered: F(Br),
	approval_status: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ D([
		"pending",
		"approval",
		"rejected"
	])), null),
	group: /* @__PURE__ */ v(/* @__PURE__ */ C(Wr), null),
	scheduled_at: /* @__PURE__ */ v(/* @__PURE__ */ De(), null),
	quote_approval: /* @__PURE__ */ v(/* @__PURE__ */ C(_i), null),
	tagged_collections: F(jr),
	quote_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	local: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	conversation_id: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	direct_conversation_id: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	in_reply_to_account_acct: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	expires_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	thread_muted: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	emoji_reactions: F(Fr),
	parent_visible: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	pinned_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	quote_visible: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	quote_url: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	quotes_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	bookmark_folder: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	list_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	event: /* @__PURE__ */ v(/* @__PURE__ */ C(xi), null),
	translation: /* @__PURE__ */ v(/* @__PURE__ */ je([/* @__PURE__ */ C(yi), /* @__PURE__ */ S(!1)]), null),
	rss_feed: /* @__PURE__ */ v(/* @__PURE__ */ C(vi), null),
	content_map: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ k())), null),
	text_map: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ k())), null),
	spoiler_text_map: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ k())), null),
	dislikes_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	disliked: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Boolean)), !1),
	local_only: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	interaction_policy: qr,
	content_type: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	location: /* @__PURE__ */ v(/* @__PURE__ */ C(bi), null)
}), Ci = (e) => {
	if (!e) return null;
	let t = null, n = e.quote ?? e.pleroma?.quote, r = n?.id ?? e.quote_id ?? e.pleroma?.quote_id;
	return n?.state ? (t = n, r = n.quoted_status?.id || n.quoted_status_id) : n ? t = {
		state: "accepted",
		quoted_status: n
	} : r && (t = {
		state: "accepted",
		quoted_status_id: r
	}), e = {
		emoji_reactions: e.reactions,
		...e.pleroma ? Ie(e.pleroma, [
			"local",
			"conversation_id",
			"direct_conversation_id",
			"in_reply_to_account_acct",
			"expires_at",
			"thread_muted",
			"emoji_reactions",
			"parent_visible",
			"pinned_at",
			"quote_url",
			"quote_visible",
			"quotes_count",
			"bookmark_folder",
			"list_id",
			"event",
			"translation",
			"rss_feed",
			"location"
		]) : void 0,
		...e.friendica ? Ie(e.friendica, ["dislikes_count", "disliked"]) : void 0,
		...e,
		quote: t,
		quote_id: r
	}, !e.interaction_policy && e.comments_disabled === !0 && (e.interaction_policy = { can_reply: { always: ["author"] } }), e;
}, $ = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g(Ci), /* @__PURE__ */ T({
	...Si.entries,
	reblog: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ Te(() => $)), null),
	quote: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ Te(() => /* @__PURE__ */ je([hi, gi]))), null)
})), wi = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g(Ci), /* @__PURE__ */ T({
	...(/* @__PURE__ */ Ne(Si, ["account"])).entries,
	account: /* @__PURE__ */ v(/* @__PURE__ */ C(L), null),
	reblog: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ Te(() => $)), null),
	quote: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ Te(() => /* @__PURE__ */ je([hi, gi]))), null)
})), Ti = /* @__PURE__ */ Pe(/* @__PURE__ */ T({
	...Si.entries,
	reblog: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ Te(() => $)), null),
	quote: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ Te(() => /* @__PURE__ */ je([hi, gi]))), null)
})), Ei = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => (e.statuses = e.statuses?.map((t) => ({
	...t,
	account: (e.actor ? e.account : e.target_account)?.account || t.account
})), e.createdAt ? {
	id: e.id,
	action_taken: e.resolved,
	comment: e.comment,
	forwarded: e.forwarded,
	created_at: e.createdAt,
	account: e.reporter,
	target_account: e.targetUser,
	assigned_account: e.assignee,
	statuses: e.notes,
	rules: e.rules
} : e.actor ? {
	action_taken: e.state !== "open",
	comment: e.content,
	updated_at: e.created_at,
	account: e.actor,
	target_account: e.account,
	...Ie(e, [
		"id",
		"assigned_account",
		"created_at",
		"rules",
		"statuses"
	])
} : e)), /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	action_taken: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	action_taken_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	category: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	comment: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	forwarded: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	updated_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	account: Zn,
	target_account: Zn,
	assigned_account: /* @__PURE__ */ v(/* @__PURE__ */ C(Zn), null),
	action_taken_by_account: /* @__PURE__ */ v(/* @__PURE__ */ C(Zn), null),
	statuses: F(wi),
	rules: F(at)
})), Di = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	text: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	hint: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	priority: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	updated_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0)
}), Oi = /* @__PURE__ */ T({
	...nr.entries,
	id: /* @__PURE__ */ k(),
	trendable: /* @__PURE__ */ x(),
	usable: /* @__PURE__ */ x(),
	requires_review: /* @__PURE__ */ x()
}), ki = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => e ? {
	...e.pleroma,
	...e
} : null), /* @__PURE__ */ T({
	id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
	title: /* @__PURE__ */ k(),
	replies_policy: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ D([
		"none",
		"list",
		"followed"
	])), void 0),
	exclusive: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	antennas: F(/* @__PURE__ */ Te(() => Ai)),
	notify: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	favourite: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	emoji: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	emoji_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
})), Ai = /* @__PURE__ */ T({
	...(/* @__PURE__ */ T({
		id: /* @__PURE__ */ k(),
		title: /* @__PURE__ */ k(),
		with_media_only: /* @__PURE__ */ x(),
		ignore_reblog: /* @__PURE__ */ x(),
		stl: /* @__PURE__ */ x(),
		ltl: /* @__PURE__ */ x(),
		insert_feeds: /* @__PURE__ */ x(),
		accounts_count: /* @__PURE__ */ w(),
		domains_count: /* @__PURE__ */ w(),
		tags_count: /* @__PURE__ */ w(),
		keywords_count: /* @__PURE__ */ w(),
		favourite: /* @__PURE__ */ x()
	})).entries,
	list: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ Te(() => ki)), null)
}), ji = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	redirect_uris: [e.redirect_uri],
	...e
})), /* @__PURE__ */ T({
	name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	website: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	redirect_uris: F(/* @__PURE__ */ k()),
	id: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	redirect_uri: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	vapid_key: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0)
})), Mi = /* @__PURE__ */ M(ji.pipe[0], ji.pipe[1], /* @__PURE__ */ T({
	...ji.pipe[2].entries,
	client_id: /* @__PURE__ */ k(),
	client_secret: /* @__PURE__ */ k(),
	client_secret_expires_at: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number))), null)
})), Ni = /* @__PURE__ */ T({ async_refresh: /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	status: /* @__PURE__ */ D(["running", "finished"]),
	result_count: /* @__PURE__ */ C(/* @__PURE__ */ w())
}) }), Pi = /* @__PURE__ */ T({
	issuer: /* @__PURE__ */ k(),
	service_documentation: /* @__PURE__ */ k(),
	authorization_endpoint: /* @__PURE__ */ k(),
	token_endpoint: /* @__PURE__ */ k(),
	app_registration_endpoint: /* @__PURE__ */ k(),
	revocation_endpoint: /* @__PURE__ */ k(),
	userinfo_endpoint: /* @__PURE__ */ k(),
	scopes_supported: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	response_types_supported: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	response_modes_supported: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	code_challenge_methods_supported: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	grant_types_supported: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	token_endpoint_auth_methods_supported: /* @__PURE__ */ b(/* @__PURE__ */ k())
}), Fi = /* @__PURE__ */ T({
	id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
	content_type: Je,
	file_size: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	inserted_at: P,
	processed: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	url: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
}), Ii = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	name: e.title,
	...e
})), /* @__PURE__ */ T({
	id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
	name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	emoji: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	emoji_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
})), Li = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	content: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	chat_id: /* @__PURE__ */ k(),
	account_id: /* @__PURE__ */ k(),
	created_at: P,
	emojis: F(We),
	attachment: /* @__PURE__ */ v(/* @__PURE__ */ C(ci), null),
	unread: /* @__PURE__ */ x(),
	card: /* @__PURE__ */ v(/* @__PURE__ */ C(pi), null)
}), Ri = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	account: L,
	unread: /* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de()),
	last_message: /* @__PURE__ */ v(/* @__PURE__ */ C(Li), null),
	updated_at: P
}), zi = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	title: /* @__PURE__ */ k()
}), Bi = /* @__PURE__ */ T({
	ancestors: F($),
	descendants: F($),
	references: /* @__PURE__ */ v(F($), [])
}), Vi = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	unread: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	accounts: F(L),
	last_status: /* @__PURE__ */ v(/* @__PURE__ */ C($), null)
}), Hi = /* @__PURE__ */ T({
	category: /* @__PURE__ */ k(),
	servers_count: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number))), null)
}), Ui = /* @__PURE__ */ T({
	locale: /* @__PURE__ */ k(),
	language: /* @__PURE__ */ k(),
	servers_count: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number))), null)
}), Wi = /* @__PURE__ */ T({
	domain: /* @__PURE__ */ k(),
	version: /* @__PURE__ */ k(),
	description: /* @__PURE__ */ k(),
	languages: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	region: /* @__PURE__ */ k(),
	categories: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	proxied_thumbnail: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _())), null),
	blurhash: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	total_users: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number)),
	last_week_users: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number)),
	approval_required: /* @__PURE__ */ x(),
	language: /* @__PURE__ */ k(),
	category: /* @__PURE__ */ k()
}), Gi = /* @__PURE__ */ T({
	period: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ pe()),
	server_count: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number))), null),
	user_count: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number))), null),
	active_user_count: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Number))), null)
}), Ki = /* @__PURE__ */ T({
	domain: /* @__PURE__ */ k(),
	digest: /* @__PURE__ */ k(),
	severity: /* @__PURE__ */ D(["silence", "suspend"]),
	comment: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0)
}), qi = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	...e,
	thumbnail_url: e.thumbnailUrl,
	content_type: e.contentType,
	is_avatar: e.isAvatar,
	is_banner: e.isBanner
})), /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	url: /* @__PURE__ */ k(),
	thumbnail_url: /* @__PURE__ */ k(),
	filename: /* @__PURE__ */ k(),
	content_type: /* @__PURE__ */ k(),
	sensitive: /* @__PURE__ */ x(),
	description: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	is_avatar: /* @__PURE__ */ x(),
	is_banner: /* @__PURE__ */ x()
})), Ji = /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	name: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	parent_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
}), Yi = /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	name: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	parent_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	files: F(qi),
	path: F(Ji)
}), Xi = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	...e,
	parent_id: e.parentId,
	path: e.path?.map((e) => ({
		...e,
		parent_id: e.parentId
	}))
})), /* @__PURE__ */ T({
	...Yi.entries,
	folders: F(/* @__PURE__ */ Te(() => Xi))
})), Zi = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	file_count: e.fileCount,
	used_size: e.usedSize,
	...e
})), /* @__PURE__ */ T({
	file_count: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0),
	used_size: /* @__PURE__ */ v(/* @__PURE__ */ w(), 0)
})), Qi = /* @__PURE__ */ T({
	updated_at: P,
	content: /* @__PURE__ */ k()
}), $i = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	accounts: F(L)
}), ea = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	name: /* @__PURE__ */ k(),
	url: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	statuses_count: /* @__PURE__ */ w(),
	last_status_at: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null)
}), ta = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	description: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	url: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _())
}), na = /* @__PURE__ */ T({
	results: F(ta),
	provider: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
}), ra = [
	"chat_mention",
	"emoji_reaction",
	"report",
	"participation_accepted",
	"participation_request",
	"event_reminder",
	"event_update",
	"subscribed_reaction"
], ia = (e) => [...e, ...e.filter((e) => ra.includes(e)).map((e) => `pleroma:${e}`)], aa = (e) => {
	if (typeof e.reaction == "object" && e.reaction !== null) return {
		emoji: e.reaction.name,
		emoji_url: e.reaction.url,
		emoji_static_url: e.reaction.static_url
	};
}, oa = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	type: /* @__PURE__ */ D([
		"domain_block",
		"user_domain_block",
		"account_suspension"
	]),
	purged: /* @__PURE__ */ k(),
	relationships_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	created_at: P
}), sa = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => e.actor ? {
	...e,
	target_account: e.account
} : e), /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	action_taken: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	action_taken_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	category: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	comment: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	forwarded: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	status_ids: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	rule_ids: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	target_account: /* @__PURE__ */ v(/* @__PURE__ */ C(L), null)
})), ca = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	acct: /* @__PURE__ */ k(),
	url: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()),
	avatar: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()),
	avatar_static: /* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()),
	locked: /* @__PURE__ */ x(),
	bot: /* @__PURE__ */ x()
}), la = /* @__PURE__ */ T({
	group_key: /* @__PURE__ */ k(),
	notifications_count: /* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de()),
	most_recent_notification_id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String), /* @__PURE__ */ k()),
	page_min_id: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	page_max_id: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	latest_page_notification_at: /* @__PURE__ */ v(/* @__PURE__ */ E(P), void 0),
	sample_account_ids: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	is_muted: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	is_seen: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0)
}), ua = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ D([
		"follow",
		"follow_request",
		"follow_request_accepted",
		"admin.sign_up",
		"bite"
	])
}), da = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ S("mention"),
	subtype: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ D(["reply"])), null),
	status_id: /* @__PURE__ */ k()
}), fa = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ D([
		"status",
		"reblog",
		"favourite",
		"poll",
		"update",
		"event_reminder",
		"quote",
		"quoted_update"
	]),
	status_id: /* @__PURE__ */ k()
}), pa = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ S("admin.report"),
	report: sa
}), ma = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ S("severed_relationships"),
	relationship_severance_event: oa
}), ha = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ S("moderation_warning"),
	moderation_warning: Yn
}), ga = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ S("move"),
	target_id: /* @__PURE__ */ k()
}), _a = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ S("emoji_reaction"),
	emoji: /* @__PURE__ */ k(),
	emoji_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	emoji_static_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	status_id: /* @__PURE__ */ k()
}), va = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ S("chat_mention"),
	chat_message: Li
}), ya = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ D(["participation_accepted", "participation_request"]),
	status_id: /* @__PURE__ */ k(),
	participation_message: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
}), ba = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ S("subscribed_reaction"),
	emoji: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	emoji_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	emoji_static_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	status_id: /* @__PURE__ */ k()
}), xa = /* @__PURE__ */ T({
	...la.entries,
	type: /* @__PURE__ */ D(["added_to_collection", "collection_update"]),
	collection: jr
}), Sa = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	...aa(e),
	group_key: `ungrouped-${e.id}`,
	...Ie(e.pleroma || {}, ["is_muted", "is_seen"]),
	...e,
	type: e.type === "pleroma:report" ? "admin.report" : e.type === "reaction" ? "emoji_reaction" : e.type?.replace(/^pleroma:/, "")
})), /* @__PURE__ */ Me("type", [
	ua,
	da,
	fa,
	pa,
	ma,
	ha,
	ga,
	_a,
	va,
	ya,
	ba,
	xa
])), Ca = /* @__PURE__ */ T({
	accounts: F(L),
	partial_accounts: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ b(ca)), void 0),
	statuses: F($),
	notification_groups: F(Sa)
}), wa = /* @__PURE__ */ T({
	accepted_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	account: L,
	created_at: P,
	id: /* @__PURE__ */ k(),
	rejected_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	reply: /* @__PURE__ */ v(/* @__PURE__ */ C($), null),
	status: /* @__PURE__ */ v(/* @__PURE__ */ C($), null),
	type: /* @__PURE__ */ D([
		"favourite",
		"reply",
		"reblog"
	]),
	uri: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
}), Ta = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	uuid: /* @__PURE__ */ k(),
	url: /* @__PURE__ */ k(),
	api_url: /* @__PURE__ */ k(),
	category: /* @__PURE__ */ D([
		"book",
		"movie",
		"tv",
		"music",
		"game",
		"podcast",
		"performance",
		"collection"
	]),
	parent_uuid: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	display_title: /* @__PURE__ */ k(),
	external_resources: /* @__PURE__ */ C(F(/* @__PURE__ */ T({ url: /* @__PURE__ */ k() }))),
	title: /* @__PURE__ */ k(),
	description: /* @__PURE__ */ k(),
	localized_title: F(/* @__PURE__ */ T({
		lang: /* @__PURE__ */ k(),
		text: /* @__PURE__ */ k()
	})),
	localized_description: F(/* @__PURE__ */ T({
		lang: /* @__PURE__ */ k(),
		text: /* @__PURE__ */ k()
	})),
	conver_image_url: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	rating: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	rating_count: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	rating_distribution: /* @__PURE__ */ C(/* @__PURE__ */ b(/* @__PURE__ */ w())),
	tags: /* @__PURE__ */ C(/* @__PURE__ */ b(/* @__PURE__ */ k()))
}), Ea = /* @__PURE__ */ T({
	...Ta.entries,
	type: /* @__PURE__ */ S("Edition"),
	subtitle: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	orig_title: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	author: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	translator: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	language: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	pub_house: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	pub_year: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	pub_month: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	binding: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	price: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	pages: /* @__PURE__ */ C(/* @__PURE__ */ je([/* @__PURE__ */ k(), /* @__PURE__ */ w()])),
	series: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	imprint: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	isbn: /* @__PURE__ */ C(/* @__PURE__ */ k())
}), Da = /* @__PURE__ */ T({
	...Ta.entries,
	type: /* @__PURE__ */ S("TVShow"),
	season_count: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	orig_title: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	director: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	playwright: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	actor: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	genre: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	language: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	area: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	year: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	site: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	episode_count: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	season_uuids: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	imdb: /* @__PURE__ */ C(/* @__PURE__ */ k())
}), Oa = /* @__PURE__ */ T({
	...Ta.entries,
	type: /* @__PURE__ */ S("TVSeason"),
	season_number: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	orig_title: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	director: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	playwright: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	actor: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	genre: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	language: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	area: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	year: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	site: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	episode_count: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	episode_uuids: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	imdb: /* @__PURE__ */ C(/* @__PURE__ */ k())
}), ka = /* @__PURE__ */ T({
	...Ta.entries,
	type: /* @__PURE__ */ S("Movie"),
	orig_title: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	director: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	playwright: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	actor: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	genre: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	language: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	area: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	year: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	site: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	duration: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	imdb: /* @__PURE__ */ C(/* @__PURE__ */ k())
}), Aa = /* @__PURE__ */ T({
	...Ta.entries,
	type: /* @__PURE__ */ S("MusicAlbum"),
	genre: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	artist: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	company: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	duration: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	release_date: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	track_list: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	barcode: /* @__PURE__ */ C(/* @__PURE__ */ k())
}), ja = /* @__PURE__ */ T({
	...Ta.entries,
	type: /* @__PURE__ */ S("Podcast"),
	genre: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	host: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	language: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	official_site: /* @__PURE__ */ C(/* @__PURE__ */ k())
}), Ma = /* @__PURE__ */ T({
	...Ta.entries,
	type: /* @__PURE__ */ S("Game"),
	genre: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	developer: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	publisher: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	platform: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	release_type: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	release_date: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	official_site: /* @__PURE__ */ C(/* @__PURE__ */ k())
}), Na = /* @__PURE__ */ T({
	...Ta.entries,
	type: /* @__PURE__ */ S("Performance"),
	orig_title: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	genre: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	language: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	opening_date: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	closing_date: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	director: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	playwright: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	orig_creator: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	composer: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	choreographer: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	performer: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	actor: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	crew: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	official_site: /* @__PURE__ */ C(/* @__PURE__ */ k())
}), Pa = /* @__PURE__ */ T({
	...Ta.entries,
	type: /* @__PURE__ */ S("PodcastEpisode"),
	guid: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	pub_date: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	media_url: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	link: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	duration: /* @__PURE__ */ C(/* @__PURE__ */ w())
}), Fa = /* @__PURE__ */ T({
	...Ta.entries,
	type: /* @__PURE__ */ S("PerformanceProduction"),
	orig_title: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	language: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	opening_date: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	closing_date: /* @__PURE__ */ C(/* @__PURE__ */ k()),
	director: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	playwright: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	orig_creator: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	composer: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	choreographer: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	performer: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	actor: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	crew: /* @__PURE__ */ b(/* @__PURE__ */ k()),
	official_site: /* @__PURE__ */ C(/* @__PURE__ */ k())
}), Ia = /* @__PURE__ */ T({
	...Ta.entries,
	type: /* @__PURE__ */ S("PerformanceProduction"),
	episode_number: /* @__PURE__ */ C(/* @__PURE__ */ w())
}), La = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ Me("type", [
	Ea,
	Da,
	Oa,
	ka,
	Aa,
	ja,
	Ma,
	Na,
	Pa,
	Fa,
	Ia
])), Ra = /* @__PURE__ */ T({
	url: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	country: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	locality: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	region: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	postal_code: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	street: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	origin_id: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	origin_provider: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	type: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	timezone: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	geom: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ T({
		coordinates: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ Oe([/* @__PURE__ */ w(), /* @__PURE__ */ w()])), null),
		srid: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
	})), null)
}), za = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => e ? {
	unread_count: e.pleroma?.unread_count,
	...e
} : null), /* @__PURE__ */ T({
	last_read_id: /* @__PURE__ */ k(),
	version: /* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de()),
	updated_at: P,
	unread_count: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de())), void 0)
})), Ba = /* @__PURE__ */ O(/* @__PURE__ */ k(), za), Va = /* @__PURE__ */ T({
	account: L,
	created_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString()),
	id: /* @__PURE__ */ k(),
	group_key: /* @__PURE__ */ k(),
	type: /* @__PURE__ */ k(),
	is_muted: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
	is_seen: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0)
}), Ha = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ D([
		"follow",
		"follow_request",
		"follow_request_accepted",
		"admin.sign_up"
	])
}), Ua = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ S("mention"),
	subtype: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ D(["reply"])), null),
	status: $
}), Wa = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ D([
		"status",
		"reblog",
		"favourite",
		"poll",
		"update",
		"quote",
		"quoted_update",
		"event_reminder"
	]),
	status: $
}), Ga = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ S("admin.report"),
	report: sa
}), Ka = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ S("severed_relationships"),
	event: oa
}), qa = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ S("moderation_warning"),
	moderation_warning: Yn
}), Ja = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ S("move"),
	target: L
}), Ya = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ S("emoji_reaction"),
	emoji: /* @__PURE__ */ k(),
	emoji_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	emoji_static_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	status: $
}), Xa = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ S("chat_mention"),
	chat_message: Li
}), Za = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ D(["participation_accepted", "participation_request"]),
	status: $,
	participation_message: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
}), Qa = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ S("bite"),
	status: /* @__PURE__ */ v(/* @__PURE__ */ C($), null)
}), $a = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ S("subscribed_reaction"),
	status: $,
	emoji: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	emoji_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	emoji_static_url: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null)
}), eo = /* @__PURE__ */ T({
	...Va.entries,
	type: /* @__PURE__ */ D(["added_to_collection", "collection_update"]),
	collection: jr
}), to = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	...aa(e),
	group_key: `ungrouped-${e.id}`,
	...Ie(e.pleroma || {}, ["is_muted", "is_seen"]),
	...e,
	type: e.type === "pleroma:report" ? "admin.report" : e.type === "reaction" ? "emoji_reaction" : e.type?.replace(/^pleroma:/, "")
})), /* @__PURE__ */ Me("type", [
	Ha,
	Ua,
	Wa,
	Ga,
	Ka,
	qa,
	Ja,
	Ya,
	Xa,
	Za,
	Qa,
	$a,
	eo
])), no = /* @__PURE__ */ D([
	"accept",
	"filter",
	"drop"
]), ro = /* @__PURE__ */ T({
	for_not_following: no,
	for_not_followers: no,
	for_new_accounts: no,
	for_private_mentions: no,
	for_limited_accounts: no,
	for_bots: /* @__PURE__ */ v(no, "accept"),
	summary: /* @__PURE__ */ T({
		pending_requests_count: /* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de()),
		pending_notifications_count: /* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de())
	})
}), io = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	created_at: P,
	updated_at: P,
	account: L,
	notifications_count: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
	last_status: /* @__PURE__ */ v(/* @__PURE__ */ E($), void 0)
}), ao = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => e ? e.createdAt ? {
	name: e.id,
	...e,
	app_name: e.app,
	created_at: e.createdAt,
	last_used: e.lastActive,
	is_current: e.current,
	linked_session: e.linkedSession
} : e.client_name ? {
	...e,
	app_name: e.client_name
} : e.application ? {
	...e,
	app_name: e.application.name,
	app_website: e.application.website,
	scopes: e.scope.split(" ")
} : {
	...e,
	valid_until: e?.valid_until?.padEnd(27, "Z")
} : null), /* @__PURE__ */ T({
	app_name: /* @__PURE__ */ k(),
	app_website: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	valid_until: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	last_used: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
	scopes: /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ k()), []),
	is_current: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ x()), null),
	is_active: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ x()), null),
	linked_session: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ Te(() => ao)), null)
})), oo = /* @__PURE__ */ T({
	updated_at: P,
	content: /* @__PURE__ */ k()
}), so = /* @__PURE__ */ T({
	url: /* @__PURE__ */ k(),
	api_url: /* @__PURE__ */ k(),
	visibility: /* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ ge(0), /* @__PURE__ */ me(2)),
	post_id: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	item: La,
	created_time: P,
	title: /* @__PURE__ */ k(),
	body: /* @__PURE__ */ k(),
	html_content: /* @__PURE__ */ k()
}), co = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	scheduled_at: P,
	params: /* @__PURE__ */ T({
		text: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		poll: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ T({
			options: /* @__PURE__ */ b(/* @__PURE__ */ k()),
			expires_in: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
			multiple: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0),
			hide_totals: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ x()), void 0)
		})), null),
		media_ids: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		sensitive: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Boolean))), null),
		spoiler_text: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		visibility: /* @__PURE__ */ v(/* @__PURE__ */ k(), "public"),
		in_reply_to_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		language: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		application_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ M(/* @__PURE__ */ w(), /* @__PURE__ */ de())), null),
		scheduled_at: /* @__PURE__ */ v(/* @__PURE__ */ C(P), null),
		idempotency: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		quoted_status_id: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
		quote_approval_policy: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ D([
			"public",
			"followers",
			"nobody"
		])), null),
		with_rate_limit: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
		expires_in: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null)
	}),
	media_attachments: F(ci)
}), lo = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => e ? {
	external_link: e.externalLink,
	...e
} : null), /* @__PURE__ */ T({
	id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
	account: L,
	created_at: P,
	title: /* @__PURE__ */ k(),
	artist: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	album: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	external_link: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	length: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null)
})), uo = /* @__PURE__ */ T({
	accounts: F(L),
	statuses: F($),
	hashtags: F(nr),
	groups: F(Wr)
}), fo = /* @__PURE__ */ T({
	id: /* @__PURE__ */ w(),
	text: /* @__PURE__ */ k(),
	author: L
}), po = /* @__PURE__ */ T({
	content: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	spoiler_text: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	sensitive: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(Boolean)),
	created_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString()),
	account: L,
	poll: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ T({ options: /* @__PURE__ */ b(/* @__PURE__ */ T({ title: /* @__PURE__ */ k() })) })), null),
	media_attachments: F(ci),
	emojis: F(We)
}), mo = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	text: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	spoiler_text: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	content_type: /* @__PURE__ */ v(/* @__PURE__ */ k(), "text/plain"),
	location: /* @__PURE__ */ v(/* @__PURE__ */ C(Ra), null),
	text_map: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ k())), null),
	spoiler_text_map: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ k())), null)
}), ho = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	account_id: e.pid,
	story_id: e.sid,
	...e
})), /* @__PURE__ */ T({
	account_id: /* @__PURE__ */ k(),
	avatar: /* @__PURE__ */ k(),
	local: /* @__PURE__ */ x(),
	username: /* @__PURE__ */ k(),
	latest: /* @__PURE__ */ T({
		id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
		type: /* @__PURE__ */ k(),
		preview_url: /* @__PURE__ */ k()
	}),
	url: /* @__PURE__ */ k(),
	seen: /* @__PURE__ */ x(),
	story_id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String))
})), go = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	id: e.media_id,
	url: e.media_url,
	type: e.media_type
})), /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	url: /* @__PURE__ */ k(),
	type: /* @__PURE__ */ D(["photo", "video"])
})), _o = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	type: /* @__PURE__ */ k(),
	duration: /* @__PURE__ */ w(),
	src: /* @__PURE__ */ k(),
	created_at: P,
	expires_at: P,
	view_count: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	seen: /* @__PURE__ */ x(),
	progress: /* @__PURE__ */ w(),
	can_reply: /* @__PURE__ */ x(),
	can_react: /* @__PURE__ */ x(),
	question: /* @__PURE__ */ E(/* @__PURE__ */ k(), void 0),
	options: /* @__PURE__ */ E(/* @__PURE__ */ b(/* @__PURE__ */ k()), void 0),
	voted: /* @__PURE__ */ E(/* @__PURE__ */ x(), void 0),
	voted_index: /* @__PURE__ */ E(/* @__PURE__ */ w(), void 0)
}), vo = /* @__PURE__ */ T({
	account: L,
	nodes: F(_o)
}), yo = /* @__PURE__ */ T({
	state: /* @__PURE__ */ D([
		"unfollow",
		"follow_pending",
		"follow_accept",
		"follow_reject"
	]),
	follower: /* @__PURE__ */ T({
		id: /* @__PURE__ */ k(),
		follower_count: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
		following_count: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null)
	}),
	following: /* @__PURE__ */ T({
		id: /* @__PURE__ */ k(),
		follower_count: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
		following_count: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null)
	})
}), bo = (e) => {
	if (Array.isArray(e)) return e.length === 1 ? bo(e[0]) : e;
	if (typeof e != "string") return e;
	if ([
		"user",
		"user:notification",
		"direct",
		"list",
		"hashtag",
		"hashtag:local",
		"public",
		"public:media",
		"public:local",
		"public:local:media",
		"public:remote",
		"public:remote:media",
		"group",
		"bubble"
	].includes(e)) return [e];
	for (let t of [
		"user:notification",
		"public:remote:media",
		"public:remote",
		"hashtag:local",
		"user",
		"direct",
		"list",
		"hashtag",
		"group"
	]) if (e.startsWith(t + ":")) return t === "user" || t === "user:notification" || t === "direct" ? [t] : [t, e.slice(t.length + 1)];
	return [e];
}, xo = /* @__PURE__ */ T({ stream: /* @__PURE__ */ E(/* @__PURE__ */ b(/* @__PURE__ */ k()), []) }), So = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ D(["update", "status.update"]),
	payload: /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => JSON.parse(e)), $)
}), Co = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ D(["delete", "announcement.delete"]),
	payload: /* @__PURE__ */ k()
}), wo = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ S("notification"),
	payload: /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => JSON.parse(e)), to)
}), To = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ S("filters_changed")
}), Eo = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ S("conversation"),
	payload: /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => JSON.parse(e)), Vi)
}), Do = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ S("announcement"),
	payload: /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => JSON.parse(e)), rr)
}), Oo = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ S("announcement.reaction"),
	payload: /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => JSON.parse(e)), $n)
}), ko = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ S("chat_update"),
	payload: /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => JSON.parse(e)), Ri)
}), Ao = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ S("follow_relationships_update"),
	payload: /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => JSON.parse(e)), yo)
}), jo = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ S("respond"),
	payload: /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => JSON.parse(e)), /* @__PURE__ */ T({
		type: /* @__PURE__ */ k(),
		result: /* @__PURE__ */ D([
			"success",
			"ignored",
			"error"
		])
	}))
}), Mo = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ S("marker"),
	payload: /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => JSON.parse(e)), Ba)
}), No = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ S("notifications_merged")
}), Po = /* @__PURE__ */ T({
	...xo.entries,
	event: /* @__PURE__ */ S("emoji_reaction"),
	payload: /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => JSON.parse(e)), Fr)
}), Fo = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	...e,
	event: e?.event?.replace(/^pleroma:/, ""),
	stream: bo(e?.stream)
})), /* @__PURE__ */ Me("event", [
	So,
	Co,
	wo,
	To,
	Eo,
	Do,
	Oo,
	ko,
	Ao,
	jo,
	Mo,
	No,
	Po
])), Io = /* @__PURE__ */ T({
	id: /* @__PURE__ */ w(),
	expires_at: /* @__PURE__ */ v(P, () => (/* @__PURE__ */ new Date()).toISOString())
}), Lo = /* @__PURE__ */ T({
	id: /* @__PURE__ */ k(),
	sender_id: /* @__PURE__ */ k(),
	recipient_id: /* @__PURE__ */ k(),
	chain_id: /* @__PURE__ */ k(),
	payment_address: /* @__PURE__ */ k(),
	amount: /* @__PURE__ */ w(),
	status: /* @__PURE__ */ D([
		"open",
		"paid",
		"forwarded",
		"timeout",
		"cancelled",
		"underpaid",
		"completed",
		"failed"
	]),
	created_at: P,
	expires_at: P
}), Ro = /* @__PURE__ */ Me("type", [/* @__PURE__ */ T({
	type: /* @__PURE__ */ S("monero"),
	chain_id: /* @__PURE__ */ k(),
	price: /* @__PURE__ */ C(/* @__PURE__ */ w()),
	payout_address: /* @__PURE__ */ k()
})]), zo = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => {
	if (!e) return null;
	if (e?.acct) return {
		source: "staff",
		sources: ["featured"],
		account: e
	};
	if (!e.sources) switch (e.sources = [], e.source) {
		case "staff":
			e.sources.push("staff");
			break;
		case "global": e.sources.push("most_interactions");
	}
	return e;
}), /* @__PURE__ */ T({
	source: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	sources: /* @__PURE__ */ v(/* @__PURE__ */ b(/* @__PURE__ */ k()), []),
	account: L
})), Bo = /* @__PURE__ */ T({
	effective_date: Ke,
	effective: /* @__PURE__ */ x(),
	content: /* @__PURE__ */ k(),
	succeeded_by: /* @__PURE__ */ v(/* @__PURE__ */ C(Ke), null)
}), Vo = /* @__PURE__ */ T({
	access_token: /* @__PURE__ */ k(),
	token_type: /* @__PURE__ */ k(),
	scope: /* @__PURE__ */ k(),
	created_at: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	id: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String))), void 0),
	refresh_token: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0),
	expires_in: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ w()), void 0),
	me: /* @__PURE__ */ v(/* @__PURE__ */ E(/* @__PURE__ */ k()), void 0)
}), Ho = /* @__PURE__ */ M(/* @__PURE__ */ y(), /* @__PURE__ */ g((e) => ({
	...e,
	id: e.url
})), /* @__PURE__ */ T({
	id: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	url: /* @__PURE__ */ v(/* @__PURE__ */ M(/* @__PURE__ */ k(), /* @__PURE__ */ _()), ""),
	title: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	description: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	type: /* @__PURE__ */ v(/* @__PURE__ */ D([
		"link",
		"photo",
		"video",
		"rich"
	]), "link"),
	author_name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	author_url: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	provider_name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	provider_url: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	html: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	width: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	height: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
	image: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	image_description: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ k()), null),
	embed_url: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
	blurhash: /* @__PURE__ */ v(/* @__PURE__ */ C(ei), null),
	history: /* @__PURE__ */ v(/* @__PURE__ */ C(tr), null)
})), Uo = /* @__PURE__ */ T({
	iss: /* @__PURE__ */ k(),
	sub: /* @__PURE__ */ k(),
	name: /* @__PURE__ */ k(),
	preferred_username: /* @__PURE__ */ k(),
	profile: /* @__PURE__ */ k(),
	picture: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
}), Wo = /* @__PURE__ */ T({
	id: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
	endpoint: /* @__PURE__ */ k(),
	standard: /* @__PURE__ */ v(/* @__PURE__ */ x(), !1),
	alerts: /* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ x()),
	server_key: /* @__PURE__ */ k()
}), Go = (e) => ({
	getAccount: async (t, n) => j(L, (await e.request(`/api/v1/accounts/${t}`, { params: n })).json),
	getAccounts: async (t) => {
		let n = await e.request("/api/v1/accounts", { params: { id: t } });
		return j(F(L), n.json);
	},
	getAccountStatuses: (t, n) => e.paginatedGet(`/api/v1/accounts/${t}/statuses`, { params: n }, $),
	getAccountFollowers: (t, n) => e.paginatedGet(`/api/v1/accounts/${t}/followers`, { params: n }, L),
	getAccountFollowing: (t, n) => e.paginatedGet(`/api/v1/accounts/${t}/following`, { params: n }, L),
	getAccountSubscribers: (t, n) => e.paginatedGet(`/api/v1/accounts/${t}/subscribers`, { params: n }, L),
	getAccountFeaturedTags: async (t) => {
		let n = await e.request(`/api/v1/accounts/${t}/featured_tags`);
		return j(F(ea), n.json);
	},
	getAccountLists: async (t) => {
		let n = await e.request(`/api/v1/accounts/${t}/lists`);
		return j(F(ki), n.json);
	},
	getAccountAntennas: async (t) => {
		let n = await e.request(`/api/v1/accounts/${t}/antennas`);
		return j(F(Ai), n.json);
	},
	getAccountExcludeAntennas: async (t) => {
		let n = await e.request(`/api/v1/accounts/${t}/exclude_antennas`);
		return j(F(zi), n.json);
	},
	getAccountCircles: async (t) => {
		let n = await e.request(`/api/v1/accounts/${t}/circles`);
		return j(F(Ai), n.json);
	},
	followAccount: async (t, n) => j(N, (await e.request(`/api/v1/accounts/${t}/follow`, {
		method: "POST",
		body: n
	})).json),
	unfollowAccount: async (t) => j(N, (await e.request(`/api/v1/accounts/${t}/unfollow`, { method: "POST" })).json),
	removeAccountFromFollowers: async (t) => j(N, (await e.request(`/api/v1/accounts/${t}/remove_from_followers`, { method: "POST" })).json),
	pinAccount: async (t) => j(N, (await e.request(`/api/v1/accounts/${t}/pin`, { method: "POST" })).json),
	unpinAccount: async (t) => j(N, (await e.request(`/api/v1/accounts/${t}/unpin`, { method: "POST" })).json),
	updateAccountNote: async (t, n) => j(N, (await e.request(`/api/v1/accounts/${t}/note`, {
		method: "POST",
		body: { comment: n }
	})).json),
	getRelationships: async (t, n) => {
		let r = await e.request("/api/v1/accounts/relationships", { params: {
			...n,
			id: t
		} });
		return j(F(N), r.json);
	},
	getFamiliarFollowers: async (t) => {
		let n;
		return n = e.features.version.software === "Pixelfed" ? (await Promise.allSettled(t.map(async (t) => ({
			id: t,
			accounts: (await e.request(`/api/v1.1/accounts/mutuals/${t}`)).json
		})))).map((e, n) => e.status === "fulfilled" ? e.value : {
			id: t[n],
			accounts: []
		}) : (await e.request("/api/v1/accounts/familiar_followers", { params: { id: t } })).json, j(F($i), n);
	},
	searchAccounts: async (t, n, r) => {
		let i = await e.request("/api/v1/accounts/search", {
			...r,
			params: {
				...n,
				q: t
			}
		});
		return j(F(L), i.json);
	},
	lookupAccount: async (t, n) => j(L, (await e.request("/api/v1/accounts/lookup", {
		...n,
		params: { acct: t }
	})).json),
	reportAccount: async (t, n) => j(sa, (await e.request("/api/v1/reports", {
		method: "POST",
		body: {
			...n,
			account_id: t
		}
	})).json),
	getAccountEndorsements: (t, n) => e.paginatedGet(`/api/v1/${e.features.version.software === "Pleroma" ? "pleroma/" : ""}accounts/${t}/endorsements`, { params: n }, L),
	getBirthdays: async (t, n) => {
		let r = await e.request("/api/v1/pleroma/birthdays", { params: {
			day: t,
			month: n
		} });
		return j(F(L), r.json);
	},
	getAccountFavourites: (t, n) => e.paginatedGet(`/api/v1/pleroma/accounts/${t}/favourites`, { params: n }, $),
	remoteInteraction: async (t, n) => {
		let r = await e.request("/api/v1/pleroma/remote_interaction", {
			method: "POST",
			body: {
				ap_id: t,
				profile: n
			}
		});
		if (r.json?.error) throw r.json.error;
		return j(/* @__PURE__ */ T({ url: /* @__PURE__ */ k() }), r.json);
	},
	biteAccount: async (t) => {
		let n;
		switch (e.features.version.software) {
			case W:
				n = await e.request("/api/v1/bite", {
					method: "POST",
					body: t
				});
				break;
			default: n = await e.request("/api/v1/bite", {
				method: "POST",
				params: { id: t }
			});
		}
		return n.json;
	},
	getScrobbles: (t, n) => e.paginatedGet(`/api/v1/pleroma/accounts/${t}/scrobbles`, { params: n }, lo),
	createScrobble: async (t) => (t.external_link && (t.externalLink = t.external_link), j(lo, (await e.request("/api/v1/pleroma/scrobble", { body: t })).json)),
	loadActivities: async (t) => (await e.request(`/api/v1/accounts/${t}/load_activities`, { method: "POST" })).json,
	subscribeByEmail: async (t, n) => (await e.request(`/api/v1/accounts/${t}/email_subscriptions`, {
		method: "POST",
		body: { email: n }
	})).json
}), Ko = async (e, t) => {
	let n = await e.request("/api/v1/pleroma/admin/users", { params: t });
	return new qn(j(F(Zn), n.json?.users), {
		previous: t.page && t.page > 1 ? () => Ko(e, {
			...t,
			page: t.page - 1
		}) : null,
		next: n.json?.count > t.page_size * ((t.page || 1) - 1) + n.json?.users?.length ? () => Ko(e, {
			...t,
			page: (t.page ?? 1) + 1
		}) : null,
		partial: n.status === 206,
		total: n.json?.count
	});
}, qo = async (e, t) => {
	let n = await e.request("/api/v1/pleroma/admin/reports", { params: t });
	return new qn(j(F(Ei), n.json?.reports), {
		previous: t.page && t.page > 1 ? () => qo(e, {
			...t,
			page: t.page - 1
		}) : null,
		next: n.json?.total > t.page_size * ((t.page || 1) - 1) + n.json?.reports?.length ? () => qo(e, {
			...t,
			page: (t.page ?? 1) + 1
		}) : null,
		partial: n.status === 206,
		total: n.json?.total
	});
}, Jo = async (e, t = "/api/v1/pleroma/admin/statuses", n) => {
	let r = await e.request(t, { params: n });
	return new qn(j(F($), r.json.activities).toReversed(), {
		previous: n.page && n.page > 1 ? () => Jo(e, t, {
			...n,
			page: n.page - 1
		}) : null,
		next: r.json?.total > (n.page_size ?? 20) * ((n.page || 1) - 1) + r.json?.activities?.length ? () => Jo(e, t, {
			...n,
			page: (n.page ?? 1) + 1
		}) : null,
		partial: r.status === 206
	});
}, Yo = (e, t, n) => {
	for (let r of [
		":media_removal",
		":report_removal",
		":federated_timeline_removal",
		":reject"
	]) {
		let i = e.value.find(({ tuple: e }) => e[0] === r);
		i ? i.tuple[1] = i.tuple[1].filter(({ tuple: e }) => e[0] !== t) : (i = { tuple: [r, []] }, e.value.push(i)), (n.reject_media && r === ":media_removal" || n.reject_reports && r === ":report_removal" || n.severity === "silence" && r === ":federated_timeline_removal" || n.severity === "suspend" && r === ":reject") && i.tuple[1].push({ tuple: [t, n.public_comment || ""] });
	}
}, Xo = (e) => {
	let t = {
		accounts: {
			getAccounts: (t) => e.features.mastodonAdminV2 ? e.paginatedGet("/api/v2/admin/accounts", { params: t }, Zn) : Ko(e, t ? {
				query: t.username,
				name: t.display_name,
				email: t.email,
				filters: [
					t.origin === "local" && "local",
					t.origin === "remote" && "external",
					t.status === "active" && "active",
					t.status === "pending" && "need_approval",
					t.status === "disabled" && "deactivated",
					t.permissions === "staff" && "is_admin",
					t.permissions === "staff" && "is_moderator"
				].filter((e) => e).join(","),
				page_size: 100
			} : { page_size: 100 }),
			getAccount: async (t) => {
				let n;
				return n = e.features.mastodonAdmin ? await e.request(`/api/v1/admin/accounts/${t}`) : await e.request(`/api/v1/pleroma/admin/users/${t}`), j(Zn, n.json);
			},
			approveAccount: async (n) => {
				let r;
				if (e.features.mastodonAdmin) r = await e.request(`/api/v1/admin/accounts/${n}/approve`, { method: "POST" });
				else {
					let i = await t.accounts.getAccount(n);
					r = await e.request("/api/v1/pleroma/admin/users/approve", {
						method: "PATCH",
						body: { nicknames: [i.username] }
					}), r.json = r.json?.users?.[0];
				}
				return j(Zn, r.json);
			},
			rejectAccount: async (n) => {
				let r;
				if (e.features.mastodonAdmin) r = await e.request(`/api/v1/admin/accounts/${n}/reject`, { method: "POST" });
				else {
					let i = await t.accounts.getAccount(n);
					r = await e.request("/api/v1/pleroma/admin/users", {
						method: "DELETE",
						body: { nicknames: [i.username] }
					});
				}
				return (/* @__PURE__ */ Fe(Zn, r.json)).output || {};
			},
			createAccount: async (t) => {
				let n = await e.request("/api/v1/pleroma/admin/users", {
					method: "POST",
					body: { users: [t] }
				});
				return j(/* @__PURE__ */ T({
					nickname: /* @__PURE__ */ k(),
					email: /* @__PURE__ */ k()
				}), n.json[0]?.data);
			},
			deleteAccount: async (n) => {
				let r;
				if (e.features.mastodonAdmin || e.features.version.software === "Mitra") r = await e.request(`/api/v1/admin/accounts/${n}`, { method: "DELETE" });
				else if (e.features.iceshrimpAdmin) await e.getIceshrimpAccessToken(), r = await e.request(`/api/iceshrimp/moderation/users/${n}/purge`, { method: "POST" });
				else {
					let i = await t.accounts.getAccount(n);
					r = await e.request("/api/v1/pleroma/admin/users", {
						method: "DELETE",
						body: { nicknames: [i.username] }
					});
				}
				return (/* @__PURE__ */ Fe(Zn, r.json)).output || {};
			},
			performAccountAction: async (n, r, i) => {
				let a;
				if (e.features.mastodonAdmin) a = await e.request(`/api/v1/admin/accounts/${n}/action`, { body: {
					...i,
					type: r
				} });
				else if (e.features.iceshrimpAdmin) switch (r) {
					case "disable":
					case "suspend":
						await e.getIceshrimpAccessToken(), a = await e.request(`/api/iceshrimp/moderation/users/${n}/suspend`, { method: "POST" });
						break;
					default: a = { json: {} };
				}
				else {
					let o = await t.accounts.getAccount(n);
					switch (r) {
						case "disable":
						case "suspend":
							a = await e.request("/api/v1/pleroma/admin/users/deactivate", { body: { nicknames: [o.username] } });
							break;
						default: a = { json: {} };
					}
					i?.report_id && await t.reports.resolveReport(i.report_id);
				}
				return a.json;
			},
			enableAccount: async (n) => {
				let r;
				if (e.features.mastodonAdmin) r = await e.request(`/api/v1/admin/accounts/${n}/enable`, { method: "POST" });
				else if (e.features.iceshrimpAdmin) await e.getIceshrimpAccessToken(), r = await e.request(`/api/iceshrimp/moderation/users/${n}/unsuspend`, { method: "POST" });
				else {
					let i = await t.accounts.getAccount(n);
					r = await e.request("/api/v1/pleroma/admin/users/activate", {
						method: "PATCH",
						body: { nicknames: [i.username] }
					}), r.json = r.json?.users?.[0];
				}
				return j(Zn, r.json);
			},
			unsilenceAccount: async (t) => j(Zn, (await e.request(`/api/v1/admin/accounts/${t}/unsilence`, { method: "POST" })).json),
			unsuspendAccount: async (n) => {
				let r;
				if (e.features.mastodonAdmin) r = await e.request(`/api/v1/admin/accounts/${n}/unsuspend`, { method: "POST" });
				else if (e.features.iceshrimpAdmin) await e.getIceshrimpAccessToken(), r = await e.request(`/api/iceshrimp/moderation/users/${n}/unsuspend`, { method: "POST" });
				else {
					let { account: i } = await t.accounts.getAccount(n);
					r = await e.request("/api/v1/pleroma/admin/users/activate", {
						method: "PATCH",
						body: { nicknames: [i.acct] }
					}), r.json = r.json?.users?.[0];
				}
				return j(Zn, r.json);
			},
			unsensitiveAccount: async (t) => j(Zn, (await e.request(`/api/v1/admin/accounts/${t}/unsensitive`, { method: "POST" })).json),
			promoteToAdmin: async (n) => {
				let { account: r } = await t.accounts.getAccount(n);
				return await e.request("/api/v1/pleroma/admin/users/permission_group/moderator", {
					method: "DELETE",
					body: { nicknames: [r.acct] }
				}), (await e.request("/api/v1/pleroma/admin/users/permission_group/admin", {
					method: "POST",
					body: { nicknames: [r.acct] }
				})).json;
			},
			promoteToModerator: async (n) => {
				let { account: r } = await t.accounts.getAccount(n);
				return await e.request("/api/v1/pleroma/admin/users/permission_group/admin", {
					method: "DELETE",
					body: { nicknames: [r.acct] }
				}), (await e.request("/api/v1/pleroma/admin/users/permission_group/moderator", {
					method: "POST",
					body: { nicknames: [r.acct] }
				})).json;
			},
			demoteToUser: async (n) => {
				let { account: r } = await t.accounts.getAccount(n);
				return await e.request("/api/v1/pleroma/admin/users/permission_group/moderator", {
					method: "DELETE",
					body: { nicknames: [r.acct] }
				}), (await e.request("/api/v1/pleroma/admin/users/permission_group/admin", {
					method: "DELETE",
					body: { nicknames: [r.acct] }
				})).json;
			},
			suggestUser: async (n) => {
				let { account: r } = await t.accounts.getAccount(n);
				return (await e.request("/api/v1/pleroma/admin/users/suggest", {
					method: "PATCH",
					body: { nicknames: [r.acct] }
				})).json;
			},
			unsuggestUser: async (n) => {
				let { account: r } = await t.accounts.getAccount(n);
				return (await e.request("/api/v1/pleroma/admin/users/unsuggest", {
					method: "PATCH",
					body: { nicknames: [r.acct] }
				})).json;
			},
			tagUser: async (n, r) => {
				let { account: i } = await t.accounts.getAccount(n);
				return (await e.request("/api/v1/pleroma/admin/users/tag", {
					method: "PUT",
					body: {
						nicknames: [i.acct],
						tags: r
					}
				})).json;
			},
			untagUser: async (n, r) => {
				let { account: i } = await t.accounts.getAccount(n);
				return (await e.request("/api/v1/pleroma/admin/users/tag", {
					method: "DELETE",
					body: {
						nicknames: [i.acct],
						tags: r
					}
				})).json;
			},
			updateCredentials: async (n, r) => {
				let { account: i } = await t.accounts.getAccount(n);
				return await e.request(`/api/v1/pleroma/admin/users/${i.acct}/credentials`, {
					method: "PATCH",
					body: r
				}), t.accounts.getAccount(n);
			},
			disableMfa: async (n) => {
				let r;
				if (e.features.iceshrimpAdmin) await e.getIceshrimpAccessToken(), r = await e.request(`/api/iceshrimp/admin/users/${n}/reset-2fa`, { method: "POST" });
				else {
					let { account: i } = await t.accounts.getAccount(n);
					r = await e.request("/api/v1/pleroma/admin/users/disable_mfa", {
						method: "PUT",
						body: { nickname: i.acct }
					});
				}
				return r.json;
			},
			resetPassword: async (n, r) => {
				let i;
				if (e.features.iceshrimpAdmin) await e.getIceshrimpAccessToken(), i = await e.request(`/api/iceshrimp/admin/users/${n}/reset-password`, {
					method: "POST",
					body: { password: r }
				});
				else {
					let { account: a } = await t.accounts.getAccount(n);
					i = await e.request(`/api/v1/pleroma/admin/users/${a.acct}/credentials`, {
						method: "PATCH",
						body: { password: r }
					});
				}
				return i.json;
			},
			getAccountStatuses: (t, n) => Jo(e, `/api/v1/pleroma/admin/users/${t}/statuses`, {
				page_size: n?.limit || 20,
				page: 1,
				local_only: n?.local_only,
				with_reblogs: n?.with_reblogs,
				godmode: n?.with_private
			})
		},
		domainBlocks: {
			getDomainBlocks: async (n) => {
				if (e.features.version.software === "Pleroma" || e.features.version.software === "Akkoma") {
					let { configs: e } = await t.config.getPleromaConfig(), n = e.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || void 0, r = [];
					if (n) {
						let e = n.value.find(({ tuple: e }) => e[0] === ":media_removal")?.tuple[1] || [], t = n.value.find(({ tuple: e }) => e[0] === ":report_removal")?.tuple[1] || [], i = n.value.find(({ tuple: e }) => e[0] === ":federated_timeline_removal")?.tuple[1] || [], a = n.value.find(({ tuple: e }) => e[0] === ":reject")?.tuple[1] || [], o = new Set([
							...e,
							...t,
							...i,
							...a
						].map((e) => e.tuple[0]).filter((e) => e)), s = new TextEncoder();
						for (let n of o) r.push({
							id: n,
							domain: n,
							digest: new Uint8Array(await window.crypto.subtle.digest("SHA-256", s.encode(n))).toHex(),
							created_at: null,
							severity: a.some(({ tuple: e }) => e[0] === n) ? "suspend" : i.some(({ tuple: e }) => e[0] === n) ? "silence" : "noop",
							reject_media: e.some(({ tuple: e }) => e[0] === n),
							reject_reports: t.some(({ tuple: e }) => e[0] === n),
							private_comment: null,
							public_comment: [
								...a,
								...i,
								...e,
								...t
							].find(({ tuple: e }) => e[0] === n)?.tuple[1] || null,
							obfuscate: !1
						});
					}
					return new qn(r);
				}
				let r;
				return e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), r = "/api/iceshrimp/admin/instances/blocked") : r = "/api/v1/admin/domain_blocks", e.paginatedGet(r, { params: n }, fr);
			},
			getDomainBlock: async (n) => e.features.version.software === "Pleroma" || e.features.version.software === "Akkoma" ? (await t.domainBlocks.getDomainBlocks()).items.find((e) => e.id === n) : j(fr, (await e.request(`/api/v1/admin/domain_blocks/${n}`)).json),
			createDomainBlock: async (n, r) => {
				if (e.features.version.software === "Pleroma" || e.features.version.software === "Akkoma") {
					let { configs: i } = await t.config.getPleromaConfig(), a = i.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || {
						group: ":pleroma",
						key: ":mrf_simple",
						value: []
					};
					return Yo(a, n, r || { severity: "silence" }), await e.request("/api/v1/pleroma/admin/config", {
						method: "POST",
						body: { configs: [a] }
					}), {};
				}
				return e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), (await e.request(`/api/iceshrimp/admin/instances/${n}/block`, {
					method: "POST",
					params: { reason: r?.public_comment }
				})).json) : j(fr, (await e.request("/api/v1/admin/domain_blocks", {
					method: "POST",
					body: {
						...r,
						domain: n
					}
				})).json);
			},
			updateDomainBlock: async (n, r) => {
				if (e.features.version.software === "Pleroma" || e.features.version.software === "Akkoma") {
					let { configs: i } = await t.config.getPleromaConfig(), a = i.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || {
						group: ":pleroma",
						key: ":mrf_simple",
						value: []
					};
					return Yo(a, n, r), await e.request("/api/v1/pleroma/admin/config", {
						method: "POST",
						body: { configs: [a] }
					}), {};
				}
				return e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), await e.request(`/api/iceshrimp/admin/instances/${n}/unblock`, { method: "POST" }), (await e.request(`/api/iceshrimp/admin/instances/${n}/block`, {
					method: "POST",
					params: { reason: r.public_comment }
				})).json) : j(fr, (await e.request(`/api/v1/admin/domain_blocks/${n}`, {
					method: "PUT",
					body: r
				})).json);
			},
			deleteDomainBlock: async (n) => {
				if (e.features.version.software === "Pleroma" || e.features.version.software === "Akkoma") {
					let { configs: r } = await t.config.getPleromaConfig(), i = r.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || void 0;
					return i && ([
						":media_removal",
						":report_removal",
						":federated_timeline_removal",
						":reject"
					].forEach((e) => {
						let t = i.value.find(({ tuple: t }) => t[0] === e);
						t && (t.tuple[1] = t.tuple[1].filter(({ tuple: e }) => e[0] !== n));
					}), await e.request("/api/v1/pleroma/admin/config", {
						method: "POST",
						body: { configs: [i] }
					})), {};
				}
				return e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), (await e.request(`/api/iceshrimp/admin/instances/${n}/unblock`, { method: "POST" })).json) : (await e.request(`/api/v1/admin/domain_blocks/${n}`, { method: "DELETE" })).json;
			},
			expireDomainKeys: async (t) => j(Qn, (await e.request("/api/v1/admin/domain_keys_expire", {
				method: "POST",
				body: { domain: t },
				formData: !0
			})).json)
		},
		reports: {
			getReports: async (t) => e.features.mastodonAdmin ? (t?.unresolved && e.features.version.software === "GoToSocial" && !e.features.mastodonAdminUnresolvedReports ? (t ||= {}, t.resolved = !1) : t?.unresolved && !t?.resolved && e.features.version.software === "GoToSocial" && e.features.mastodonAdminUnresolvedReports && (delete t.unresolved, delete t.resolved), e.paginatedGet("/api/v1/admin/reports", { params: t }, Ei)) : e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), e.paginatedGet("/api/iceshrimp/moderation/reports", { params: t }, Ei)) : qo(e, {
				state: t?.resolved === !0 ? "resolved" : "open",
				page_size: t?.limit || 100
			}),
			getReport: async (t) => {
				let n;
				return e.features.mastodonAdmin ? n = await e.request(`/api/v1/admin/reports/${t}`) : e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), n = await e.request(`/api/iceshrimp/moderation/reports/${t}`)) : n = await e.request(`/api/v1/pleroma/admin/reports/${t}`), j(Ei, n.json);
			},
			updateReport: async (t, n) => j(Ei, (await e.request(`/api/v1/admin/reports/${t}`, {
				method: "PUT",
				body: n
			})).json),
			assignReportToSelf: async (t) => j(Ei, (await e.request(`/api/v1/admin/reports/${t}/assign_to_self`, { method: "POST" })).json),
			unassignReport: async (t) => j(Ei, (await e.request(`/api/v1/admin/reports/${t}/unassign`, { method: "POST" })).json),
			resolveReport: async (n, r) => {
				let i;
				if (e.features.mastodonAdmin) i = await e.request(`/api/v1/admin/reports/${n}/resolve`, {
					method: "POST",
					body: { action_taken_comment: r }
				});
				else if (e.features.version.software === "Iceshrimp.NET") return await e.getIceshrimpAccessToken(), await e.request(`/api/iceshrimp/moderation/reports/${n}/resolve`, { method: "POST" }), t.reports.getReport(n);
				else return await e.request("/api/v1/pleroma/admin/reports", {
					method: "PATCH",
					body: { reports: [{
						id: n,
						state: "resolved"
					}] }
				}), t.reports.getReport(n);
				return j(Ei, i.json);
			},
			reopenReport: async (t) => {
				let n;
				return n = e.features.mastodonAdmin ? await e.request(`/api/v1/admin/reports/${t}/reopen`, { method: "POST" }) : await e.request(`/api/v1/pleroma/admin/reports/${t}`, {
					method: "PATCH",
					body: { reports: [{
						id: t,
						state: "open"
					}] }
				}), j(Ei, n.json);
			},
			forwardReport: async (n) => (await e.getIceshrimpAccessToken(), await e.request(`/api/iceshrimp/moderation/reports/${n}/forward`, { method: "POST" }), t.reports.getReport(n))
		},
		statuses: {
			getStatuses: (t) => Jo(e, void 0, {
				page_size: t?.limit || 100,
				page: 1,
				local_only: t?.local_only,
				with_reblogs: t?.with_reblogs,
				godmode: t?.with_private
			}),
			getStatus: async (t) => j($, (await e.request(`/api/v1/pleroma/admin/statuses/${t}`)).json),
			updateStatus: async (t, n) => j($, (await e.request(`/api/v1/pleroma/admin/statuses/${t}`, {
				method: "PUT",
				body: n
			})).json),
			deleteStatus: async (t) => (await e.request(e.features.version.software === "Mitra" ? `/api/v1/admin/posts/${t}` : e.features.iceshrimpAdmin ? `/api/iceshrimp/moderation/notes/${t}` : `/api/v1/pleroma/admin/statuses/${t}`, { method: "DELETE" })).json,
			redactStatus: async (t, n) => j($, (await e.request(`/api/v1/pleroma/admin/statuses/${t}/redact`, {
				method: "PATCH",
				body: n
			})).json),
			getStatusSource: async (t) => j(mo, (await e.request(`/api/v1/pleroma/admin/statuses/${t}/source`)).json)
		},
		trends: {
			getTrendingLinks: async () => {
				let t = await e.request("/api/v1/admin/trends/links");
				return j(F(Ho), t.json);
			},
			getTrendingStatuses: async () => {
				let t = await e.request("/api/v1/admin/trends/statuses");
				return j(F($), t.json);
			},
			getTrendingTags: async () => {
				let t = await e.request("/api/v1/admin/trends/tags");
				return j(F(Oi), t.json);
			}
		},
		canonicalEmailBlocks: {
			getCanonicalEmailBlocks: (t) => e.paginatedGet("/api/v1/admin/canonical_email_blocks", { params: t }, ar),
			getCanonicalEmailBlock: async (t) => j(ar, (await e.request(`/api/v1/admin/canonical_email_blocks/${t}`)).json),
			testCanonicalEmailBlock: async (t) => {
				let n = await e.request("/api/v1/admin/canonical_email_blocks/test", {
					method: "POST",
					body: { email: t }
				});
				return j(F(ar), n.json);
			},
			createCanonicalEmailBlock: async (t, n) => j(ar, (await e.request("/api/v1/admin/canonical_email_blocks", {
				method: "POST",
				body: {
					email: t,
					canonical_email_hash: n
				}
			})).json),
			deleteCanonicalEmailBlock: async (t) => (await e.request(`/api/v1/admin/canonical_email_blocks/${t}`, { method: "DELETE" })).json
		},
		dimensions: { getDimensions: async (t, n) => {
			let r = await e.request("/api/v1/admin/dimensions", {
				method: "POST",
				params: {
					...n,
					keys: t
				}
			});
			return j(F(lr), r.json);
		} },
		domainAllows: {
			getDomainAllows: async (n) => {
				if (e.features.version.software === "Pleroma" || e.features.version.software === "Akkoma") {
					let { configs: e } = await t.config.getPleromaConfig(), n = e.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || void 0, r = [];
					return n && (r = (n.value.find(({ tuple: e }) => e[0] === ":accept")?.tuple[1] || []).map(({ tuple: e }) => ({
						id: e[0],
						domain: e[0],
						created_at: null,
						is_imported: !1
					}))), new qn(r);
				}
				let r;
				return e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), r = "/api/iceshrimp/admin/instances/allowed") : r = "/api/v1/admin/domain_allows", e.paginatedGet(r, { params: n }, dr);
			},
			getDomainAllow: async (n) => e.features.version.software === "Pleroma" || e.features.version.software === "Akkoma" ? (await t.domainAllows.getDomainAllows()).items.find((e) => e.id === n) : j(dr, (await e.request(`/api/v1/admin/domain_allows/${n}`)).json),
			createDomainAllow: async (n) => {
				if (e.features.version.software === "Pleroma" || e.features.version.software === "Akkoma") {
					let { configs: r } = await t.config.getPleromaConfig(), i = r.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || void 0;
					if (i) {
						let t = i.value.find(({ tuple: e }) => e[0] === ":accept");
						if (t || (t = { tuple: [":accept", []] }, i.value.push(t)), t.tuple[1].find(({ tuple: e }) => e[0] === n)) return {};
						t.tuple[1].push({ tuple: [n, ""] }), await e.request("/api/v1/pleroma/admin/config", {
							method: "POST",
							body: { configs: [i] }
						});
					}
					return {};
				}
				return e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), (await e.request(`/api/iceshrimp/admin/instances/${n}/allow`, { method: "POST" })).json) : j(dr, (await e.request("/api/v1/admin/domain_allows", {
					method: "POST",
					body: { domain: n }
				})).json);
			},
			deleteDomainAllow: async (n) => {
				if (e.features.version.software === "Pleroma" || e.features.version.software === "Akkoma") {
					let { configs: r } = await t.config.getPleromaConfig(), i = r.find((e) => e.group === ":pleroma" && e.key === ":mrf_simple") || void 0;
					if (i) {
						let t = i.value.find(({ tuple: e }) => e[0] === ":accept");
						t && (t.tuple[1] = t.tuple[1].filter(({ tuple: e }) => e[0] !== n), await e.request("/api/v1/pleroma/admin/config", {
							method: "POST",
							body: { configs: [i] }
						}));
					}
					return {};
				}
				return e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), (await e.request(`/api/iceshrimp/admin/instances/${n}/disallow`, { method: "POST" })).json) : (await e.request(`/api/v1/admin/domain_allows/${n}`, { method: "DELETE" })).json;
			}
		},
		emailDomainBlocks: {
			getEmailDomainBlocks: (t) => e.paginatedGet("/api/v1/admin/email_domain_blocks", { params: t }, gr),
			getEmailDomainBlock: async (t) => j(gr, (await e.request(`/api/v1/admin/email_domain_blocks/${t}`)).json),
			createEmailDomainBlock: async (t) => j(gr, (await e.request("/api/v1/admin/email_domain_blocks", {
				method: "POST",
				body: { domain: t }
			})).json),
			deleteEmailDomainBlock: async (t) => (await e.request(`/api/v1/admin/email_domain_blocks/${t}`, { method: "DELETE" })).json
		},
		ipBlocks: {
			getIpBlocks: (t) => e.paginatedGet("/api/v1/admin/ip_blocks", { params: t }, xr),
			getIpBlock: async (t) => j(xr, (await e.request(`/api/v1/admin/ip_blocks/${t}`)).json),
			createIpBlock: async (t) => j(xr, (await e.request("/api/v1/admin/ip_blocks", {
				method: "POST",
				body: t
			})).json),
			updateIpBlock: async (t, n) => j(xr, (await e.request(`/api/v1/admin/ip_blocks/${t}`, {
				method: "PUT",
				body: n
			})).json),
			deleteIpBlock: async (t) => (await e.request(`/api/v1/admin/ip_blocks/${t}`, { method: "DELETE" })).json
		},
		measures: { getMeasures: async (t, n, r, i) => {
			let a = await e.request("/api/v1/admin/measures", {
				method: "POST",
				params: {
					...i,
					keys: t,
					start_at: n,
					end_at: r
				}
			});
			return j(F(Sr), a.json);
		} },
		retention: { getRetention: async (t, n, r) => {
			let i = await e.request("/api/v1/admin/retention", {
				method: "POST",
				params: {
					start_at: t,
					end_at: n,
					frequency: r
				}
			});
			return j(F(or), i.json);
		} },
		announcements: {
			getAnnouncements: async (n) => {
				let r = await e.request("/api/v1/pleroma/admin/announcements", { params: n }), i = j(F(ir), r.json);
				return new qn(i, {
					next: i.length ? () => t.announcements.getAnnouncements({
						...n,
						offset: (n?.offset || 0) + i.length
					}) : null,
					partial: !1
				});
			},
			getAnnouncement: async (t) => j(ir, (await e.request(`/api/v1/pleroma/admin/announcements/${t}`)).json),
			createAnnouncement: async (t) => j(ir, (await e.request("/api/v1/pleroma/admin/announcements", {
				method: "POST",
				body: t
			})).json),
			updateAnnouncement: async (t, n) => j(ir, (await e.request(`/api/v1/pleroma/admin/announcements/${t}`, {
				method: "PATCH",
				body: n
			})).json),
			deleteAnnouncement: async (t) => (await e.request(`/api/v1/pleroma/admin/announcements/${t}`, { method: "DELETE" })).json
		},
		domains: {
			getDomains: async () => {
				let t = await e.request("/api/v1/pleroma/admin/domains");
				return j(F(ur), t.json);
			},
			createDomain: async (t) => j(ur, (await e.request("/api/v1/pleroma/admin/domains", {
				method: "POST",
				body: t
			})).json),
			updateDomain: async (t, n) => j(ur, (await e.request(`/api/v1/pleroma/admin/domains/${t}`, {
				method: "PATCH",
				body: { public: n }
			})).json),
			deleteDomain: async (t) => (await e.request(`/api/v1/pleroma/admin/domains/${t}`, { method: "DELETE" })).json
		},
		moderationLog: { getModerationLog: async ({ limit: n, ...r } = {}) => {
			let i = await e.request("/api/v1/pleroma/admin/moderation_log", { params: {
				page_size: n,
				...r
			} });
			return new qn(j(F(Cr), i.json.items), {
				previous: r.page && r.page > 1 ? () => t.moderationLog.getModerationLog({
					...r,
					page: r.page - 1
				}) : null,
				next: i.json.total > (r.page || 1) * (n || 50) ? () => t.moderationLog.getModerationLog({
					...r,
					page: (r.page || 1) + 1
				}) : null,
				partial: i.status === 206
			});
		} },
		relays: {
			getRelays: async () => {
				let t;
				return e.features.adminRelaySubscriptions ? t = await e.request("/api/v1/admin/relay_subscriptions") : e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), t = await e.request("/api/iceshrimp/admin/relays")) : (t = await e.request("/api/v1/pleroma/admin/relay"), t.json = t.json.relays), j(F(Or), t.json);
			},
			followRelay: async (t, n) => {
				let r;
				return e.features.adminRelaySubscriptions ? r = await e.request("/api/v1/admin/relay_subscriptions", {
					method: "POST",
					body: {
						...n,
						relay_actor_uri: t
					}
				}) : e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), r = await e.request("/api/iceshrimp/admin/relays", {
					method: "POST",
					body: { inbox: t }
				})) : r = await e.request("/api/v1/pleroma/admin/relay", {
					method: "POST",
					body: { relay_url: t }
				}), j(/* @__PURE__ */ E(Or), r.json);
			},
			unfollowRelay: async (t, n = !1) => {
				let r;
				return e.features.adminRelaySubscriptions ? r = await e.request(`/api/v1/admin/relay_subscriptions/${t}`, { method: "DELETE" }) : e.features.version.software === "Iceshrimp.NET" ? (await e.getIceshrimpAccessToken(), r = await e.request(`/api/iceshrimp/admin/relays/${t}`, { method: "DELETE" })) : r = await e.request("/api/v1/pleroma/admin/relay", {
					method: "DELETE",
					body: {
						relay_url: t,
						force: n
					}
				}), j(/* @__PURE__ */ E(Or), r.json);
			},
			getRelay: async (t) => j(Or, (await e.request(`/api/v1/admin/relay_subscriptions/${t}`)).json),
			updateRelay: async (t, n) => j(Or, (await e.request(`/api/v1/admin/relay_subscriptions/${t}`, {
				method: "PUT",
				body: n
			})).json),
			createRelayMatcher: async (t, n) => j(Or, (await e.request(`/api/v1/admin/relay_subscriptions/${t}/matchers`, {
				method: "POST",
				body: n
			})).json),
			deleteRelayMatcher: async (t, n) => j(Or, (await e.request(`/api/v1/admin/relay_subscriptions/${t}/matchers/${n}`, { method: "DELETE" })).json),
			updateRelayMatcher: async (t, n, r) => j(Or, (await e.request(`/api/v1/admin/relay_subscriptions/${t}/matchers/${n}`, {
				method: "PUT",
				body: r
			})).json)
		},
		rules: {
			getRules: async () => {
				let t = await e.request(e.features.version.software === "GoToSocial" ? "/api/v1/admin/instance/rules" : "/api/v1/pleroma/admin/rules");
				return j(F(Di), t.json);
			},
			createRule: async (t) => j(Di, (await e.request(e.features.version.software === "GoToSocial" ? "/api/v1/admin/instance/rules" : "/api/v1/pleroma/admin/rules", {
				method: "POST",
				body: t
			})).json),
			updateRule: async (t, n) => j(Di, (await e.request(`/api/v1/${e.features.version.software === "GoToSocial" ? "admin/instance" : "pleroma/admin"}/rules/${t}`, {
				method: "PATCH",
				body: n
			})).json),
			deleteRule: async (t) => (await e.request(`/api/v1/${e.features.version.software === "GoToSocial" ? "admin/instance" : "pleroma/admin"}/rules/${t}`, { method: "DELETE" })).json
		},
		config: {
			getPleromaConfigDescriptions: async () => {
				let t = await e.request("/api/v1/pleroma/admin/config/descriptions");
				return j(/* @__PURE__ */ b(Er), t.json);
			},
			getPleromaConfig: async () => j(wr, (await e.request("/api/v1/pleroma/admin/config")).json),
			updatePleromaConfig: async (t) => j(wr, (await e.request("/api/v1/pleroma/admin/config", {
				method: "POST",
				body: { configs: t }
			})).json)
		},
		customEmojis: {
			getCustomEmojis: (t) => e.paginatedGet("/api/v1/admin/custom_emojis", { params: t }, sr),
			getCustomEmojiCategories: async () => {
				let t = await e.request("/api/v1/admin/custom_emojis/categories");
				return j(F(cr), t.json);
			},
			getCustomEmoji: async (t) => j(sr, (await e.request(`/api/v1/admin/custom_emojis/${t}`)).json),
			createCustomEmoji: async (t) => j(sr, (await e.request("/api/v1/admin/custom_emojis", {
				method: "POST",
				body: t,
				formData: !0
			})).json),
			updateCustomEmoji: async (t, n) => j(sr, (await e.request(`/api/v1/admin/custom_emojis/${t}`, {
				method: "PATCH",
				body: n,
				formData: !0
			})).json),
			deleteCustomEmoji: async (t) => j(sr, (await e.request(`/api/v1/admin/custom_emojis/${t}`, { method: "DELETE" })).json)
		},
		invites: {
			getInvites: async () => {
				let t = await e.request("/api/v1/pleroma/admin/users/invites");
				return j(F(br), t.json?.invites);
			},
			createInviteToken: async (t = {}) => e.features.iceshrimpAdmin ? (await e.getIceshrimpAccessToken(), j(br, { token: (await e.request("/api/iceshrimp/admin/invites/generate", { method: "POST" })).json.code })) : j(br, (await e.request("/api/v1/pleroma/admin/users/invite_token", {
				method: "POST",
				body: t
			})).json),
			revokeInviteToken: async (t) => e.features.iceshrimpAdmin ? (await e.getIceshrimpAccessToken(), e.request(`/api/iceshrimp/admin/invites/${t}/revoke`, { method: "POST" })) : e.request("/api/v1/pleroma/admin/users/revoke_invite", {
				method: "POST",
				body: { token: t }
			}),
			emailInvite: async (t) => {
				await e.request("/api/v1/pleroma/admin/users/email_invite", {
					method: "POST",
					body: t
				});
			}
		},
		domainLimits: {
			getDomainLimits: (t) => e.paginatedGet("/api/v1/admin/domain_limits", { params: t }, pr),
			createDomainLimit: async (t) => j(pr, (await e.request("/api/v1/admin/domain_limits", {
				method: "POST",
				body: t
			})).json),
			updateDomainLimit: async (t, n) => j(pr, (await e.request(`/api/v1/admin/domain_limits/${t}`, {
				method: "PUT",
				body: n
			})).json),
			deleteDomainLimit: async (t) => j(pr, (await e.request(`/api/v1/admin/domain_limits/${t}`, { method: "DELETE" })).json)
		},
		domainPermissionDrafts: {
			getDomainPermissionDrafts: (t) => e.paginatedGet("/api/v1/admin/domain_permission_drafts", { params: t }, mr),
			getDomainPermissionDraft: async (t) => j(mr, (await e.request(`/api/v1/admin/domain_permission_drafts/${t}`)).json),
			createDomainPermissionDraft: async (t) => j(mr, (await e.request("/api/v1/admin/domain_permission_drafts", {
				method: "POST",
				body: t
			})).json),
			acceptDomainPermissionDraft: async (t, n) => j(mr, (await e.request(`/api/v1/admin/domain_permission_drafts/${t}/accept`, {
				method: "POST",
				body: { overwrite: n }
			})).json),
			removeDomainPermissionDraft: async (t, n) => j(mr, (await e.request(`/api/v1/admin/domain_permission_drafts/${t}/remove`, {
				method: "POST",
				body: { exclude_target: n }
			})).json)
		},
		domainPermissionExcludes: {
			getDomainPermissionExcludes: (t) => e.paginatedGet("/api/v1/admin/domain_permission_excludes", { params: t }, mr),
			getDomainPermissionExclude: async (t) => j(mr, (await e.request(`/api/v1/admin/domain_permission_excludes/${t}`)).json),
			createDomainPermissionExclude: async (t) => j(mr, (await e.request("/api/v1/admin/domain_permission_excludes", {
				method: "POST",
				body: t
			})).json),
			deleteDomainPermissionExclude: async (t) => j(mr, (await e.request(`/api/v1/admin/domain_permission_excludes/${t}`, { method: "DELETE" })).json)
		},
		domainPermissionSubscriptions: {
			getDomainPermissionSubscriptions: (t) => e.paginatedGet("/api/v1/admin/domain_permission_subscriptions", { params: t }, hr),
			getDomainPermissionSubscriptionsPreview: async (t) => {
				let n = await e.request("/api/v1/admin/domain_permission_subscriptions/preview", { params: { permission_type: t } });
				return j(F(hr), n.json);
			},
			getDomainPermissionSubscription: async (t) => j(hr, (await e.request(`/api/v1/admin/domain_permission_subscriptions/${t}`)).json),
			createDomainPermissionSubscription: async (t) => j(hr, (await e.request("/api/v1/admin/domain_permission_subscriptions", {
				method: "POST",
				body: t
			})).json),
			updateDomainPermissionSubscription: async (t, n) => j(hr, (await e.request(`/api/v1/admin/domain_permission_subscriptions/${t}`, {
				method: "PATCH",
				body: n
			})).json),
			testDomainPermissionSubscription: async (t) => {
				let n = await e.request(`/api/v1/admin/domain_permission_subscriptions/${t}/test`, { method: "POST" });
				return j(F(mr), n.json);
			},
			removeDomainPermissionSubscription: async (t, n) => j(hr, (await e.request(`/api/v1/admin/domain_permission_subscriptions/${t}/remove`, {
				method: "POST",
				body: { remove_children: n }
			})).json)
		},
		headerFilters: {
			getHeaderAllows: async () => {
				let t = await e.request("/api/v1/admin/header_allows");
				return j(F(_r), t.json);
			},
			getHeaderAllow: async (t) => j(_r, (await e.request(`/api/v1/admin/header_allows/${t}`)).json),
			createHeaderAllow: async (t) => j(_r, (await e.request("/api/v1/admin/header_allows", {
				method: "POST",
				body: t
			})).json),
			deleteHeaderAllow: async (t) => (await e.request(`/api/v1/admin/header_allows/${t}`, { method: "DELETE" })).json,
			getHeaderBlocks: async () => {
				let t = await e.request("/api/v1/admin/header_blocks");
				return j(F(_r), t.json);
			},
			getHeaderBlock: async (t) => j(_r, (await e.request(`/api/v1/admin/header_blocks/${t}`)).json),
			createHeaderBlock: async (t) => j(_r, (await e.request("/api/v1/admin/header_blocks", {
				method: "POST",
				body: t
			})).json),
			deleteHeaderBlock: async (t) => (await e.request(`/api/v1/admin/header_blocks/${t}`, { method: "DELETE" })).json
		},
		instances: {
			getInstances: (t) => e.paginatedGet("/api/v1/admin/instances", { params: t }, yr),
			getInstance: async (t) => j(yr, (await e.request(`/api/v1/admin/instances/${t}`)).json),
			clearInstanceDeliveryErrors: async (t) => j(yr, (await e.request(`/api/v1/admin/instances/${t}/clear_delivery_errors`, { method: "POST" })).json)
		},
		media: {
			cleanupMedia: async (t) => (await e.request("/api/v1/admin/media_cleanup", {
				method: "POST",
				params: t
			})).json,
			purgeMedia: async (t) => (await e.request("/api/v1/admin/media_purge", {
				method: "POST",
				params: { domain: t }
			})).json,
			refetchMedia: async (t) => (await e.request("/api/v1/admin/media_refetch", {
				method: "POST",
				params: { domain: t }
			})).json
		},
		email: { sendTestEmail: async (t, n) => (await e.request("/api/v1/admin/email/test", {
			method: "POST",
			body: {
				email: t,
				message: n
			},
			formData: !0
		})).json },
		policies: {
			getPolicies: async () => (await e.getIceshrimpAccessToken(), (await e.request("/api/iceshrimp/admin/policy")).json),
			getPolicy: async (t) => (await e.getIceshrimpAccessToken(), (await e.request(`/api/iceshrimp/admin/policy/${t}`)).json),
			setPolicy: async (t, n) => (await e.getIceshrimpAccessToken(), (await e.request(`/api/iceshrimp/admin/policy/${t}`, {
				method: "PUT",
				body: n
			})).json)
		}
	};
	return t;
}, Zo = (e) => ({
	getAnnouncements: async () => {
		let t = await e.request("/api/v1/announcements");
		return j(F(rr), t.json);
	},
	dismissAnnouncements: async (t) => (await e.request(`/api/v1/announcements/${t}`, { method: "POST" })).json,
	addAnnouncementReaction: async (t, n) => (await e.request(`/api/v1/announcements/${t}/reactions/${n}`, { method: "PUT" })).json,
	deleteAnnouncementReaction: async (t, n) => (await e.request(`/api/v1/announcements/${t}/reactions/${n}`, { method: "DELETE" })).json
}), Qo = (e) => ({
	fetchAntennas: async () => {
		let t = await e.request("/api/v1/antennas");
		return j(F(Ai), t.json);
	},
	getAntennas: async (t) => j(Ai, (await e.request(`/api/v1/antennas/${t}`)).json),
	createAntenna: async (t) => j(Ai, (await e.request("/api/v1/antennas", {
		method: "POST",
		body: t
	})).json),
	updateAntenna: async (t, n) => j(Ai, (await e.request(`/api/v1/antennas/${t}`, {
		method: "PUT",
		body: n
	})).json),
	deleteAntenna: async (t) => (await e.request(`/api/v1/antennas/${t}`, { method: "DELETE" })).json,
	getAntennaAccounts: (t) => e.paginatedGet(`/api/v1/antennas/${t}/accounts`, {}, L),
	addAntennaAccounts: async (t, n) => (await e.request(`/api/v1/antennas/${t}/accounts`, {
		method: "POST",
		body: { account_ids: n }
	})).json,
	removeAntennaAccounts: async (t, n) => (await e.request(`/api/v1/antennas/${t}/accounts`, {
		method: "DELETE",
		body: { account_ids: n }
	})).json,
	getAntennaExcludedAccounts: (t) => e.paginatedGet(`/api/v1/antennas/${t}/exclude_accounts`, {}, L),
	addAntennaExcludedAccounts: async (t, n) => (await e.request(`/api/v1/antennas/${t}/exclude_accounts`, {
		method: "POST",
		body: { account_ids: n }
	})).json,
	removeAntennaExcludedAccounts: async (t, n) => (await e.request(`/api/v1/antennas/${t}/exclude_accounts`, {
		method: "DELETE",
		body: { account_ids: n }
	})).json,
	getAntennaDomains: async (t) => {
		let n = await e.request(`/api/v1/antennas/${t}/domains`);
		return j(/* @__PURE__ */ T({
			domains: F(/* @__PURE__ */ k()),
			exclude_domains: F(/* @__PURE__ */ k())
		}), n.json);
	},
	addAntennaDomains: async (t, n) => (await e.request(`/api/v1/antennas/${t}/domains`, {
		method: "POST",
		body: { domains: n }
	})).json,
	removeAntennaDomains: async (t, n) => (await e.request(`/api/v1/antennas/${t}/domains`, {
		method: "DELETE",
		body: { domains: n }
	})).json,
	addAntennaExcludedDomains: async (t, n) => (await e.request(`/api/v1/antennas/${t}/exclude_domains`, {
		method: "POST",
		body: { domains: n }
	})).json,
	removeAntennaExcludedDomains: async (t, n) => (await e.request(`/api/v1/antennas/${t}/exclude_domains`, {
		method: "DELETE",
		body: { domains: n }
	})).json,
	getAntennaKeywords: async (t) => {
		let n = await e.request(`/api/v1/antennas/${t}/keywords`);
		return j(/* @__PURE__ */ T({
			keywords: F(/* @__PURE__ */ k()),
			exclude_keywords: F(/* @__PURE__ */ k())
		}), n.json);
	},
	addAntennaKeywords: async (t, n) => (await e.request(`/api/v1/antennas/${t}/keywords`, {
		method: "POST",
		body: { keywords: n }
	})).json,
	removeAntennaKeywords: async (t, n) => (await e.request(`/api/v1/antennas/${t}/keywords`, {
		method: "DELETE",
		body: { keywords: n }
	})).json,
	addAntennaExcludedKeywords: async (t, n) => (await e.request(`/api/v1/antennas/${t}/exclude_keywords`, {
		method: "POST",
		body: { keywords: n }
	})).json,
	removeAntennaExcludedKeywords: async (t, n) => (await e.request(`/api/v1/antennas/${t}/exclude_keywords`, {
		method: "DELETE",
		body: { keywords: n }
	})).json,
	getAntennaTags: async (t) => {
		let n = await e.request(`/api/v1/antennas/${t}/tags`);
		return j(/* @__PURE__ */ T({
			tags: F(/* @__PURE__ */ k()),
			exclude_tags: F(/* @__PURE__ */ k())
		}), n.json);
	},
	addAntennaTags: async (t, n) => (await e.request(`/api/v1/antennas/${t}/tags`, {
		method: "POST",
		body: { tags: n }
	})).json,
	removeAntennaTags: async (t, n) => (await e.request(`/api/v1/antennas/${t}/tags`, {
		method: "DELETE",
		body: { tags: n }
	})).json,
	addAntennaExcludedTags: async (t, n) => (await e.request(`/api/v1/antennas/${t}/exclude_tags`, {
		method: "POST",
		body: { tags: n }
	})).json,
	removeAntennaExcludedTags: async (t, n) => (await e.request(`/api/v1/antennas/${t}/exclude_tags`, {
		method: "DELETE",
		body: { tags: n }
	})).json
}), $o = (e) => ({
	createApplication: async (t) => j(Mi, (await e.request("/api/v1/apps", {
		method: "POST",
		body: t
	})).json),
	verifyApplication: async () => j(ji, (await e.request("/api/v1/apps/verify_credentials")).json)
}), es = (e) => ({ show: async (t) => j(Ni, (await e.request(`/api/v1_alpha/async_refreshes/${t}`)).json) }), ts = (e) => ({
	createChat: async (t) => j(Ri, (await e.request(`/api/v1/pleroma/chats/by-account-id/${t}`, { method: "POST" })).json),
	getChat: async (t) => j(Ri, (await e.request(`/api/v1/pleroma/chats/${t}`)).json),
	markChatAsRead: async (t, n) => j(Ri, (await e.request(`/api/v1/pleroma/chats/${t}/read`, {
		method: "POST",
		body: { last_read_id: n }
	})).json),
	markChatMessageAsRead: async (t, n) => j(Ri, (await e.request(`/api/v1/pleroma/chats/${t}/messages/${n}/read`, { method: "POST" })).json),
	getChats: (t) => e.paginatedGet("/api/v2/pleroma/chats", { params: t }, Ri),
	getChatMessages: (t, n) => e.paginatedGet(`/api/v1/pleroma/chats/${t}/messages`, { params: n }, Li),
	createChatMessage: async (t, n) => j(Li, (await e.request(`/api/v1/pleroma/chats/${t}/messages`, {
		method: "POST",
		body: n
	})).json),
	deleteChatMessage: async (t, n) => j(Li, (await e.request(`/api/v1/pleroma/chats/${t}/messages/${n}`, { method: "DELETE" })).json),
	deleteChat: async (t) => j(Ri, (await e.request(`/api/v1/pleroma/chats/${t}`, { method: "DELETE" })).json)
}), ns = (e) => ({
	fetchCircles: async () => {
		let t = await e.request("/api/v1/circles");
		return j(F(zi), t.json);
	},
	getCircle: async (t) => j(zi, (await e.request(`/api/v1/circles/${t}`)).json),
	createCircle: async (t) => j(zi, (await e.request("/api/v1/circles", {
		method: "POST",
		body: { title: t }
	})).json),
	updateCircle: async (t, n) => j(zi, (await e.request(`/api/v1/circles/${t}`, {
		method: "PUT",
		body: { title: n }
	})).json),
	deleteCircle: async (t) => (await e.request(`/api/v1/circles/${t}`, { method: "DELETE" })).json,
	getCircleAccounts: (t, n) => e.paginatedGet(`/api/v1/circles/${t}/accounts`, { params: n }, L),
	addCircleAccounts: async (t, n) => (await e.request(`/api/v1/circles/${t}/accounts`, {
		method: "POST",
		body: { account_ids: n }
	})).json,
	deleteCircleAccounts: async (t, n) => (await e.request(`/api/v1/circles/${t}/accounts`, {
		method: "DELETE",
		body: { account_ids: n }
	})).json,
	getCircleStatuses: (t, n) => e.paginatedGet(`/api/v1/circles/${t}/statuses`, { params: n }, $)
}), rs = (e) => {
	let t = async (n, r) => {
		let i = await e.request(n, { params: r }), { prev: a, next: o } = Hn(i);
		return new qn(j(F(jr), i.json?.collections), {
			previous: a ? () => t(a) : null,
			next: o ? () => t(o) : null,
			partial: i.status === 206
		});
	};
	return {
		createCollection: async (t) => j(jr, (await e.request("/api/v1/collections", {
			method: "POST",
			body: t
		})).json?.collection),
		getCollection: async (t) => j(Mr, (await e.request(`/api/v1/collections/${t}`)).json),
		getAccountCollections: (e, n) => t(`/api/v1/accounts/${e}/collections`, n),
		getAccountInCollections: (e, n) => t(`/api/v1/accounts/${e}/in_collections`, n),
		updateCollection: async (t, n) => j(jr, (await e.request(`/api/v1/collections/${t}`, {
			method: "PATCH",
			body: n
		})).json?.collection),
		deleteCollection: async (t) => (await e.request(`/api/v1/collections/${t}`, { method: "DELETE" })).json,
		addCollectionItem: async (t, n) => j(Ar, (await e.request(`/api/v1/collections/${t}/items`, {
			method: "POST",
			body: { account_id: n }
		})).json?.collection_item),
		removeCollectionItem: async (t, n) => (await e.request(`/api/v1/collections/${t}/items/${n}`, { method: "DELETE" })).json,
		revokeCollectionItem: async (t, n) => (await e.request(`/api/v1/collections/${t}/items/${n}/revoke`, { method: "POST" })).json
	};
}, is = (e) => ({
	getDrive: async () => (await e.getIceshrimpAccessToken(), j(Xi, (await e.request("/api/iceshrimp/drive/folder")).json)),
	getFolder: async (t) => (await e.getIceshrimpAccessToken(), j(Xi, (await e.request(`/api/iceshrimp/drive/folder/${t}`)).json)),
	createFolder: async (t, n) => (await e.getIceshrimpAccessToken(), j(Xi, (await e.request("/api/iceshrimp/drive/folder", {
		method: "POST",
		body: {
			name: t,
			parentId: n || null
		}
	})).json)),
	updateFolder: async (t, n) => (await e.getIceshrimpAccessToken(), j(Xi, (await e.request(`/api/iceshrimp/drive/folder/${t}`, {
		method: "PUT",
		body: n
	})).json)),
	deleteFolder: async (t) => (await e.getIceshrimpAccessToken(), await e.request(`/api/iceshrimp/drive/folder/${t}`, { method: "DELETE" })),
	moveFolder: async (t, n) => (await e.getIceshrimpAccessToken(), j(Xi, (await e.request(`/api/iceshrimp/drive/folder/${t}/move`, {
		method: "POST",
		body: { folderId: n || null }
	})).json)),
	getFile: async (t) => (await e.getIceshrimpAccessToken(), j(qi, (await e.request(`/api/iceshrimp/drive/${t}`)).json)),
	createFile: async (t, n) => (await e.getIceshrimpAccessToken(), j(qi, (await e.request("/api/iceshrimp/drive", {
		method: "POST",
		body: { file: t },
		params: { folderId: n },
		formData: !0
	})).json)),
	updateFile: async (t, n) => (await e.getIceshrimpAccessToken(), j(qi, (await e.request(`/api/iceshrimp/drive/${t}`, {
		method: "PATCH",
		body: n
	})).json)),
	deleteFile: async (t) => (await e.getIceshrimpAccessToken(), await e.request(`/api/iceshrimp/drive/${t}`, { method: "DELETE" })),
	moveFile: async (t, n) => (await e.getIceshrimpAccessToken(), j(qi, (await e.request(`/api/iceshrimp/drive/${t}/move`, {
		method: "POST",
		body: { folderId: n || null }
	})).json)),
	getDriveStatus: async () => (await e.getIceshrimpAccessToken(), j(Zi, (await e.request("/api/iceshrimp/drive/status")).json))
}), as = (e) => ({ resendConfirmationEmail: async (t) => (await e.request("/api/v1/emails/confirmations", {
	method: "POST",
	body: { email: t }
})).json }), os = (e) => ({
	createEvent: async (t) => j($, (await e.request("/api/v1/pleroma/events", {
		method: "POST",
		body: t
	})).json),
	editEvent: async (t, n) => j($, (await e.request(`/api/v1/pleroma/events/${t}`, {
		method: "PUT",
		body: n
	})).json),
	getJoinedEvents: (t, n) => e.paginatedGet("/api/v1/pleroma/events/joined_events", { params: {
		...n,
		state: t
	} }, $),
	getEventParticipations: (t, n) => e.paginatedGet(`/api/v1/pleroma/events/${t}/participations`, { params: n }, L),
	getEventParticipationRequests: (t, n) => e.paginatedGet(`/api/v1/pleroma/events/${t}/participation_requests`, { params: n }, /* @__PURE__ */ T({
		account: L,
		participation_message: /* @__PURE__ */ v(/* @__PURE__ */ k(), "")
	})),
	acceptEventParticipationRequest: async (t, n) => j($, (await e.request(`/api/v1/pleroma/events/${t}/participation_requests/${n}/authorize`, { method: "POST" })).json),
	rejectEventParticipationRequest: async (t, n) => j($, (await e.request(`/api/v1/pleroma/events/${t}/participation_requests/${n}/reject`, { method: "POST" })).json),
	joinEvent: async (t, n) => j($, (await e.request(`/api/v1/pleroma/events/${t}/join`, {
		method: "POST",
		body: { participation_message: n }
	})).json),
	leaveEvent: async (t) => j($, (await e.request(`/api/v1/pleroma/events/${t}/leave`, { method: "POST" })).json),
	getEventIcs: async (t) => (await e.request(`/api/v1/pleroma/events/${t}/ics`, { formData: !0 })).data
}), ss = (e) => {
	let t = {
		admin: { groups: {
			getGroups: async (t) => {
				let n = await e.request("/api/v1/admin/groups", { params: t });
				return j(F(Wr), n.json);
			},
			getGroup: async (t) => j(Wr, (await e.request(`/api/v1/admin/groups/${t}`)).json),
			suspendGroup: async (t) => j(Wr, (await e.request(`/api/v1/admin/groups/${t}/suspend`, { method: "POST" })).json),
			unsuspendGroup: async (t) => j(Wr, (await e.request(`/api/v1/admin/groups/${t}/unsuspend`, { method: "POST" })).json),
			deleteGroup: async (t) => j(Wr, (await e.request(`/api/v1/admin/groups/${t}`, { method: "DELETE" })).json)
		} },
		groups: {
			getGroups: async () => {
				let t;
				return t = e.features.version.software === "Pixelfed" ? await e.request("/api/v0/groups/self/list") : await e.request("/api/v1/groups"), j(F(Wr), t.json);
			},
			createGroup: async (n) => {
				let r;
				if (e.features.version.software === "Pixelfed") {
					if (r = await e.request("/api/v0/groups/create", {
						method: "POST",
						body: {
							...n,
							name: n.display_name,
							description: n.note,
							membership: "public"
						},
						formData: !!(n.avatar || n.header)
					}), r.json?.id) return t.groups.getGroup(r.json.id);
				} else r = await e.request("/api/v1/groups", {
					method: "POST",
					body: n,
					formData: !!(n.avatar || n.header)
				});
				return j(Wr, r.json);
			},
			getGroup: async (t) => {
				let n;
				return n = e.features.version.software === "Pixelfed" ? await e.request(`/api/v0/groups/${t}`) : await e.request(`/api/v1/groups/${t}`), j(Wr, n.json);
			},
			updateGroup: async (t, n) => j(Wr, (await e.request(`/api/v1/groups/${t}`, {
				method: "PUT",
				body: n,
				formData: !!(n.avatar || n.header)
			})).json),
			deleteGroup: async (t) => {
				let n;
				return n = e.features.version.software === "Pixelfed" ? await e.request("/api/v0/groups/delete", {
					method: "POST",
					params: { gid: t }
				}) : await e.request(`/api/v1/groups/${t}`, { method: "DELETE" }), n.json;
			},
			getGroupMemberships: (t, n, r) => e.paginatedGet(e.features.version.software === "Pixelfed" ? `/api/v0/groups/members/list?gid=${t}` : `/api/v1/groups/${t}/memberships`, { params: {
				...r,
				role: n
			} }, Hr),
			getGroupMembershipRequests: (t, n) => e.paginatedGet(e.features.version.software === "Pixelfed" ? `/api/v0/groups/members/requests?gid=${t}` : `/api/v1/groups/${t}/membership_requests`, { params: n }, L),
			acceptGroupMembershipRequest: async (t, n) => (await e.request(`/api/v1/groups/${t}/membership_requests/${n}/authorize`, { method: "POST" })).json,
			rejectGroupMembershipRequest: async (t, n) => (await e.request(`/api/v1/groups/${t}/membership_requests/${n}/reject`, { method: "POST" })).json,
			deleteGroupStatus: async (t, n) => j($, (await e.request(`/api/v1/groups/${t}/statuses/${n}`, { method: "DELETE" })).json),
			getGroupBlocks: (t, n) => e.paginatedGet(`/api/v1/groups/${t}/blocks`, { params: n }, L),
			blockGroupUsers: async (t, n) => (await e.request(`/api/v1/groups/${t}/blocks`, {
				method: "POST",
				params: { account_ids: n }
			})).json,
			unblockGroupUsers: async (t, n) => (await e.request(`/api/v1/groups/${t}/blocks`, {
				method: "DELETE",
				params: { account_ids: n }
			})).json,
			joinGroup: async (t) => j(Ur, (await e.request(`/api/v1/groups/${t}/join`, { method: "POST" })).json),
			leaveGroup: async (t) => j(Ur, (await e.request(`/api/v1/groups/${t}/leave`, { method: "POST" })).json),
			kickGroupUsers: async (t, n) => (await e.request(`/api/v1/groups/${t}/kick`, {
				method: "POST",
				params: { account_ids: n }
			})).json,
			promoteGroupUsers: async (t, n, r) => {
				let i = await e.request(`/api/v1/groups/${t}/promote`, {
					method: "POST",
					params: {
						account_ids: n,
						role: r
					}
				});
				return j(F(Hr), i.json);
			},
			demoteGroupUsers: async (t, n, r) => {
				let i = await e.request(`/api/v1/groups/${t}/demote`, {
					method: "POST",
					params: {
						account_ids: n,
						role: r
					}
				});
				return j(F(Hr), i.json);
			},
			getGroupRelationships: async (t) => {
				let n = await e.request("/api/v1/groups/relationships", { params: { id: t } });
				return j(F(Ur), n.json);
			}
		}
	};
	return t;
}, cs = (e) => ({
	blockAccount: async (t, n) => j(N, (await e.request(`/api/v1/accounts/${t}/block`, {
		method: "POST",
		body: n
	})).json),
	unblockAccount: async (t) => j(N, (await e.request(`/api/v1/accounts/${t}/unblock`, { method: "POST" })).json),
	muteAccount: async (t, n) => j(N, (await e.request(`/api/v1/accounts/${t}/mute`, {
		method: "POST",
		body: n
	})).json),
	unmuteAccount: async (t) => j(N, (await e.request(`/api/v1/accounts/${t}/unmute`, { method: "POST" })).json),
	getMutes: (t) => e.paginatedGet("/api/v1/mutes", { params: t }, it),
	getBlocks: (t) => e.paginatedGet("/api/v1/blocks", { params: t }, rt),
	getDomainBlocks: (t) => e.paginatedGet("/api/v1/domain_blocks", { params: t }, /* @__PURE__ */ k()),
	blockDomain: async (t) => (await e.request("/api/v1/domain_blocks", {
		method: "POST",
		body: { domain: t }
	})).json,
	unblockDomain: async (t) => (await e.request("/api/v1/domain_blocks", {
		method: "DELETE",
		body: { domain: t }
	})).json,
	getFilters: async () => {
		let t = await e.request(e.features.filtersV2 ? "/api/v2/filters" : "/api/v1/filters");
		return j(F(zr), t.json);
	},
	getFilter: async (t) => j(zr, (await e.request(e.features.filtersV2 ? `/api/v2/filters/${t}` : `/api/v1/filters/${t}`)).json),
	createFilter: async (t) => {
		let { filtersV2: n } = e.features;
		return j(zr, (await e.request(n ? "/api/v2/filters" : "/api/v1/filters", {
			method: "POST",
			body: n ? t : {
				phrase: t.keywords_attributes[0]?.keyword,
				context: t.context,
				irreversible: t.filter_action === "hide",
				whole_word: t.keywords_attributes[0]?.whole_word,
				expires_in: t.expires_in
			}
		})).json);
	},
	updateFilter: async (t, n) => {
		let { filtersV2: r } = e.features;
		return j(zr, (await e.request(r ? `/api/v2/filters/${t}` : `/api/v1/filters/${t}`, {
			method: "PUT",
			body: r ? n : {
				phrase: n.keywords_attributes?.[0]?.keyword,
				context: n.context,
				irreversible: n.filter_action === "hide",
				whole_word: n.keywords_attributes?.[0]?.whole_word,
				expires_in: n.expires_in
			}
		})).json);
	},
	deleteFilter: async (t) => (await e.request(e.features.filtersV2 ? `/api/v2/filters/${t}` : `/api/v1/filters/${t}`, { method: "DELETE" })).json,
	getFilterKeywords: async (t) => {
		let n = await e.request(`/api/v2/filters/${t}/keywords`);
		return j(F(Ir), n.json);
	},
	addFilterKeyword: async (t, n, r) => j(Ir, (await e.request(`/api/v2/filters/${t}/keywords`, {
		method: "POST",
		body: {
			keyword: n,
			whole_word: r
		}
	})).json),
	getFilterKeyword: async (t) => j(Ir, (await e.request(`/api/v2/filters/keywords/${t}`)).json),
	updateFilterKeyword: async (t, n, r) => j(Ir, (await e.request(`/api/v2/filters/keywords/${t}`, {
		method: "PUT",
		body: {
			keyword: n,
			whole_word: r
		}
	})).json),
	deleteFilterKeyword: async (t) => (await e.request(`/api/v2/filters/keywords/${t}`, { method: "DELETE" })).json,
	getFilterStatuses: async (t) => {
		let n = await e.request(`/api/v2/filters/${t}/statuses`);
		return j(F(Lr), n.json);
	},
	addFilterStatus: async (t, n) => j(Lr, (await e.request(`/api/v2/filters/${t}/statuses`, {
		method: "POST",
		body: { status_id: n }
	})).json),
	getFilterStatus: async (t) => j(Lr, (await e.request(`/api/v2/filters/statuses/${t}`)).json),
	deleteFilterStatus: async (t) => (await e.request(`/api/v2/filters/statuses/${t}`, { method: "DELETE" })).json
}), ls = (e) => ({ searchGifs: async (t, n) => j(na, (await e.request("/api/v1/gifs", {
	...n,
	params: { q: t }
})).json) }), us = [
	"favourite",
	"reblog",
	"emoji_reaction",
	"event_reminder",
	"participation_accepted",
	"participation_request",
	"update",
	"quoted_update"
], ds = ({ previous: e, next: t, items: n, ...r }, i) => {
	let a = [];
	for (let e of n) {
		let t;
		(i?.grouped_types || us).includes(e.type) && (t = a.find((t) => t.type === e.type && (e.type === "emoji_reaction" && t.type === "emoji_reaction" ? e.emoji === t.emoji : !0) && t.status_id === e.status?.id)), t ? (t.notifications_count += 1, t.page_min_id = e.id, t.sample_account_ids.includes(e.account.id) || t.sample_account_ids.push(e.account.id)) : a.push({
			...Le(e, [
				"account",
				"status",
				"target"
			]),
			group_key: e.id,
			notifications_count: 1,
			most_recent_notification_id: e.id,
			page_min_id: e.id,
			page_max_id: e.id,
			latest_page_notification_at: e.created_at,
			sample_account_ids: [e.account.id],
			status_id: e.status?.id,
			target_id: e.target?.id
		});
	}
	let o = {
		accounts: Object.values(n.reduce((e, t) => (e[t.account.id] = t.account, "target" in t && (e[t.target.id] = t.target), e), {})),
		statuses: Object.values(n.reduce((e, t) => ("status" in t && t.status && (e[t.status.id] = t.status), e), {})),
		notification_groups: a
	};
	return {
		...r,
		previous: e ? async () => ds(await e(), i) : null,
		next: t ? async () => ds(await t(), i) : null,
		items: o
	};
}, fs = (e) => {
	let t = {
		getGroupedNotifications: async (t, n) => e.features.groupedNotifications ? (t?.types && (t.types = ia(t.types)), t?.exclude_types && (t.exclude_types = ia(t.exclude_types)), e.paginatedGet("/api/v2/notifications", {
			...n,
			params: t
		}, Ca, !1)) : ds(await e.notifications.getNotifications(Ie(t, [
			"max_id",
			"since_id",
			"limit",
			"min_id",
			"types",
			"exclude_types",
			"account_id",
			"include_filtered"
		])), t),
		getNotificationGroup: async (t) => e.features.groupedNotifications ? j(Ca, (await e.request(`/api/v2/notifications/${t}`)).json) : ds(new qn([(await e.request(`/api/v1/notifications/${t}`)).json], { partial: !1 })).items,
		dismissNotificationGroup: async (t) => e.features.groupedNotifications ? (await e.request(`/api/v2/notifications/${t}/dismiss`, { method: "POST" })).json : e.notifications.dismissNotification(t),
		getNotificationGroupAccounts: async (n) => {
			if (e.features.groupedNotifications) {
				let t = await e.request(`/api/v2/notifications/${n}/accounts`);
				return j(F(L), t.json);
			}
			return (await t.getNotificationGroup(n)).accounts;
		},
		getUnreadNotificationGroupCount: async (t) => {
			if (e.features.groupedNotifications) {
				let n = await e.request("/api/v2/notifications/unread_count", { params: t });
				return j(/* @__PURE__ */ T({ count: /* @__PURE__ */ w() }), n.json);
			}
			return e.notifications.getUnreadNotificationCount(Ie(t || {}, [
				"limit",
				"types",
				"exclude_types",
				"account_id"
			]));
		}
	};
	return t;
}, ps = (e) => ({
	getInstance: (() => {
		let t, n = (t) => {
			let n = j(/* @__PURE__ */ M(xt, /* @__PURE__ */ _e()), t);
			return e.setInstance(n), n;
		}, r = async () => {
			if (e.instanceInformation.domain) try {
				let t = await e.request(e.features.instanceV2 ? "/api/v2/instance" : "/api/v1/instance");
				return n(t.json);
			} catch (t) {
				if (!e.features.instanceV2) throw t;
				let r = await e.request("/api/v1/instance");
				return n(r.json);
			}
			let t = await e.request("/api/v1/instance"), r = n(t.json);
			if (!e.features.instanceV2) return r;
			try {
				let t = await e.request("/api/v2/instance");
				return n(t.json);
			} catch {
				return r;
			}
		};
		return () => t || (t = r(), t.then(() => {
			t = void 0;
		}, () => {
			t = void 0;
		}), t);
	})(),
	getInstancePeers: async () => {
		let t = await e.request("/api/v1/instance/peers");
		return j(/* @__PURE__ */ b(/* @__PURE__ */ k()), t.json);
	},
	getInstanceActivity: async () => {
		let t = await e.request("/api/v1/instance/activity");
		return j(/* @__PURE__ */ b(/* @__PURE__ */ T({
			week: /* @__PURE__ */ k(),
			statuses: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
			logins: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String)),
			registrations: /* @__PURE__ */ M(/* @__PURE__ */ A(), /* @__PURE__ */ g(String))
		})), t.json);
	},
	getInstanceRules: async () => {
		let t = await e.request("/api/v1/instance/rules");
		return j(F(at), t.json);
	},
	getInstanceDomainBlocks: async () => {
		let t = await e.request("/api/v1/instance/rules");
		return j(F(Ki), t.json);
	},
	getInstanceExtendedDescription: async () => j(Qi, (await e.request("/api/v1/instance/extended_description")).json),
	getInstanceTranslationLanguages: async () => {
		if (e.features.version.software === "Akkoma") {
			let t = await e.request("/api/v1/akkoma/translation/languages");
			return Object.fromEntries(t.json.source.map((e) => [e.code.toLocaleLowerCase(), t.json.target.map((e) => e.code).filter((t) => t !== e.code).map((e) => e.toLocaleLowerCase())]));
		}
		let t = await e.request("/api/v1/instance/translation_languages");
		return j(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ b(/* @__PURE__ */ k())), t.json);
	},
	profileDirectory: async (t) => {
		let n = await e.request("/api/v1/directory", { params: t });
		return j(F(L), n.json);
	},
	getCustomEmojis: async () => {
		let t = await e.request("/api/v1/custom_emojis");
		return j(F(We), t.json);
	},
	getFrontendConfigurations: async () => {
		let t;
		switch (e.features.version.software) {
			case K:
				if (!e.accessToken) return {};
				t = (await e.request("/api/v1/accounts/verify_credentials")).json?.client_config;
				break;
			default: t = (await e.request("/api/pleroma/frontend_configurations")).json;
		}
		return j(/* @__PURE__ */ v(/* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ y())), {}), t);
	},
	getInstancePrivacyPolicy: async () => j(oo, (await e.request("/api/v1/instance/privacy_policy")).json),
	getInstanceTermsOfService: async () => j(Bo, (await e.request("/api/v1/instance/terms_of_service")).json),
	getInstanceTermsOfServiceForDate: async (t) => j(Bo, (await e.request(`/api/v1/instance/terms_of_service/${t}`)).json),
	getInstanceBubbleDomains: async () => {
		let t = await e.request("/api/v1/instance/bubble_domains");
		return j(/* @__PURE__ */ b(/* @__PURE__ */ k()), t.json);
	}
}), ms = (e) => ({
	getInteractionRequests: (t) => e.paginatedGet("/api/v1/interaction_requests", { params: t }, wa),
	getInteractionRequest: async (t) => j(wa, (await e.request(`/api/v1/interaction_requests/${t}`)).json),
	authorizeInteractionRequest: async (t) => j(wa, (await e.request(`/api/v1/interaction_requests/${t}/authorize`, { method: "POST" })).json),
	rejectInteractionRequest: async (t) => j(wa, (await e.request(`/api/v1/interaction_requests/${t}/authorize`, { method: "POST" })).json)
}), hs = (e) => ({
	getLists: async () => {
		let t = await e.request("/api/v1/lists");
		return j(F(ki), t.json);
	},
	getList: async (t) => j(ki, (await e.request(`/api/v1/lists/${t}`)).json),
	createList: async (t) => j(ki, (await e.request("/api/v1/lists", {
		method: "POST",
		body: t
	})).json),
	updateList: async (t, n) => j(ki, (await e.request(`/api/v1/lists/${t}`, {
		method: "PUT",
		body: n
	})).json),
	deleteList: async (t) => (await e.request(`/api/v1/lists/${t}`, { method: "DELETE" })).json,
	getListAccounts: (t, n) => e.paginatedGet(`/api/v1/lists/${t}/accounts`, { params: n }, L),
	addListAccounts: async (t, n) => (await e.request(`/api/v1/lists/${t}/accounts`, {
		method: "POST",
		body: { account_ids: n }
	})).json,
	deleteListAccounts: async (t, n) => (await e.request(`/api/v1/lists/${t}/accounts`, {
		method: "DELETE",
		body: { account_ids: n }
	})).json,
	favouriteList: async (t) => j(ki, (await e.request(`/api/v1/lists/${t}/favourite`, { method: "POST" })).json),
	unfavouriteList: async (t) => j(ki, (await e.request(`/api/v1/lists/${t}/unfavourite`, { method: "POST" })).json)
}), gs = (e) => ({
	uploadMedia: async (t, n) => j(ci, (await e.request(e.features.mediaV2 ? "/api/v2/media" : "/api/v1/media", {
		...n,
		method: "POST",
		body: t,
		formData: !0
	})).json),
	getMedia: async (t) => j(ci, (await e.request(`/api/v1/media/${t}`)).json),
	updateMedia: async (t, n) => j(ci, (await e.request(`/api/v1/media/${t}`, {
		method: "PUT",
		body: n,
		formData: !!n.thumbnail
	})).json),
	deleteMedia: async (t) => (await e.request(`/api/v1/media/${t}`, { method: "DELETE" })).json
}), _s = async (e, t, n) => {
	let r = await e.request(t, {
		method: "POST",
		body: n
	});
	return e.setIceshrimpAccessToken(r.json.token), r.json;
}, vs = async (e, { appName: t, scopes: n }) => {
	let r = await e.request("/api/iceshrimp/sessions/mastodon", {
		method: "POST",
		body: {
			appName: t,
			scopes: n?.split(" "),
			flags: {
				supportsHtmlFormatting: !0,
				autoDetectQuotes: !1,
				isPleroma: !0,
				supportsInlineMedia: !0
			}
		}
	});
	return j(Vo, {
		access_token: r.json.token,
		token_type: "Bearer",
		scope: r.json.scopes.join(" "),
		created_at: new Date(r.json.created_at).getTime(),
		id: r.json.id
	});
}, ys = async (e, t, n = void 0, r) => {
	await e.getIceshrimpAccessToken();
	let i = await e.request(t, n ? { params: n } : void 0), a = r(i.json), o = await e.accounts.getAccounts(a), { prev: s, next: c } = Hn(i);
	return new qn(o, {
		previous: s ? () => ys(e, s, void 0, r) : null,
		next: c ? () => ys(e, c, void 0, r) : null,
		partial: i.status === 206
	});
}, bs = async (e, t, n = void 0, r) => {
	await e.getIceshrimpAccessToken();
	let i = await e.request(t, n ? { params: n } : void 0), a = r(i.json), o = (await e.statuses.getStatuses(a)).toReversed(), { prev: s, next: c } = Hn(i);
	return new qn(o, {
		previous: s ? () => bs(e, s, void 0, r) : null,
		next: c ? () => bs(e, c, void 0, r) : null,
		partial: i.status === 206
	});
}, xs = (e) => ({
	getBookmarks: (t) => e.paginatedGet(e.features.bookmarkFoldersMultiple && t?.folder_id ? `/api/v1/bookmark_categories/${t.folder_id}/statuses` : "/api/v1/bookmarks", { params: t }, $),
	getFavourites: (t) => e.paginatedGet("/api/v1/favourites", { params: t }, $),
	getFollowRequests: (t) => e.paginatedGet("/api/v1/follow_requests", { params: t }, L),
	getOutgoingFollowRequests: (t) => {
		if (e.features.version.software === "Iceshrimp.NET") return ys(e, "/api/iceshrimp/follow_requests/outgoing", t, (e) => e.map(({ user: e }) => e.id));
		switch (e.features.version.software) {
			case V:
			case K: return e.paginatedGet("/api/v1/follow_requests/outgoing", { params: t }, L);
			default: return e.paginatedGet("/api/v1/pleroma/outgoing_follow_requests", { params: t }, L);
		}
	},
	acceptFollowRequest: async (t) => j(N, (await e.request(`/api/v1/follow_requests/${t}/authorize`, { method: "POST" })).json),
	rejectFollowRequest: async (t) => j(N, (await e.request(`/api/v1/follow_requests/${t}/reject`, { method: "POST" })).json),
	getEndorsements: (t) => e.paginatedGet("/api/v1/endorsements", { params: t }, L),
	getFeaturedTags: async () => {
		let t = await e.request("/api/v1/featured_tags");
		return j(F(ea), t.json);
	},
	featureTag: async (t) => j(ea, (await e.request("/api/v1/featured_tags", {
		method: "POST",
		body: { name: t }
	})).json),
	unfeatureTag: async (t) => (await e.request(`/api/v1/featured_tags/${t}`, { method: "DELETE" })).json,
	getFeaturedTagsSuggestions: async () => {
		let t = await e.request("/api/v1/featured_tags/suggestions");
		return j(F(nr), t.json);
	},
	getFollowedTags: (t) => e.paginatedGet("/api/v1/followed_tags", { params: t }, nr),
	getTag: async (t) => j(nr, (await e.request(`/api/v1/tags/${t}`)).json),
	followTag: async (t) => j(nr, (await e.request(`/api/v1/tags/${t}/follow`, { method: "POST" })).json),
	unfollowTag: async (t) => j(nr, (await e.request(`/api/v1/tags/${t}/unfollow`, { method: "POST" })).json),
	getSuggestions: async (t) => {
		let n = await e.request(e.features.version.software === "Pixelfed" ? "/api/v1.1/discover/accounts/popular" : e.features.suggestionsV2 ? "/api/v2/suggestions" : "/api/v1/suggestions", { params: { limit: t } });
		return j(F(zo), n.json);
	},
	dismissSuggestions: async (t) => (await e.request(`/api/v1/suggestions/${t}`, { method: "DELETE" })).json,
	getBookmarkFolders: async () => {
		let t = await e.request(e.features.version.software === "Pleroma" ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories");
		return j(F(Ii), t.json);
	},
	createBookmarkFolder: async (t) => j(Ii, (await e.request(e.features.version.software === "Pleroma" ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories", {
		method: "POST",
		body: {
			title: t.name,
			...t
		}
	})).json),
	updateBookmarkFolder: async (t, n) => j(Ii, (await e.request(`${e.features.version.software === "Pleroma" ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories"}/${t}`, {
		method: "PATCH",
		body: {
			title: n.name,
			...n
		}
	})).json),
	deleteBookmarkFolder: async (t) => j(Ii, (await e.request(`${e.features.version.software === "Pleroma" ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories"}/${t}`, { method: "DELETE" })).json),
	addBookmarkToFolder: async (t, n) => (await e.request(`/api/v1/bookmark_categories/${n}/statuses`, {
		method: "POST",
		params: { status_ids: [t] }
	})).json,
	removeBookmarkFromFolder: async (t, n) => (await e.request(`/api/v1/bookmark_categories/${n}/statuses`, {
		method: "DELETE",
		params: { status_ids: [t] }
	})).json,
	getMutedThreads: (t) => bs(e, "/api/iceshrimp/misc/muted_threads", t, (e) => e.map(({ id: e }) => e))
}), Ss = (e) => ({
	getNotifications: (t, n) => (t?.types && (t.types = ia(t.types)), t?.exclude_types && (t.exclude_types = ia(t.exclude_types)), e.paginatedGet("/api/v1/notifications", {
		...n,
		params: t
	}, to)),
	getNotification: async (t) => j(to, (await e.request(`/api/v1/notifications/${t}`)).json),
	markNotificationsAsRead: async (t) => {
		let n = await e.request("/api/v1/pleroma/notifications/read", {
			method: "POST",
			body: { max_id: t }
		});
		return j(F(to), n.json);
	},
	dismissNotifications: async () => (await e.request("/api/v1/notifications/clear", { method: "POST" })).json,
	dismissNotification: async (t) => (await e.request(`/api/v1/notifications/${t}/dismiss`, { method: "POST" })).json,
	getUnreadNotificationCount: async (t) => {
		let n = await e.request("/api/v1/notifications/unread_count", { params: t });
		return j(/* @__PURE__ */ T({ count: /* @__PURE__ */ w() }), n.json);
	},
	getNotificationPolicy: async () => j(ro, (await e.request("/api/v2/notifications/policy")).json),
	updateNotificationPolicy: async (t) => j(ro, (await e.request("/api/v2/notifications/policy", {
		method: "PATCH",
		body: t
	})).json),
	getNotificationRequests: (t) => e.paginatedGet("/api/v1/notifications/requests", { params: t }, io),
	getNotificationRequest: async (t) => j(io, (await e.request(`/api/v1/notifications/requests/${t}`)).json),
	acceptNotificationRequest: async (t) => (await e.request(`/api/v1/notifications/requests/${t}/accept`, { method: "POST" })).json,
	dismissNotificationRequest: async (t) => (await e.request(`/api/v1/notifications/requests/${t}/dismiss`, { method: "POST" })).json,
	acceptMultipleNotificationRequests: async (t) => (await e.request("/api/v1/notifications/requests/accept", {
		method: "POST",
		body: { id: t }
	})).json,
	dismissMultipleNotificationRequests: async (t) => (await e.request("/api/v1/notifications/requests/dismiss", {
		method: "POST",
		body: { id: t }
	})).json,
	checkNotificationRequestsMerged: async () => {
		let t = await e.request("/api/v1/notifications/requests/merged");
		return j(/* @__PURE__ */ T({ merged: /* @__PURE__ */ x() }), t.json);
	},
	dismissMultipleNotifications: async (t) => (await e.request("/api/v1/notifications/destroy_multiple", {
		params: { ids: t },
		method: "DELETE"
	})).json
}), Cs = (e) => ({
	authorize: async (t) => {
		let n = await e.request("/oauth/authorize", {
			params: t,
			formData: !0
		});
		return j(/* @__PURE__ */ k(), n.json);
	},
	getToken: async (t) => {
		if (e.features.version.software === "Iceshrimp.NET" && t.grant_type === "password") {
			if ((await _s(e, "/api/iceshrimp/auth/login", {
				username: t.username,
				password: t.password
			})).status === "two_factor") throw { response: { json: { error: "mfa_required" } } };
			return vs(e, {
				appName: t.client_id,
				scopes: t.scope
			});
		}
		let n = await e.request("/oauth/token", {
			method: "POST",
			body: t,
			formData: !0
		});
		return j(Vo, {
			scope: t.scope || "",
			...n.json
		});
	},
	revokeToken: async (t) => {
		let n = await e.request("/oauth/revoke", {
			method: "POST",
			body: t,
			formData: !0
		});
		return e.socket?.close(), n.json;
	},
	userinfo: async () => j(Uo, (await e.request("/oauth/userinfo")).json),
	authorizationServerMetadata: async () => j(Pi, (await e.request("/.well-known/oauth-authorization-server")).json),
	getCaptcha: async () => {
		let t = await e.request("/api/pleroma/captcha");
		return j(/* @__PURE__ */ we([/* @__PURE__ */ T({ type: /* @__PURE__ */ k() }), /* @__PURE__ */ O(/* @__PURE__ */ k(), /* @__PURE__ */ y())]), t.json);
	},
	mfaChallenge: async (t) => e.features.version.software === "Iceshrimp.NET" ? (await _s(e, "/api/iceshrimp/auth/2fa", { code: t.code }), vs(e, {
		appName: t.client_id,
		scopes: t.scope
	})) : j(Vo, (await e.request("/oauth/mfa/challenge", {
		method: "POST",
		body: t
	})).json)
}), ws = (e) => ({ getOembed: async (t, n, r) => {
	let i = await e.request("/api/oembed", { params: {
		url: t,
		maxwidth: n,
		maxheight: r
	} });
	return j(/* @__PURE__ */ T({
		type: /* @__PURE__ */ v(/* @__PURE__ */ k(), "rich"),
		version: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		author_name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		author_url: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		provider_name: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		provider_url: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
		cache_age: /* @__PURE__ */ w(),
		html: /* @__PURE__ */ k(),
		width: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null),
		height: /* @__PURE__ */ v(/* @__PURE__ */ C(/* @__PURE__ */ w()), null)
	}), i.json);
} }), Ts = (e) => ({
	getPoll: async (t) => j(ui, (await e.request(`/api/v1/polls/${t}`)).json),
	vote: async (t, n) => j(ui, (await e.request(`/api/v1/polls/${t}/votes`, {
		method: "POST",
		body: { choices: n }
	})).json)
}), Es = (e) => ({
	createSubscription: async (t) => j(Wo, (await e.request("/api/v1/push/subscription", {
		method: "POST",
		body: t
	})).json),
	getSubscription: async () => j(Wo, (await e.request("/api/v1/push/subscription")).json),
	updateSubscription: async (t) => j(Wo, (await e.request("/api/v1/push/subscription", {
		method: "PUT",
		body: t
	})).json),
	deleteSubscription: async () => (await e.request("/api/v1/push/subscription", { method: "DELETE" })).json
}), Ds = (e) => ({
	fetchRssFeedSubscriptions: async () => {
		let t = await e.request("/api/v1/pleroma/rss_feed_subscriptions");
		return j(F(vi), t.json);
	},
	createRssFeedSubscription: async (t) => j(vi, (await e.request("/api/v1/pleroma/rss_feed_subscriptions", {
		method: "POST",
		body: { url: t }
	})).json),
	deleteRssFeedSubscription: async (t) => (await e.request("/api/v1/pleroma/rss_feed_subscriptions", {
		method: "DELETE",
		body: { url: t }
	})).json
}), Os = (e) => ({
	getScheduledStatuses: (t) => e.paginatedGet("/api/v1/scheduled_statuses", { params: t }, co),
	getScheduledStatus: async (t) => j(co, (await e.request(`/api/v1/scheduled_statuses/${t}`)).json),
	updateScheduledStatus: async (t, n) => j(co, (await e.request(`/api/v1/scheduled_statuses/${t}`, {
		method: "PUT",
		body: { scheduled_at: n }
	})).json),
	cancelScheduledStatus: async (t) => (await e.request(`/api/v1/scheduled_statuses/${t}`, { method: "DELETE" })).json
}), ks = (e) => ({
	search: async (t, n, r) => {
		let i = j(uo, (await e.request("/api/v2/search", {
			...r,
			params: {
				...n,
				q: t
			}
		})).json);
		if (n && n.resolve && n.offset && n.offset > 0) {
			let e = i.accounts[0];
			e && [e.url, e.acct].includes(t) && (i.accounts = i.accounts.slice(1));
			let n = i.statuses[0];
			n && [n.uri, n.url].includes(t) && (i.statuses = i.statuses.slice(1));
		}
		return i;
	},
	searchLocation: async (t, n) => {
		let r = await e.request("/api/v1/pleroma/search/location", {
			...n,
			params: { q: t }
		});
		return j(F(Ra), r.json);
	}
}), As = (e) => ({
	createAccount: async (t) => {
		if (e.features.version.software === "Iceshrimp.NET") return await _s(e, "/api/iceshrimp/auth/register", {
			username: t.username,
			password: t.password,
			invite: t.invite_code
		}), vs(e, {
			appName: t.client_id,
			scopes: t.scopes
		});
		let n = await e.request("/api/v1/accounts", {
			method: "POST",
			body: {
				language: t.locale,
				birthday: t.date_of_birth,
				...t
			}
		});
		return "identifier" in n.json ? j(/* @__PURE__ */ T({
			message: /* @__PURE__ */ k(),
			identifier: /* @__PURE__ */ k()
		}), n.json) : j(Vo, n.json);
	},
	verifyCredentials: async () => {
		let t = j(nt, (await e.request("/api/v1/accounts/verify_credentials")).json);
		if (e.features.version.software === "Iceshrimp.NET") {
			await e.getIceshrimpAccessToken();
			try {
				let n = await e.request("/api/iceshrimp/auth");
				t.is_admin = n.json.isAdmin, t.is_moderator = n.json.isModerator;
			} catch {}
		}
		return t;
	},
	updateCredentials: async (t) => (t.background_image && (t.pleroma_background_image = t.background_image, delete t.background_image), t.settings_store && (t.pleroma_settings_store = t.settings_store, e.features.version.software === "Mitra" && await e.request("/api/v1/settings/client_config", {
		method: "POST",
		body: t.settings_store
	}), delete t.settings_store), j(nt, (await e.request("/api/v1/accounts/update_credentials", {
		method: "PATCH",
		formData: !!(e.features.version.software === "GoToSocial" || e.features.version.software === "Iceshrimp.NET" || t.avatar || t.header),
		body: t
	})).json)),
	deleteAvatar: async () => j(nt, (await e.request("/api/v1/profile/avatar", { method: "DELETE" })).json),
	deleteHeader: async () => j(nt, (await e.request("/api/v1/profile/header", { method: "DELETE" })).json),
	getPreferences: async () => (await e.request("/api/v1/preferences")).json,
	createBackup: async () => j(Fi, (await e.request("/api/v1/pleroma/backups", { method: "POST" })).json),
	getBackups: async () => {
		let t = await e.request("/api/v1/pleroma/backups");
		return j(F(Fi), t.json);
	},
	getAccountAliases: async () => {
		let t = await e.request("/api/pleroma/aliases");
		return j(/* @__PURE__ */ T({ aliases: F(/* @__PURE__ */ k()) }), t.json);
	},
	addAccountAlias: async (t) => {
		let n = await e.request("/api/pleroma/aliases", {
			method: "PUT",
			body: { alias: t }
		});
		return j(/* @__PURE__ */ T({ status: /* @__PURE__ */ S("success") }), n.json);
	},
	deleteAccountAlias: async (t) => {
		let n = await e.request("/api/pleroma/aliases", {
			method: "DELETE",
			body: { alias: t }
		});
		return j(/* @__PURE__ */ T({ status: /* @__PURE__ */ S("success") }), n.json);
	},
	getOauthTokens: async () => {
		let t;
		switch (e.features.version.software) {
			case V:
				t = "/api/v1/tokens";
				break;
			case W:
				await e.getIceshrimpAccessToken(), t = "/api/iceshrimp/sessions/mastodon";
				break;
			case K:
				t = "/api/v1/settings/sessions";
				break;
			default: t = "/api/oauth_tokens";
		}
		return e.paginatedGet(t, {}, ao);
	},
	deleteOauthToken: async (t) => {
		let n;
		switch (e.features.version.software) {
			case V:
				n = await e.request(`/api/v1/tokens/${t}/invalidate`, { method: "POST" });
				break;
			case K:
				n = await e.request(`/api/v1/settings/sessions/${t}`, { method: "DELETE" });
				break;
			default: n = await e.request(`/api/oauth_tokens/${t}`, { method: "DELETE" });
		}
		return n.json;
	},
	changePassword: async (t, n) => {
		let r;
		switch (e.features.version.software) {
			case V:
				r = await e.request("/api/v1/user/password_change", {
					method: "POST",
					body: {
						old_password: t,
						new_password: n
					}
				});
				break;
			case W:
				await e.getIceshrimpAccessToken(), r = await e.request("/api/iceshrimp/auth/change-password", {
					method: "POST",
					body: {
						oldPassword: t,
						newPassword: n
					}
				});
				break;
			case K:
				r = await e.request("/api/v1/settings/change_password", {
					method: "POST",
					body: { new_password: n }
				});
				break;
			case J:
				if (r = await e.request("/api/v1.1/accounts/change-password", {
					method: "POST",
					body: {
						current_password: t,
						new_password: n,
						confirm_password: n
					}
				}), r.redirected) throw r;
				break;
			default: r = await e.request("/api/pleroma/change_password", {
				method: "POST",
				body: {
					password: t,
					new_password: n,
					new_password_confirmation: n
				}
			});
		}
		return r.json;
	},
	resetPassword: async (t, n) => (await e.request("/auth/password", {
		method: "POST",
		body: {
			email: t,
			nickname: n
		}
	})).json,
	changeEmail: async (t, n) => {
		let r;
		switch (e.features.version.software) {
			case V:
				r = await e.request("/api/v1/user/email_change", {
					method: "POST",
					body: {
						new_email: t,
						password: n
					}
				});
				break;
			default: r = await e.request("/api/pleroma/change_email", {
				method: "POST",
				body: {
					email: t,
					password: n
				}
			});
		}
		if (r.json?.error) throw r.json.error;
		return r.json;
	},
	deleteAccount: async (t) => {
		let n;
		switch (e.features.version.software) {
			case V:
				n = await e.request("/api/v1/accounts/delete", {
					method: "POST",
					body: { password: t }
				});
				break;
			default: n = await e.request("/api/pleroma/delete_account", {
				method: "POST",
				body: { password: t }
			});
		}
		if (n.json?.error) throw n.json.error;
		return n.json;
	},
	deleteAccountWithoutPassword: async () => (await e.request("/api/v1/settings/delete_account", { method: "POST" })).json,
	disableAccount: async (t) => {
		let n = await e.request("/api/pleroma/disable_account", {
			method: "POST",
			body: { password: t }
		});
		if (n.json?.error) throw n.json.error;
		return n.json;
	},
	moveAccount: async (t, n) => {
		let r = await e.request("/api/pleroma/move_account", {
			method: "POST",
			body: {
				password: n,
				target_account: t
			}
		});
		if (r.json?.error) throw r.json.error;
		return r.json;
	},
	mfa: {
		getMfaSettings: async () => {
			let t;
			switch (e.features.version.software) {
				case V:
					t = await e.request("/api/v1/user").then(({ json: e }) => ({ settings: {
						enabled: !!e?.two_factor_enabled_at,
						totp: !!e?.two_factor_enabled_at
					} }));
					break;
				case W:
					await e.getIceshrimpAccessToken(), t = await e.request("/api/iceshrimp/settings").then(({ json: e }) => ({ settings: {
						enabled: e.twoFactorEnrolled,
						totp: e.twoFactorEnrolled
					} }));
					break;
				default: t = (await e.request("/api/pleroma/accounts/mfa")).json;
			}
			return j(/* @__PURE__ */ T({ settings: I({
				enabled: /* @__PURE__ */ x(),
				totp: /* @__PURE__ */ x()
			}) }), t);
		},
		getMfaBackupCodes: async () => {
			let t = await e.request("/api/pleroma/accounts/mfa/backup_codes");
			return j(/* @__PURE__ */ T({ codes: /* @__PURE__ */ b(/* @__PURE__ */ k()) }), t.json);
		},
		getMfaSetup: async (t) => {
			let n;
			switch (e.features.version.software) {
				case V:
					n = await e.request("/api/v1/user/2fa/qruri").then(({ data: e }) => ({
						provisioning_uri: e,
						key: new URL(e).searchParams.get("secret")
					}));
					break;
				case W:
					await e.getIceshrimpAccessToken(), n = await e.request("/api/iceshrimp/settings/2fa/enroll", { method: "POST" }).then(({ json: e }) => ({
						provisioning_uri: e.url,
						key: e.secret
					}));
					break;
				default: n = (await e.request(`/api/pleroma/accounts/mfa/setup/${t}`)).json;
			}
			return j(/* @__PURE__ */ T({
				key: /* @__PURE__ */ v(/* @__PURE__ */ k(), ""),
				provisioning_uri: /* @__PURE__ */ k()
			}), n);
		},
		confirmMfaSetup: async (t, n, r) => {
			let i;
			switch (e.features.version.software) {
				case V:
					i = await e.request("/api/v1/user/2fa/enable", {
						method: "POST",
						body: { code: n }
					});
					break;
				case W:
					await e.getIceshrimpAccessToken(), i = await e.request("/api/iceshrimp/settings/2fa/confirm", {
						method: "POST",
						body: { code: n }
					});
					break;
				default: i = (await e.request(`/api/pleroma/accounts/mfa/confirm/${t}`, {
					method: "POST",
					body: {
						code: n,
						password: r
					}
				})).json;
			}
			if (i?.error) throw i.error;
			return i;
		},
		disableMfa: async (t, n) => {
			let r;
			switch (e.features.version.software) {
				case V:
					r = await e.request("/api/v1/user/2fa/disable", {
						method: "POST",
						body: { password: n }
					});
					break;
				default: r = await e.request(`/api/pleroma/accounts/mfa/${t}`, {
					method: "DELETE",
					body: { password: n }
				});
			}
			if (r.json?.error) throw r.json.error;
			return r.json;
		},
		disableMfaWithCode: async (t) => {
			await e.getIceshrimpAccessToken();
			let n = await e.request("/api/iceshrimp/settings/2fa/disable", {
				method: "POST",
				body: { code: t }
			});
			if (n.json?.error) throw n.json.error;
			return n.json;
		}
	},
	importFollows: async (t, n) => {
		let r;
		switch (e.features.version.software) {
			case V:
				r = await e.request("/api/v1/import", {
					method: "POST",
					body: {
						data: t,
						type: "following",
						mode: n
					},
					formData: !0
				});
				break;
			case W:
				r = await e.request("/api/iceshrimp/settings/import/following", {
					method: "POST",
					body: { file: t },
					formData: !0
				});
				break;
			case K:
				r = await e.request("/api/v1/settings/import_follows", {
					method: "POST",
					body: { follows_csv: typeof t == "string" ? t : await t.text() }
				});
				break;
			default: r = await e.request("/api/pleroma/follow_import", {
				method: "POST",
				body: { list: t },
				formData: !0
			});
		}
		return r.json;
	},
	importFollowers: async (t, n) => (await e.request("/api/v1/settings/import_followers", {
		method: "POST",
		body: {
			from_actor_id: n,
			followers_csv: typeof t == "string" ? t : await t.text()
		}
	})).json,
	importBlocks: async (t, n) => {
		let r;
		switch (e.features.version.software) {
			case V:
				r = await e.request("/api/v1/import", {
					method: "POST",
					body: {
						data: t,
						type: "blocks",
						mode: n
					},
					formData: !0
				});
				break;
			case W:
				r = await e.request("/api/iceshrimp/settings/import/blocking", {
					method: "POST",
					body: { file: t },
					formData: !0
				});
				break;
			default: r = await e.request("/api/pleroma/blocks_import", {
				method: "POST",
				body: { list: t },
				formData: !0
			});
		}
		return r.json;
	},
	importMutes: async (t, n) => {
		let r;
		switch (e.features.version.software) {
			case V:
				r = await e.request("/api/v1/import", {
					method: "POST",
					body: {
						data: t,
						type: "blocks",
						mode: n
					},
					formData: !0
				});
				break;
			case W:
				r = await e.request("/api/iceshrimp/settings/import/muting", {
					method: "POST",
					body: { file: t },
					formData: !0
				});
				break;
			default: r = await e.request("/api/pleroma/mutes_import", {
				method: "POST",
				body: { list: t },
				formData: !0
			});
		}
		return r.json;
	},
	exportFollowers: async () => {
		let t;
		switch (e.features.version.software) {
			case V:
				t = await e.request("/api/v1/exports/followers.csv", { method: "GET" });
				break;
			default: t = await e.request("/api/v1/settings/export_followers", { method: "GET" });
		}
		return t.data;
	},
	exportFollows: async () => {
		let t;
		switch (e.features.version.software) {
			case V:
				t = await e.request("/api/v1/exports/following.csv", { method: "GET" });
				break;
			default: t = await e.request("/api/v1/settings/export_follows", { method: "GET" });
		}
		return t.data;
	},
	exportLists: async () => (await e.request("/api/v1/exports/lists.csv", { method: "GET" })).data,
	exportBlocks: async () => (await e.request("/api/v1/exports/blocks.csv", { method: "GET" })).data,
	exportMutes: async () => (await e.request("/api/v1/exports/mutes.csv", { method: "GET" })).data,
	updateNotificationSettings: async (t) => {
		let n = await e.request("/api/pleroma/notification_settings", {
			method: "PUT",
			body: t
		});
		if (n.json?.error) throw n.json.error;
		return j(/* @__PURE__ */ T({ status: /* @__PURE__ */ k() }), n.json);
	},
	getInteractionPolicies: async () => j(Jr, (await e.request("/api/v1/interaction_policies/defaults")).json),
	updateInteractionPolicies: async (t) => j(Jr, (await e.request("/api/v1/interaction_policies/defaults", {
		method: "PATCH",
		body: t
	})).json),
	getAvailableFrontends: async () => {
		let t = await e.request("/api/v1/akkoma/preferred_frontend/available");
		return j(/* @__PURE__ */ b(/* @__PURE__ */ k()), t.json);
	},
	setPreferredFrontend: async (t) => {
		let n = await e.request("/api/v1/akkoma/preferred_frontend", {
			method: "PUT",
			body: { frontend_name: t }
		});
		return j(/* @__PURE__ */ T({ frontend_name: /* @__PURE__ */ k() }), n.json);
	},
	authorizeIceshrimp: async () => (await e.request("/api/v1/accounts/authorize_iceshrimp", { method: "POST" })).json
});
//#endregion
//#region ../../node_modules/.pnpm/isows@1.0.7_ws@8.22.0/node_modules/isows/_esm/utils.js
function js() {
	if (typeof WebSocket < "u") return WebSocket;
	if (global.WebSocket !== void 0) return global.WebSocket;
	if (window.WebSocket !== void 0) return window.WebSocket;
	if (self.WebSocket !== void 0) return self.WebSocket;
	throw Error("`WebSocket` is not supported in this environment");
}
//#endregion
//#region ../../node_modules/.pnpm/isows@1.0.7_ws@8.22.0/node_modules/isows/_esm/native.js
var Ms = js(), Ns = (e) => ({ connect: (t, { onMessage: n, onMessages: r }) => {
	let i = 2, a;
	if (e.shoutSocket) return e.shoutSocket;
	let o = new Ms(Bn("/socket/websocket", e.baseURL, {
		token: t,
		vsn: "2.0.0"
	}));
	return o.onmessage = (e) => {
		let [t, i, a, o, s] = JSON.parse(e.data);
		o === "new_msg" ? n(j(fo, s)) : o === "messages" && r(j(F(fo), s.messages));
	}, o.onopen = () => {
		o.send(JSON.stringify([
			"3",
			`${++i}`,
			"chat:public",
			"phx_join",
			{}
		])), a = setInterval(() => {
			o.send(JSON.stringify([
				null,
				`${++i}`,
				"phoenix",
				"heartbeat",
				{}
			]));
		}, 5e3);
	}, o.onclose = () => {
		clearInterval(a);
	}, e.shoutSocket = {
		message: (e) => {
			o.send(JSON.stringify([
				"3",
				`${++i}`,
				"chat:public",
				"new_msg",
				{ text: e }
			]));
		},
		close: () => {
			o.close(), e.shoutSocket = void 0, clearInterval(a);
		}
	}, e.shoutSocket;
} }), Ps = (e) => {
	let t = {
		createStatus: async (t) => {
			let n = t;
			t.content_type === "text/markdown" && e.instanceInformation.api_versions["kmyblue_markdown.fedibird.pl-api"] >= 1 && (n.markdown = !0), t.visibility?.startsWith("api/v1/bookmark_categories") && (n.circle_id = t.visibility.slice(7), n.visibility = "circle"), t.quote_id && e.instanceInformation.api_versions.mastodon >= 7 ? t.quoted_status_id = t.quote_id : t.quoted_status_id && (e.instanceInformation.api_versions.mastodon || 0) < 7 && (t.quote_id = t.quoted_status_id);
			let r = t.preview && e.features.version.software === "Mitra" ? "/api/v1/statuses/preview" : "/api/v1/statuses", i = await e.request(r, {
				method: "POST",
				body: n
			});
			return i.json?.scheduled_at ? j(co, i.json) : j($, i.json);
		},
		previewStatus: async (t) => {
			let n = e.features.version.software === "Pleroma" || e.features.version.software === "Akkoma" ? "/api/v1/statuses" : "/api/v1/statuses/preview";
			(e.features.version.software === "Pleroma" || e.features.version.software === "Akkoma") && (t.preview = !0);
			let r = await e.request(n, {
				method: "POST",
				body: t
			});
			return j(/* @__PURE__ */ Pe(Ti), r.json);
		},
		getStatus: async (t, n) => j($, (await e.request(`/api/v1/statuses/${t}`, { params: n })).json),
		getStatuses: async (t, n) => {
			let r = await e.request("/api/v1/statuses", { params: {
				...n,
				id: t
			} });
			return j(F($), r.json);
		},
		deleteStatus: async (t, n) => j(mo, (await e.request(`/api/v1/statuses/${t}`, {
			method: "DELETE",
			params: { delete_media: n }
		})).json),
		getContext: async (t, n) => {
			let r = await e.request(`/api/v1/statuses/${t}/context`, { params: n });
			return {
				asyncRefreshHeader: Wn(r),
				...j(Bi, r.json)
			};
		},
		translateStatus: async (t, n) => {
			let r;
			return r = e.features.version.software === "Akkoma" ? await e.request(`/api/v1/statuses/${t}/translations/${n}`) : await e.request(`/api/v1/statuses/${t}/translate`, {
				method: "POST",
				body: { lang: n }
			}), j(yi, r.json);
		},
		translateStatuses: async (t, n) => {
			let r = await e.request("/api/v1/pl/statuses/translate", {
				method: "POST",
				body: {
					ids: t,
					lang: n
				}
			});
			return j(F(yi), r.json);
		},
		getRebloggedBy: (t, n) => e.paginatedGet(`/api/v1/statuses/${t}/reblogged_by`, { params: n }, L),
		getFavouritedBy: (t, n) => e.paginatedGet(`/api/v1/statuses/${t}/favourited_by`, { params: n }, L),
		favouriteStatus: async (t) => j($, (await e.request(`/api/v1/statuses/${t}/favourite`, { method: "POST" })).json),
		unfavouriteStatus: async (t) => j($, (await e.request(`/api/v1/statuses/${t}/unfavourite`, { method: "POST" })).json),
		reblogStatus: async (t, n, r) => {
			let i = await e.request(`/api/v1/statuses/${t}/reblog`, {
				method: "POST",
				body: {
					visibility: n,
					scheduled_at: r
				}
			});
			return i.json?.scheduled_at ? j(co, i.json) : j($, i.json);
		},
		unreblogStatus: async (t) => j($, (await e.request(`/api/v1/statuses/${t}/unreblog`, { method: "POST" })).json),
		bookmarkStatus: async (n, r) => !r || !e.features.bookmarkFoldersMultiple ? j($, (await e.request(`/api/v1/statuses/${n}/bookmark`, {
			method: "POST",
			body: { folder_id: r }
		})).json) : (await e.request(`/api/v1/bookmark_categories/${r}/statuses`, {
			method: "POST",
			params: { status_ids: [n] }
		}), t.getStatus(n)),
		unbookmarkStatus: async (n) => (await e.request(`/api/v1/statuses/${n}/unbookmark`, { method: "POST" }), t.getStatus(n)),
		revokeQuote: async (t, n) => j($, (await e.request(`/api/v1/statuses/${t}/quotes/${n}/revoke`, { method: "POST" })).json),
		muteStatus: async (t) => j($, (await e.request(`/api/v1/statuses/${t}/mute`, { method: "POST" })).json),
		unmuteStatus: async (t) => j($, (await e.request(`/api/v1/statuses/${t}/unmute`, { method: "POST" })).json),
		pinStatus: async (t) => j($, (await e.request(`/api/v1/statuses/${t}/pin`, { method: "POST" })).json),
		unpinStatus: async (t) => j($, (await e.request(`/api/v1/statuses/${t}/unpin`, { method: "POST" })).json),
		editStatus: async (t, n) => {
			let r = n;
			return n.content_type === "text/markdown" && e.instanceInformation.api_versions["kmyblue_markdown.fedibird.pl-api"] >= 1 && (r.markdown = !0), j($, (await e.request(`/api/v1/statuses/${t}`, {
				method: "PUT",
				body: r
			})).json);
		},
		editInteractionPolicy: async (t, n) => j($, (await e.request(`/api/v1/statuses/${t}`, {
			method: "PUT",
			body: n
		})).json),
		getStatusHistory: async (t) => {
			let n = await e.request(`/api/v1/statuses/${t}/history`);
			return j(F(po), n.json);
		},
		getStatusSource: async (t) => j(mo, (await e.request(`/api/v1/statuses/${t}/source`)).json),
		getStatusReactions: async (t, n) => {
			let r = e.instanceInformation.api_versions, i;
			return r["emoji_reactions.pleroma.pl-api"] >= 1 || e.features.version.software === "Iceshrimp.NET" ? i = await e.request(`/api/v1/pleroma/statuses/${t}/reactions${n ? `/${n}` : ""}`) : (i = r["emoji_reaction.fedibird.pl-api"] >= 1 ? await e.request(`/api/v1/statuses/${t}/emoji_reactioned_by`) : await e.request(`/api/v1/statuses/${t}/reactions`, { params: { emoji: n } }), i.json = i.json?.reduce((e, t) => {
				if (n && t.name !== n) return e;
				let r = e.find((e) => e.name === t.name);
				return r ? (r.accounts.push(t.account), r.account_ids.push(t.account.id), r.count += 1) : e.push({
					count: 1,
					accounts: [t.account],
					account_ids: [t.account.id],
					...t
				}), e;
			}, [])), j(F(Fr), i?.json || []);
		},
		createStatusReaction: async (t, n) => {
			let r = e.instanceInformation.api_versions, i;
			return i = r["emoji_reactions.pleroma.pl-api"] >= 1 || e.features.version.software === "Mitra" ? await e.request(`/api/v1/pleroma/statuses/${t}/reactions/${encodeURIComponent(n)}`, { method: "PUT" }) : await e.request(`/api/v1/statuses/${t}/react/${encodeURIComponent(n)}`, { method: "POST" }), j($, i.json);
		},
		deleteStatusReaction: async (t, n) => {
			let r = e.instanceInformation.api_versions, i;
			return i = r["emoji_reactions.pleroma.pl-api"] >= 1 || e.features.version.software === "Mitra" ? await e.request(`/api/v1/pleroma/statuses/${t}/reactions/${n}`, { method: "DELETE" }) : await e.request(`/api/v1/statuses/${t}/unreact/${encodeURIComponent(n)}`, { method: "POST" }), j($, i.json);
		},
		getStatusQuotes: (t, n) => e.paginatedGet(e.instanceInformation.api_versions.mastodon >= 7 ? `/api/v1/statuses/${t}/quotes` : `/api/v1/pleroma/statuses/${t}/quotes`, { params: n }, $),
		getDislikedBy: (t) => e.paginatedGet(`/api/v1/statuses/${t}/disliked_by`, {}, L),
		dislikeStatus: async (t) => j($, (await e.request(`/api/friendica/statuses/${t}/dislike`, { method: "POST" })).json),
		undislikeStatus: async (t) => j($, (await e.request(`/api/friendica/statuses/${t}/undislike`, { method: "POST" })).json),
		getStatusReferences: (t, n) => e.paginatedGet(`/api/v1/statuses/${t}/referred_by`, { params: n }, $),
		getStatusMentionedUsers: (t, n) => e.paginatedGet(`/api/v1/statuses/${t}/mentioned_by`, { params: n }, L),
		loadConversation: async (t) => (await e.request(`/api/v1/statuses/${t}/load_conversation`, { method: "POST" })).json,
		getStatusBookmarkFolders: async (t) => {
			let n = await e.request(`/api/v1/statuses/${t}/bookmark_categories`, { method: "GET" });
			return j(F(Ii), n.json);
		},
		biteStatus: async (t) => (await e.getIceshrimpAccessToken(), (await e.request(`/api/iceshrimp/notes/${t}/bite`, { method: "POST" })).json)
	};
	return t;
}, Fs = (e) => ({
	getRecentStories: async () => {
		let t = await e.request("/api/web/stories/v1/recent");
		return j(F(ho), t.json);
	},
	getStoryViewers: async (t) => {
		let n = await e.request("/api/web/stories/v1/viewers", { params: { sid: t } });
		return j(F(L), n.json);
	},
	getStoriesForProfile: async (t) => {
		let n = await e.request(`/api/web/stories/v1/profile/${t}`);
		return j(F(vo), n.json);
	},
	storyExists: async (t) => {
		let n = await e.request(`/api/web/stories/v1/exists/${t}`);
		return j(/* @__PURE__ */ x(), n.json);
	},
	getStoryPollResults: async (t) => {
		let n = await e.request("/api/web/stories/v1/poll/results", { params: { sid: t } });
		return j(/* @__PURE__ */ b(/* @__PURE__ */ w()), n.json);
	},
	markStoryAsViewed: async (t) => (await e.request("/api/web/stories/v1/viewed", {
		method: "POST",
		body: { id: t }
	})).json,
	createStoryReaction: async (t, n) => (await e.request("/api/web/stories/v1/react", {
		method: "POST",
		body: {
			sid: t,
			reaction: n
		}
	})).json,
	createStoryComment: async (t, n) => (await e.request("/api/web/stories/v1/comment", {
		method: "POST",
		body: {
			sid: t,
			caption: n
		}
	})).json,
	createStoryPoll: async (t) => (await e.request("/api/web/stories/v1/publish/poll", {
		method: "POST",
		body: t
	})).json,
	storyPollVote: async (t, n) => (await e.request("/api/web/stories/v1/publish/poll", {
		method: "POST",
		body: {
			sid: t,
			ci: n
		}
	})).json,
	reportStory: async (t, n) => (await e.request("/api/web/stories/v1/report", {
		method: "POST",
		body: {
			id: t,
			type: n
		}
	})).json,
	addMedia: async (t) => j(go, (await e.request("/api/web/stories/v1/add", {
		method: "POST",
		body: { file: t },
		formData: !0
	})).json),
	cropPhoto: async (t, n) => (await e.request("/api/web/stories/v1/crop", {
		method: "POST",
		body: {
			media_id: t,
			...n
		}
	})).json,
	createStory: async (t, n) => (await e.request("/api/web/stories/v1/publish", {
		method: "POST",
		body: {
			media_id: t,
			...n
		}
	})).json,
	deleteStory: async (t) => (await e.request(`/api/web/stories/v1/delete/${t}`, { method: "DELETE" })).json
}), Is = "ÀÁÂÃÄÅàáâãäåĀāĂăĄąÇçĆćĈĉĊċČčÐðĎďĐđÈÉÊËèéêëĒēĔĕĖėĘęĚěĜĝĞğĠġĢģĤĥĦħÌÍÎÏìíîïĨĩĪīĬĭĮįİıĴĵĶķĸĹĺĻļĽľĿŀŁłÑñŃńŅņŇňŉŊŋÒÓÔÕÖØòóôõöøŌōŎŏŐőŔŕŖŗŘřŚśŜŝŞşŠšſŢţŤťŦŧÙÚÛÜùúûüŨũŪūŬŭŮůŰűŲųŴŵÝýÿŶŷŸŹźŻżŽž", Ls = "AAAAAAaaaaaaAaAaAaCcCcCcCcCcDdDdDdEEEEeeeeEeEeEeEeEeGgGgGgGgHhHhIIIIiiiiIiIiIiIiIiJjKkkLlLlLlLlLlNnNnNnNnnNnOOOOOOooooooOoOoOoRrRrRrSsSsSsSssTtTtTtUUUUuuuuUuUuUuUuUuUuWwYyyYyYZzZzZz", Rs = (e, t) => t === "Akkoma" ? e.toLowerCase().trim() : t === "Mastodon" ? e.normalize("NFKC").toLowerCase().replace(/[ÀÁÂÃÄÅàáâãäåĀāĂăĄąÇçĆćĈĉĊċČčÐðĎďĐđÈÉÊËèéêëĒēĔĕĖėĘęĚěĜĝĞğĠġĢģĤĥĦħÌÍÎÏìíîïĨĩĪīĬĭĮįİıĴĵĶķĸĹĺĻļĽľĿŀŁłÑñŃńŅņŇňŉŊŋÒÓÔÕÖØòóôõöøŌōŎŏŐőŔŕŖŗŘřŚśŜŝŞşŠšſŢţŤťŦŧÙÚÛÜùúûüŨũŪūŬŭŮůŰűŲųŴŵÝýÿŶŷŸŹźŻżŽž]/gu, (e) => Ls[Is.indexOf(e)]).replace(/[^\p{L}\p{N}_\u00b7\u200c]/gu, "") : e, zs = (e, t = {}, n = null) => {
	let r = e === "list" ? "list" : e === "hashtag" || e === "hashtag:local" ? "tag" : e === "group" ? "group" : e === "public:remote" || e === "public:remote:media" ? "instance" : void 0, i = r ? t[r] : void 0;
	n === "Akkoma" && r === "list" && typeof i == "string" && i.length < 32 && /^\+?\d+$/u.test(i) && (i = i.replace(/^\+/u, "").replace(/^0+(?=\d)/u, ""));
	let a = r === "tag" && typeof i == "string" ? Rs(i, n) : i, o = a === void 0 ? [e] : [e, a];
	return {
		key: JSON.stringify(o),
		identity: o,
		stream: e,
		params: r && i !== void 0 ? { [r]: r === "tag" && n === "Akkoma" ? a : i } : {},
		owners: /* @__PURE__ */ new Set(),
		legacy: !1,
		error: void 0
	};
}, Bs = (e) => {
	let t = (t, n) => zs(t, n, e.features.version.software), n = /* @__PURE__ */ new Map(), r = [], i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), c, l = !1, u = !1, d = !1, ee = 0, f, p, m = (e, t) => {
		for (let n of [...e]) try {
			n(t);
		} catch {}
	}, te = () => m(i, void 0), h = (e) => {
		for (let t of n.values()) t.error = e;
		m(o, e), te();
	}, ne = (e) => {
		l !== e && (l = e, m(a, e), te());
	}, re = () => {
		clearTimeout(f), clearTimeout(p), f = p = void 0;
	}, ie = (t) => !u && e.socket === ue && c === t, ae = () => {
		if (u || d || f || n.size === 0) return;
		let e = Math.min(3e4, 1e3 * 2 ** Math.min(ee++, 5));
		f = setTimeout(() => {
			f = void 0, se();
		}, Math.round(e * (.8 + Math.random() * .4)));
	}, oe = (e, t) => {
		if (c && c.readyState === Ms.OPEN) try {
			c.send(JSON.stringify({
				type: e,
				stream: t.stream,
				...t.params
			}));
		} catch {
			let e = c;
			c = void 0, clearTimeout(p), ne(!1), e.close(), m(s, void 0), ae();
		}
	}, se = () => {
		if (u || d || c || f) return;
		let i;
		try {
			i = new Ms(Bn("/api/v1/streaming", e.instanceInformation.configuration.urls.streaming, { access_token: e.accessToken }), e.accessToken);
		} catch {
			h({ error: "Unable to open streaming connection" }), ae();
			return;
		}
		c = i, i.onopen = () => {
			if (ie(i) && !l) {
				for (let e of n.values()) e.error = void 0;
				for (let e of n.values()) {
					if (!ie(i)) break;
					oe("subscribe", e);
				}
				ie(i) && (ne(!0), ie(i) && (p = setTimeout(() => ee = 0, 3e4)));
			}
		}, i.onmessage = (e) => {
			if (ie(i) && l) try {
				let i = JSON.parse(e.data);
				if (typeof i?.error == "string") {
					let e = typeof i.status == "number" ? i.status : void 0;
					h({
						error: i.error,
						status: e
					});
					return;
				}
				let a = /* @__PURE__ */ Fe(Fo, i);
				if (!a.success) {
					h({ error: "Invalid streaming event" });
					return;
				}
				let o = a.output, [s, c] = o.stream, l = t(s, {
					list: c,
					tag: c,
					group: c,
					instance: c
				}).identity, u = n.get(JSON.stringify(l));
				u?.error && (u.error = void 0, te());
				let d = r.filter(({ stream: e, identity: t }) => (!e || o.stream[0] === e) && (!t || t.every((e, t) => l[t] === e)));
				m(d.map(({ listener: e }) => e), o);
			} catch {
				h({ error: "Invalid streaming event" });
			}
		}, i.onclose = (e) => {
			ie(i) && (c = void 0, clearTimeout(p), ne(!1), ([
				1002,
				1003,
				1007,
				1008,
				1010
			].includes(e.code) || e.code >= 4e3) && (d = !0), m(s, e), ae());
		}, i.onerror = () => {
			ie(i) && h({ error: "Streaming transport error" });
		};
	}, ce = (e, r) => {
		let i = t(e, r), a = n.get(i.key);
		return a || (a = i, n.set(a.key, a), oe("subscribe", a), te()), se(), a;
	}, le = (e) => {
		u || n.get(e.key) !== e || e.owners.size || e.legacy || (n.delete(e.key), te(), oe("unsubscribe", e), n.size === 0 && ue.close());
	}, ue = {
		get connected() {
			return l;
		},
		canUseUpdates: (e, r) => {
			let i = n.get(t(e, r).key);
			return l && !!i && !i.error;
		},
		getError: (e, r) => n.get(t(e, r).key)?.error,
		onAvailabilityChange: (e) => u ? () => {} : (i.add(e), e(), () => {
			i.delete(e);
		}),
		acquire: (e, t) => {
			if (u) return () => {};
			let n = ce(e, t), r = Symbol();
			return n.owners.add(r), () => {
				n.owners.delete(r), le(n);
			};
		},
		listen: (e, n, i) => u ? 0 : r.push({
			listener: e,
			stream: n,
			identity: n && i ? t(n, i).identity : void 0
		}),
		unlisten: (e) => {
			r = r.filter((t) => t.listener !== e);
		},
		subscribe: (e, t) => {
			u || (ce(e, t).legacy = !0);
		},
		unsubscribe: (e, r) => {
			let i = n.get(t(e, r).key);
			i && (i.legacy = !1, le(i));
		},
		onStateChange: (e) => u ? () => {} : (a.add(e), e(l), () => {
			a.delete(e);
		}),
		onError: (e) => (u || o.add(e), () => {
			o.delete(e);
		}),
		onDisconnect: (e) => (u || s.add(e), () => {
			s.delete(e);
		}),
		close: () => {
			if (u) return;
			u = !0, re();
			let t = c;
			c = void 0, e.socket === ue && (e.socket = void 0), ne(!1), m(s, void 0), n.clear(), r = [], i.clear(), a.clear(), o.clear(), s.clear(), t?.close();
		}
	};
	return e.socket = ue, se(), ue;
}, Vs = /* @__PURE__ */ new WeakMap(), Hs = (e) => ({
	health: async () => {
		let t = await e.request("/api/v1/streaming/health");
		return j(/* @__PURE__ */ S("OK"), t.json);
	},
	getIdentity: (t, n) => zs(t, n, e.features.version.software).identity,
	connect: () => {
		let t = JSON.stringify([
			e.baseURL,
			e.accessToken,
			e.features.version.software,
			e.instanceInformation.configuration.urls.streaming
		]);
		e.socket && Vs.get(e.socket) !== t && e.socket.close();
		let n = e.socket ?? Bs(e);
		return Vs.set(n, t), n;
	}
}), Us = (e) => ({
	createSubscription: async (t, n) => j(Io, (await e.request("/api/v1/subscriptions", {
		method: "POST",
		body: {
			subscriber_id: t,
			duration: n
		}
	})).json),
	getSubscriptionOptions: async () => {
		let t = await e.request("/api/v1/subscriptions/options");
		return j(F(Ro), t.json);
	},
	updateSubscription: async (t, n, r, i) => j(L, (await e.request("/api/v1/subscriptions/options", {
		method: "POST",
		body: {
			type: t,
			chain_id: n,
			price: r,
			payout_address: i
		}
	})).json),
	findSubscription: async (t, n) => j(Io, (await e.request("/api/v1/subscriptions/find", { params: {
		sender_id: t,
		recipient_id: n
	} })).json),
	createInvoice: async (t, n, r, i) => j(Lo, (await e.request("/api/v1/subscriptions/invoices", {
		method: "POST",
		body: {
			sender_id: t,
			recipient_id: n,
			chain_id: r,
			amount: i
		}
	})).json),
	getInvoice: async (t) => j(Lo, (await e.request(`/api/v1/subscriptions/invoices/${t}`)).json),
	cancelInvoice: async (t) => j(Lo, (await e.request(`/api/v1/subscriptions/invoices/${t}`, { method: "DELETE" })).json)
}), Ws = (e) => ({
	publicTimeline: (t) => t?.instance && e.features.version.software === "Iceshrimp.NET" ? bs(e, `/api/iceshrimp/timelines/remote/${t.instance}`, t, (e) => e.map(({ id: e }) => e)) : e.paginatedGet("/api/v1/timelines/public", { params: t }, $),
	hashtagTimeline: (t, n) => e.paginatedGet(`/api/v1/timelines/tag/${t}`, { params: n }, $),
	homeTimeline: (t) => e.paginatedGet("/api/v1/timelines/home", { params: t }, $),
	linkTimeline: (t, n) => e.paginatedGet("/api/v1/timelines/link", { params: {
		...n,
		url: t
	} }, $),
	listTimeline: (t, n) => e.paginatedGet(`/api/v1/timelines/list/${t}`, { params: n }, $),
	getConversations: (t) => e.paginatedGet("/api/v1/conversations", { params: t }, Vi),
	deleteConversation: async (t) => (await e.request(`/api/v1/conversations/${t}`, { method: "DELETE" })).json,
	markConversationRead: async (t) => j(Vi, (await e.request(`/api/v1/conversations/${t}/read`, { method: "POST" })).json),
	getMarkers: async (t) => j(Ba, (await e.request("/api/v1/markers", { params: { timeline: t } })).json),
	saveMarkers: async (t) => j(Ba, (await e.request("/api/v1/markers", {
		method: "POST",
		body: t
	})).json),
	groupTimeline: (t, n) => e.paginatedGet(e.features.version.software === "Pixelfed" ? `/api/v0/groups/${t}/feed` : `/api/v1/timelines/group/${t}`, { params: n }, $),
	bubbleTimeline: (t) => e.paginatedGet("/api/v1/timelines/bubble", { params: t }, $),
	antennaTimeline: (t, n) => e.paginatedGet(`/api/v1/timelines/antenna/${t}`, { params: n }, $),
	wrenchedTimeline: (t) => e.paginatedGet("/api/v1/pleroma/timelines/wrenched", { params: t }, $)
}), Gs = (e) => ({
	getTrendingTags: async (t) => {
		let n = await e.request(e.features.version.software === "Pixelfed" ? "/api/v1.1/discover/posts/hashtags" : "/api/v1/trends/tags", { params: t });
		return j(F(nr), n.json);
	},
	getTrendingStatuses: async (t) => {
		let n = await e.request(e.features.version.software === "Pixelfed" ? "/api/pixelfed/v2/discover/posts/trending" : "/api/v1/trends/statuses", { params: t });
		return j(F($), n.json);
	},
	getTrendingLinks: async (t) => {
		let n = await e.request("/api/v1/trends/links", { params: t });
		return j(F(Ho), n.json);
	}
}), Ks = (e) => ({ paginatedGet: e.paginatedGet.bind(e) }), qs = class extends Jn {
	accounts = Go(this);
	admin = Xo(this);
	announcements = Zo(this);
	antennas = Qo(this);
	apps = $o(this);
	asyncRefreshes = es(this);
	chats = ts(this);
	circles = ns(this);
	collections = rs(this);
	drive = is(this);
	emails = as(this);
	events = os(this);
	experimental = ss(this);
	filtering = cs(this);
	gifs = ls(this);
	groupedNotifications = fs(this);
	instance = ps(this);
	interactionRequests = ms(this);
	lists = hs(this);
	media = gs(this);
	myAccount = xs(this);
	notifications = Ss(this);
	oauth = Cs(this);
	oembed = ws(this);
	polls = Ts(this);
	pushNotifications = Es(this);
	rssFeedSubscriptions = Ds(this);
	scheduledStatuses = Os(this);
	search = ks(this);
	settings = As(this);
	shoutbox = Ns(this);
	statuses = Ps(this);
	stories = Fs(this);
	streaming = Hs(this);
	subscriptions = Us(this);
	timelines = Ws(this);
	trends = Gs(this);
	utils = Ks(this);
	#e;
	constructor(e, t, { fetchInstance: n, fetchInstanceSignal: r, onInstanceFetchSuccess: i, onInstanceFetchError: a, iceshrimpAccessToken: o, onFetchIceshrimpAccessToken: s, ...c } = {}) {
		super(e, t, c), n && this.instance.getInstance().then((e) => {
			if (!r?.aborted) return i?.(e);
		}).catch((e) => {
			r?.aborted || a?.(e);
		}), o && this.setIceshrimpAccessToken(o), s && (this.#e = s);
	}
	getIceshrimpAccessToken = async () => {
		if (!this.iceshrimpAccessToken && this.features.version.software === "Iceshrimp.NET") {
			let e = await this.settings.authorizeIceshrimp();
			this.setIceshrimpAccessToken(e), this.#e?.(e);
		}
	};
}, Js = class {
	accessToken = void 0;
	iceshrimpAccessToken = void 0;
	customAuthorizationToken = void 0;
	baseURL;
	request = Kn.bind(this);
	constructor(e) {
		this.baseURL = e;
	}
	async getStatistics() {
		let e = await this.request("/statistics");
		return j(F(Gi), e.json);
	}
	async getCategories(e) {
		let t = await this.request("/categories", { params: e });
		return j(F(Hi), t.json);
	}
	async getLanguages(e) {
		let t = await this.request("/languages", { params: e });
		return j(F(Ui), t.json);
	}
	async getServers(e) {
		let t = await this.request("/servers", { params: e });
		return j(F(Wi), t.json);
	}
};
//#endregion
export { Z as AKKOMA, It as EGREGOROS, B as FIREFISH, Lt as FRIENDICA, Wt as GLITCH, V as GOTOSOCIAL, Vr as GroupRoles, H as HOLLO, Gt as HOMETOWN, U as ICESHRIMP, W as ICESHRIMP_NET, G as MASTODON, K as MITRA, q as NEODB, J as PIXELFED, Y as PLEROMA, qn as PaginatedResponse, Jn as PlApiBaseClient, qs as PlApiClient, Js as PlApiDirectoryClient, X as SHARKEY, Rt as SNAC, zt as TAKAHE, Bt as TINYAP, Vt as TOKI, Kt as UNRELEASED, Ht as WAFRN, Ut as WORDPRESS, L as accountSchema, Yn as accountWarningSchema, Go as accountsCategory, Zn as adminAccountSchema, Qn as adminActionResponseSchema, ir as adminAnnouncementSchema, ar as adminCanonicalEmailBlockSchema, Xo as adminCategory, or as adminCohortSchema, cr as adminCustomEmojiCategorySchema, sr as adminCustomEmojiSchema, lr as adminDimensionSchema, dr as adminDomainAllowSchema, fr as adminDomainBlockSchema, pr as adminDomainLimitSchema, mr as adminDomainPermissionSchema, hr as adminDomainPermissionSubscriptionSchema, ur as adminDomainSchema, gr as adminEmailDomainBlockSchema, _r as adminHeaderFilterSchema, vr as adminInstanceDeliveryErrorSchema, yr as adminInstanceSchema, br as adminInviteSchema, xr as adminIpBlockSchema, Xn as adminIpSchema, Sr as adminMeasureSchema, Cr as adminModerationLogEntrySchema, Dr as adminRelayMatcherSchema, Or as adminRelaySchema, Ei as adminReportSchema, Di as adminRuleSchema, Oi as adminTagSchema, Aa as albumSchema, $n as announcementReactionSchema, rr as announcementSchema, Zo as announcementsCategory, Ai as antennaSchema, Qo as antennasCategory, ji as applicationSchema, $o as appsCategory, Ni as asyncRefreshSchema, es as asyncRefreshesCategory, Pi as authorizationServerMetadataSchema, Fi as backupSchema, Rr as baseFilterSchema, rt as blockedAccountSchema, ei as blurhashSchema, Ii as bookmarkFolderSchema, Li as chatMessageSchema, Ri as chatSchema, ts as chatsCategory, zi as circleSchema, ns as circlesCategory, Ar as collectionItemSchema, jr as collectionSchema, Mr as collectionWithAccountsSchema, rs as collectionsCategory, Bi as contextSchema, Vi as conversationSchema, nt as credentialAccountSchema, Mi as credentialApplicationSchema, We as customEmojiSchema, Hi as directoryCategorySchema, Ui as directoryLanguageSchema, Wi as directoryServerSchema, Gi as directoryStatisticsPeriodSchema, Ki as domainBlockSchema, is as driveCategory, qi as driveFileSchema, Xi as driveFolderSchema, Zi as driveStatusSchema, Ea as editionSchema, as as emailsCategory, Fr as emojiReactionSchema, os as eventsCategory, ss as experimentalCategory, Qi as extendedDescriptionSchema, $i as familiarFollowersSchema, et as featureApprovalSchema, ea as featuredTagSchema, Ir as filterKeywordSchema, Br as filterResultSchema, zr as filterSchema, Lr as filterStatusSchema, cs as filteringCategory, yo as followRelationshipUpdateSchema, Ma as gameSchema, qt as getFeatures, ta as gifResultSchema, na as gifResultsSchema, Hr as groupMemberSchema, Ur as groupRelationshipSchema, Wr as groupSchema, fs as groupedNotificationsCategory, Ca as groupedNotificationsResultsSchema, tr as historySchema, ps as instanceCategory, xt as instanceSchema, Jr as interactionPoliciesSchema, qr as interactionPolicySchema, wa as interactionRequestSchema, ms as interactionRequestsCategory, La as itemSchema, ki as listSchema, hs as listsCategory, Ra as locationSchema, za as markerSchema, Ba as markersSchema, ci as mediaAttachmentSchema, gs as mediaCategory, er as mentionSchema, ka as movieSchema, it as mutedAccountSchema, xs as myAccountCategory, Sa as notificationGroupSchema, ro as notificationPolicySchema, io as notificationRequestSchema, to as notificationSchema, Ss as notificationsCategory, Cs as oauthCategory, ao as oauthTokenSchema, ws as oembedCategory, Ti as partialStatusSchema, Na as performanceSchema, Tr as pleromaConfigDescriptionChildSchema, Er as pleromaConfigDescriptionSchema, wr as pleromaConfigSchema, Pa as podcastEpisodeSchema, ja as podcastSchema, ui as pollSchema, Ts as pollsCategory, di as previewCardAuthorSchema, pi as previewCardSchema, oo as privacyPolicySchema, Es as pushNotificationsCategory, _i as quoteApprovalSchema, hi as quoteSchema, N as relationshipSchema, oa as relationshipSeveranceEventSchema, sa as reportSchema, so as reviewSchema, Ge as roleSchema, vi as rssFeedSchema, Ds as rssFeedSubscriptionsCategory, at as ruleSchema, co as scheduledStatusSchema, Os as scheduledStatusesCategory, lo as scrobbleSchema, ks as searchCategory, uo as searchSchema, As as settingsCategory, gi as shallowQuoteSchema, kr as shallowTagSchema, fo as shoutMessageSchema, Ns as shoutboxCategory, po as statusEditSchema, $ as statusSchema, mo as statusSourceSchema, wi as statusWithoutAccountSchema, Ps as statusesCategory, Fs as storiesCategory, ho as storyCarouselItemSchema, go as storyMediaSchema, _o as storyNodeSchema, vo as storyProfileSchema, Hs as streamingCategory, Fo as streamingEventSchema, Io as subscriptionDetailsSchema, Lo as subscriptionInvoiceSchema, Ro as subscriptionOptionSchema, Us as subscriptionsCategory, zo as suggestionSchema, nr as tagSchema, Bo as termsOfServiceSchema, Ws as timelinesCategory, Vo as tokenSchema, yi as translationSchema, Gs as trendsCategory, Ho as trendsLinkSchema, Oa as tvSeasonSchema, Da as tvShowSchema, Uo as userInfoSchema, Ks as utilsCategory, Wo as webPushSubscriptionSchema };

//# sourceMappingURL=main.es.js.map